// src/bullhorn/components/about/BullhornLogo.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var BullhornLogo = ({ width, height }) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 259 99",
    xmlns: "http://www.w3.org/2000/svg",
    className: "BullhornLogo_svg__site-header__logo",
    width: width ? width : "1em ",
    height: height ? height : "1em ",
    children: /* @__PURE__ */ jsxs("g", { fill: "none", fillRule: "evenodd", children: [
      /* @__PURE__ */ jsx("g", { className: "BullhornLogo_svg__bullhorn-svg-logo__text", children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 59.309a.84.84 0 01.839-.839h14.974c4.062 0 7.134 1.042 9.216 3.123 1.578 1.578 2.367 3.526 2.367 5.842v.101c0 1.041-.143 1.981-.428 2.82-.285.84-.655 1.57-1.108 2.19a8.15 8.15 0 01-1.586 1.637c-.161.126-.325.246-.491.362-.535.373-.481 1.181.113 1.454 1.392.64 2.567 1.444 3.525 2.414 1.292 1.31 1.939 3.156 1.939 5.54v.1c0 1.58-.311 2.972-.931 4.181a8.305 8.305 0 01-2.644 3.021c-1.142.806-2.51 1.42-4.105 1.838-1.595.42-3.383.63-5.363.63H.839a.839.839 0 01-.84-.839V59.309zm14.554 14.018c2.014 0 3.627-.392 4.835-1.177 1.208-.785 1.813-1.979 1.813-3.58v-.103c0-1.4-.53-2.495-1.586-3.28-1.058-.784-2.594-1.177-4.61-1.177H6.934a.838.838 0 00-.84.84v7.637c0 .464.376.84.84.84h7.62zm1.813 14.856c2.115 0 3.778-.4 4.986-1.202 1.209-.8 1.813-2.004 1.813-3.608v-.1c0-1.502-.597-2.663-1.788-3.482-1.192-.818-3.014-1.227-5.464-1.227H6.933a.839.839 0 00-.84.84v7.94c0 .464.376.84.84.84h9.434zM60.931 58.157h4.417c.518 0 .938.42.938.937v33.692c0 .517-.42.937-.938.937h-4.417a.937.937 0 01-.937-.937V59.094c0-.517.419-.937.937-.937m11.009 0h4.416c.518 0 .938.42.938.937v33.692c0 .517-.42.937-.938.937H71.94a.937.937 0 01-.937-.937V59.094c0-.517.42-.937.937-.937m10.07 0h3.034a3.153 3.153 0 013.152 3.152v9.966c.64-.711 1.573-1.404 2.8-2.08 1.225-.675 2.8-1.014 4.718-1.014 1.528 0 2.897.25 4.106.747 1.208.499 2.213 1.2 3.013 2.107.8.906 1.413 1.999 1.84 3.278.426 1.28.64 2.686.64 4.213v14.333a.863.863 0 01-.865.864h-4.564a.864.864 0 01-.864-.864v-14.28c0-1.6-.436-2.834-1.306-3.705-.87-.871-2-1.307-3.386-1.307a5.75 5.75 0 00-2.4.507 5.623 5.623 0 00-1.919 1.413 6.733 6.733 0 00-1.253 2.107 7.234 7.234 0 00-.454 2.584v12.68a.863.863 0 01-.863.865h-4.565a.864.864 0 01-.864-.864V58.156zm75.653 10.557h3.967a1.06 1.06 0 011.057 1l.103 1.827c.32-.355.702-.729 1.146-1.12a8.69 8.69 0 011.6-1.093 9.782 9.782 0 012.106-.827c.782-.213 1.671-.32 2.667-.32 3.127 0 5.51.933 7.145 2.8 1.634 1.866 2.453 4.381 2.453 7.545v14.078c0 .618-.5 1.12-1.119 1.12h-4.054a1.12 1.12 0 01-1.12-1.12V78.58c0-1.6-.435-2.835-1.306-3.706-.87-.87-1.999-1.306-3.386-1.306-.853 0-1.653.168-2.4.506a5.623 5.623 0 00-1.919 1.413 6.772 6.772 0 00-1.253 2.107 7.24 7.24 0 00-.453 2.586v12.425c0 .618-.5 1.12-1.119 1.12h-4.055a1.119 1.119 0 01-1.119-1.12v-22.83a1.06 1.06 0 011.06-1.06m29.156 2.272c0 .39-.096.753-.29 1.086a2.152 2.152 0 01-.794.794 2.132 2.132 0 01-1.082.293c-.386 0-.747-.098-1.082-.292a2.136 2.136 0 01-.797-.793 2.15 2.15 0 010-2.164c.194-.34.46-.605.795-.798.335-.193.697-.29 1.084-.29.386 0 .745.097 1.08.289.334.19.598.458.793.796.196.338.293.698.293 1.079zm-.297.004c0-.331-.083-.642-.252-.933a1.838 1.838 0 00-.683-.687 1.861 1.861 0 00-1.869 0 1.816 1.816 0 00-.688.687c-.168.29-.25.605-.25.939 0 .332.082.642.25.93.166.29.396.517.691.684a1.858 1.858 0 001.866-.001c.29-.168.518-.395.684-.684.168-.288.251-.598.251-.935zm-2.779-1.26h1.045c.245 0 .42.024.526.072a.594.594 0 01.264.239c.067.11.102.239.102.385a.732.732 0 01-.07.329.713.713 0 01-.24.22.496.496 0 01.227.194c.038.072.057.196.057.373v.28c0 .132.03.242.088.33l.041.066h-.442a1.862 1.862 0 01-.06-.365l-.02-.305a.547.547 0 00-.054-.236.254.254 0 00-.122-.1 1.048 1.048 0 00-.318-.03h-.63v1.036h-.394V69.73zm.393.36v.74h.62c.187 0 .314-.022.381-.064.1-.06.15-.164.15-.308 0-.127-.037-.22-.108-.28-.07-.057-.205-.087-.399-.087h-.644zm-45.934-1.451h3.933c.571 0 1.042.447 1.071 1.018l.108 2.128c.285-.355.65-.747 1.094-1.173a8.348 8.348 0 011.572-1.173 10.027 10.027 0 012.106-.906c.801-.249 1.715-.374 2.747-.374.604 0 1.146.036 1.626.107.205.03.412.07.62.12a.894.894 0 01.672 1.058l-.898 4.153a.892.892 0 01-1.088.673 5.634 5.634 0 00-.426-.086c-.444-.07-.968-.107-1.573-.107-.853 0-1.67.143-2.452.427a5.862 5.862 0 00-2.027 1.227 5.957 5.957 0 00-1.359 1.92c-.339.746-.507 1.581-.507 2.505v12.435c0 .583-.472 1.056-1.055 1.056h-4.182a1.056 1.056 0 01-1.055-1.056v-22.88c0-.593.481-1.072 1.073-1.072m-87.748.462a.972.972 0 00-.972.972v12.154c0 3.329-2.377 5.563-5.278 5.563h-1.157c-2.901 0-5.28-2.235-5.28-5.563V70.074a.97.97 0 00-.97-.971h-3.86a.971.971 0 00-.97.971v13.485c0 5.859 5.362 9.934 11.03 9.984v.001h.04l.067.001v-.001h1.042v.002l.08-.002h.124v-.003c5.63-.095 10.935-4.155 10.935-9.981V70.074a.972.972 0 00-.972-.972h-3.86zm57.413 12.196c0-1.813.329-3.527.987-5.146a13.117 13.117 0 012.745-4.239c1.175-1.208 2.588-2.169 4.24-2.88 1.653-.71 3.474-1.066 5.465-1.066 1.99 0 3.813.355 5.465 1.066 1.654.711 3.068 1.672 4.24 2.88a13.115 13.115 0 012.746 4.24c.657 1.618.988 3.332.988 5.145 0 1.812-.33 3.527-.988 5.146a13.428 13.428 0 01-2.745 4.265c-1.173 1.227-2.587 2.195-4.24 2.905-1.653.711-3.475 1.067-5.466 1.067-1.99 0-3.812-.356-5.466-1.067-1.651-.71-3.064-1.678-4.239-2.905a13.43 13.43 0 01-2.745-4.265 13.534 13.534 0 01-.987-5.146m13.438 7.944c1.207 0 2.257-.239 3.145-.719a6.73 6.73 0 002.214-1.893 8.305 8.305 0 001.305-2.56 9.36 9.36 0 00.428-2.772c0-.889-.142-1.805-.427-2.747a7.964 7.964 0 00-1.306-2.56 6.884 6.884 0 00-2.214-1.866c-.888-.479-1.938-.72-3.145-.72-1.21 0-2.258.241-3.147.72a6.884 6.884 0 00-2.213 1.866 7.964 7.964 0 00-1.305 2.56 9.431 9.431 0 00-.428 2.747c0 .924.142 1.848.428 2.772.283.925.72 1.778 1.305 2.56a6.73 6.73 0 002.213 1.893c.888.48 1.938.72 3.146.72",
          fill: "#202945"
        }
      ) }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M223.755 86.38c.937 1.132 2.197 1.966 3.139 3.133 1.255 1.553 3.26 6.09 3.276 6.507-.002 1.035-.834.977-1.65 1.446-.39.144-.617.551-.995-.083a.647.647 0 00-.674-.085c-.233.102-.213.457-.184.81.017.221-.118.434-.313.495-.68.212-1.391.262-2.158.034-.604-.18-1.037-.199-1.215-1.145l-.023-.08c-1.085-2.92 1.14-1.227-3.151-8.869l-.156-.39c-.36-1.34-1.12-2.548-2.336-3.285a4.057 4.057 0 01-1.666-1.96c-.77-1.883-2.105-3.059-3.833-3.75-1.131-.45-2.285-.853-3.415-1.328-2.568-1.076-5.608-3.026-7.83-6.39-.094-.146-.21-.29-.297-.46-.186-.368-1.79-2.293-1.422-2.162 3.369 1.407 11.175 2.783 15.632 3.268.664.072 1.266.485 1.508 1.107.035.09.369.658.432.754 1.36 2.137 1.44 2.47 1.997 3.231.885 1.213 2.096 2.333 2.303 3.861.323 2.385 1.772 3.82 3.03 5.341m34.543-28.859c-.071-.096-.284-.217-.267-.46.059-.812-.351-.562-.655-.36-1.048.7-2.418.95-2.75 2.696-.075.387-.441.528-.728.7-2.723 1.614-5.724-.309-6.457-4.232-.381-2.033-.884-4.02-1.695-5.875-.437-1-1.717-2.329-2.343-3.375a1.177 1.177 0 01-.17-.57c-.031-1.078-.49-3.554-3.418-5.259l-.065-.04c-3.591-2.612-11.318-5.305-15.464-6.56-1.582-.439-2.006.58-2.045 1.222-.007.123.01.244.043.363.08.29.254.88.256.898.982 3.747 2.245 8.94 1.52 8.736-.774-.215-2.693-11.056-7.222-14.175l-.086-.069c-2.955-2.733-9.092-4.017-11.161-4.45a1.137 1.137 0 01-.678-.426c-1.217-1.619-3.12-2.113-6.074-2.594a79.306 79.306 0 00-3.178-.46 1.183 1.183 0 01-.983-1.54l.004-.012c.095-.296.096-.893-.096-.97-.221-.088-.913.221-1.497.286-.39.043-.84-.208-.861-.22-.143-.084.203.21.053.07-1.706-1.618 2.548-3.11 1.61-3.175a20.029 20.029 0 00-.965-.038 21.801 21.801 0 00-3.491.208c-.265.037-.433-.213-.41-.438a.334.334 0 01.175-.27c5.596-3.04 7.698-6.515 7.698-6.515s1.703-2.765-2.25-4.594c-.754-.349-1.713-.665-2.933-.924-3.42-.725-6.491-1.849-8.86-2.88a49.858 49.858 0 01-2.224-1.035c-.025-.012-.183-.09-.313-.128-.37-.14-.693-.03-.884.432-.314.764.739 1.156 1.29 1.583 2.349 1.821 5.013 2.984 7.444 4.561 1.533.994 1.577 1.434.172 2.4-2.04 1.402-4.346 2.277-6.667 3.15a1.101 1.101 0 01-.365.07c-1.224-.809-2.454-.97-3.587-.76-2.035.083-3.94 1.22-4.976 3.131a1.15 1.15 0 01-1.102.592 2.357 2.357 0 00-.252-.008 1.839 1.839 0 00-.45-.019c-5.007.385-6.004 2.441-6.2 3.32a.802.802 0 01-.457.576c-10.771 4.543-18.357 1.138-20.898-.358l-.056-.033c-.326-.194-.71.116-.571.468 2.393 6.09 14.739 6.565 18.186 6.574h.396c.259-.002.468.262.382.51-.884 2.541-1.942 4.205-2.608 5.121-.33.453-.586.954-.756 1.49l-.071.22a4.56 4.56 0 00.033 2.877c.079.227.084.473.02.704a1.85 1.85 0 00-.065.316s-.03.237.015.507c.645 3.943 2.795 4.791 2.795 4.791s.362.221 1.776.153c3.363-.159 9.015-.963 10.418-1.059.15-.009.299.005.444.043l.09.024c.105.027.203.063.297.112 4.86 2.52 12.103 10.372 14.697 14.913.146.275.297.546.45.815 1.219 2.32 2.502 4.055 4.584 5.594.232.172.893.663 1.962 1.273 1.342.763 2.43 1.207 3.307 1.561 2.358.95 4.306 1.444 5.73 1.805.613.154 1.014.244 1.269.298 1.098.231 2.094.368 3.343.532 4.702.616 6.882.37 7.74 1.866.06.072.227.643.28.843l.02.067c1.156 3.37 1.887 3.764 2.409 5.31.247.727.63 1.132 1.292 1.33 1.04.31 1.966.885 2.389 2.014.974 2.598 2.849 4.608 5.277 5.284 2.677.746 3.903.51 5.51-1.719.603-.834.638-1.61.148-2.478-.96-1.698-2.384-2.51-4.132-2.726-.836-.102-1.632-.525-1.746-1.383-.19-1.429-.932-2.267-1.79-3.15-.847-.87-.644-2.093.307-2.654.25-.147 3.109-2.414 4.27-2.997.414-.213 2.88-1.078 2.959-2.809-.357-4.137.316-7.087.629-7.06.179.016-.143 1.374.41 3.956.029.128.066.252.109.374v.003c.512 2.978 4.055 7.653 5.8 9.638.088.1.154.212.2.336.354.923.817 1.773 1.393 2.576.23.321.48.9.547 1.29.56 3.326 2.145 6.256 2.466 9.642.122 1.287.412 2.853.239 3.431-.04.132-.07.266-.057.402.082.912.373 2.941.72 3.117.37.186 2.104.537 2.889-.338a.48.48 0 00.106-.267c.152-1.458.744-.828 1.046-.432a.32.32 0 00.378.11c.725-.273 1.054-.568 1.495-1.09a.495.495 0 00.108-.23c.236-1.248.292-2.476-.29-3.634-.52-1.036-1.148-1.963-1.83-2.853-1.632-2.136-2.54-4.55-1.896-7.577.28-1.316.005-2.528-.725-3.537-.507-.7-.567-1.35-.383-2.295.556-2.86.74-5.767.439-8.679-.047-.448-.294-.944.1-1.296.377-.338.773-.02 1.127.153 1.759.86 3.446.606 5.083-.436.38-.242.74-.485 1.197-.485 1.885.002 2.766-1.237 2.896-2.053.05-.315.012-.979-.284-1.379",
          fill: "#EF6A25"
        }
      )
    ] })
  }
);

// src/bullhorn/components/candidates/__generated__/BullhornCandidateDetail_bullhornCandidate.graphql.ts
var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BullhornCandidateDetail_bullhornCandidate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bullhornCandidateId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "candidateId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mappingStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bullhornSyncStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastErrorCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastErrorMessage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitProfileId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitSyncStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vaultProfileId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vaultSyncStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedOn",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BullhornCandidateCustomFields_bullhornCandidate"
    }
  ],
  "type": "BullhornCandidate",
  "abstractKey": null
};
node.hash = "bbe8e8c4e9d0f3a921d9e22c312ea50d";
var BullhornCandidateDetail_bullhornCandidate_graphql_default = node;

// src/bullhorn/components/candidates/BullhornCandidateDetail.tsx
import { Fragment as Fragment2 } from "react";
import { useFragment as useFragment2 } from "react-relay";
import {
  AuditFields,
  DescriptionItem,
  DescriptionList,
  LinkButton
} from "shared-ui";
import { useToggle } from "shared-lib";

// src/bullhorn/components/candidates/__generated__/BullhornCandidateCustomFields_bullhornCandidate.graphql.ts
var node2 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BullhornCandidateCustomFields_bullhornCandidate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "candidateId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BullhornCandidateCustomData",
      "kind": "LinkedField",
      "name": "customData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText3",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText4",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText5",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText6",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText7",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText8",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText9",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText10",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText11",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText12",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText13",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText14",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText15",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText16",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText17",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText18",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText19",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText20",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText21",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText22",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText23",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText24",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText25",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText26",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText27",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText28",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText29",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText30",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText31",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText32",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText33",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText34",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText35",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText36",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText37",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText38",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText39",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText40",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText41",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText42",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText43",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText44",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText45",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText46",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText47",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText48",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText49",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText50",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText51",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText52",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText53",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText54",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText55",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText56",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText57",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText58",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText59",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText60",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customDate1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customDate2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customDate3",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customDate4",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customDate5",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customDate6",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customDate7",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customDate8",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customDate9",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customDate10",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customDate11",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customDate12",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customDate13",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat3",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat4",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat5",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat6",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat7",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat8",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat9",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat10",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat11",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat12",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat13",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat14",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat15",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat16",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat17",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat18",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat19",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat20",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat21",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat22",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat23",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt3",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt4",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt5",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt6",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt7",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt8",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt9",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt10",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt11",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt12",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt13",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt14",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt15",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt16",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt17",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt18",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt19",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt20",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt21",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt22",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt23",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customTextBlock1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customTextBlock2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customTextBlock3",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customTextBlock4",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customTextBlock5",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customTextBlock6",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customTextBlock7",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customTextBlock8",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customTextBlock9",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customTextBlock10",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BullhornCandidate",
  "abstractKey": null
};
node2.hash = "259b4e55e5ae440b8abd56ce891f9df7";
var BullhornCandidateCustomFields_bullhornCandidate_graphql_default = node2;

// src/bullhorn/components/candidates/BullhornCandidateCustomFields.tsx
import { Fragment, useMemo, useState } from "react";
import { useFragment } from "react-relay";
import {
  EdColumnCell,
  EdRow,
  EdTable,
  Input
} from "shared-ui";
import { isNotNull } from "shared-lib";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var fragment = BullhornCandidateCustomFields_bullhornCandidate_graphql_default;
var columns = [
  { id: "Name", name: "Name" },
  { id: "Value", name: "Value" }
];
function displayList(list) {
  if (list == null || list.length == 0) {
    return "";
  }
  return list.filter(isNotNull).map((i) => i.toString()).join(",");
}
function createFields(data) {
  return [
    {
      label: "Custom Text 1",
      value: displayList(data.customData.customText1)
    },
    {
      label: "Custom Text 2",
      value: displayList(data.customData.customText2)
    },
    {
      label: "Custom Text 3",
      value: displayList(data.customData.customText3)
    },
    {
      label: "Custom Text 4",
      value: displayList(data.customData.customText4)
    },
    {
      label: "Custom Text 5",
      value: displayList(data.customData.customText5)
    },
    {
      label: "Custom Text 6",
      value: displayList(data.customData.customText6)
    },
    {
      label: "Custom Text 7",
      value: displayList(data.customData.customText7)
    },
    {
      label: "Custom Text 8",
      value: displayList(data.customData.customText8)
    },
    {
      label: "Custom Text 9",
      value: displayList(data.customData.customText9)
    },
    {
      label: "Custom Text 10",
      value: displayList(data.customData.customText10)
    },
    {
      label: "Custom Text 11",
      value: displayList(data.customData.customText11)
    },
    {
      label: "Custom Text 12",
      value: displayList(data.customData.customText12)
    },
    {
      label: "Custom Text 13",
      value: displayList(data.customData.customText13)
    },
    {
      label: "Custom Text 14",
      value: displayList(data.customData.customText14)
    },
    {
      label: "Custom Text 15",
      value: displayList(data.customData.customText15)
    },
    {
      label: "Custom Text 16",
      value: displayList(data.customData.customText16)
    },
    {
      label: "Custom Text 17",
      value: displayList(data.customData.customText17)
    },
    {
      label: "Custom Text 18",
      value: displayList(data.customData.customText18)
    },
    {
      label: "Custom Text 19",
      value: displayList(data.customData.customText19)
    },
    {
      label: "Custom Text 20",
      value: displayList(data.customData.customText20)
    },
    {
      label: "Custom Text 21",
      value: displayList(data.customData.customText21)
    },
    {
      label: "Custom Text 22",
      value: displayList(data.customData.customText22)
    },
    {
      label: "Custom Text 23",
      value: displayList(data.customData.customText23)
    },
    {
      label: "Custom Text 24",
      value: displayList(data.customData.customText24)
    },
    {
      label: "Custom Text 25",
      value: displayList(data.customData.customText25)
    },
    {
      label: "Custom Text 26",
      value: displayList(data.customData.customText26)
    },
    {
      label: "Custom Text 27",
      value: displayList(data.customData.customText27)
    },
    {
      label: "Custom Text 28",
      value: displayList(data.customData.customText28)
    },
    {
      label: "Custom Text 29",
      value: displayList(data.customData.customText29)
    },
    {
      label: "Custom Text 30",
      value: displayList(data.customData.customText30)
    },
    {
      label: "Custom Text 31",
      value: displayList(data.customData.customText31)
    },
    {
      label: "Custom Text 32",
      value: displayList(data.customData.customText32)
    },
    {
      label: "Custom Text 33",
      value: displayList(data.customData.customText33)
    },
    {
      label: "Custom Text 34",
      value: displayList(data.customData.customText34)
    },
    {
      label: "Custom Text 35",
      value: displayList(data.customData.customText35)
    },
    {
      label: "Custom Text 36",
      value: displayList(data.customData.customText36)
    },
    {
      label: "Custom Text 37",
      value: displayList(data.customData.customText37)
    },
    {
      label: "Custom Text 38",
      value: displayList(data.customData.customText38)
    },
    {
      label: "Custom Text 39",
      value: displayList(data.customData.customText39)
    },
    {
      label: "Custom Text 40",
      value: displayList(data.customData.customText40)
    },
    {
      label: "Custom Text 41",
      value: displayList(data.customData.customText41)
    },
    {
      label: "Custom Text 42",
      value: displayList(data.customData.customText42)
    },
    {
      label: "Custom Text 43",
      value: displayList(data.customData.customText43)
    },
    {
      label: "Custom Text 44",
      value: displayList(data.customData.customText44)
    },
    {
      label: "Custom Text 45",
      value: displayList(data.customData.customText45)
    },
    {
      label: "Custom Text 46",
      value: displayList(data.customData.customText46)
    },
    {
      label: "Custom Text 47",
      value: displayList(data.customData.customText47)
    },
    {
      label: "Custom Text 48",
      value: displayList(data.customData.customText48)
    },
    {
      label: "Custom Text 49",
      value: displayList(data.customData.customText49)
    },
    {
      label: "Custom Text 50",
      value: displayList(data.customData.customText50)
    },
    {
      label: "Custom Text 51",
      value: displayList(data.customData.customText51)
    },
    {
      label: "Custom Text 52",
      value: displayList(data.customData.customText52)
    },
    {
      label: "Custom Text 53",
      value: displayList(data.customData.customText53)
    },
    {
      label: "Custom Text 54",
      value: displayList(data.customData.customText54)
    },
    {
      label: "Custom Text 55",
      value: displayList(data.customData.customText55)
    },
    {
      label: "Custom Text 56",
      value: displayList(data.customData.customText56)
    },
    {
      label: "Custom Text 57",
      value: displayList(data.customData.customText57)
    },
    {
      label: "Custom Text 58",
      value: displayList(data.customData.customText58)
    },
    {
      label: "Custom Text 59",
      value: displayList(data.customData.customText59)
    },
    {
      label: "Custom Text 60",
      value: displayList(data.customData.customText60)
    },
    {
      label: "Custom Date 1",
      value: displayList(data.customData.customDate1)
    },
    {
      label: "Custom Date 2",
      value: displayList(data.customData.customDate2)
    },
    {
      label: "Custom Date 3",
      value: displayList(data.customData.customDate3)
    },
    {
      label: "Custom Date 4",
      value: displayList(data.customData.customDate4)
    },
    {
      label: "Custom Date 5",
      value: displayList(data.customData.customDate5)
    },
    {
      label: "Custom Date 6",
      value: displayList(data.customData.customDate6)
    },
    {
      label: "Custom Date 7",
      value: displayList(data.customData.customDate7)
    },
    {
      label: "Custom Date 8",
      value: displayList(data.customData.customDate8)
    },
    {
      label: "Custom Date 9",
      value: displayList(data.customData.customDate9)
    },
    {
      label: "Custom Date 10",
      value: displayList(data.customData.customDate10)
    },
    {
      label: "Custom Date 11",
      value: displayList(data.customData.customDate11)
    },
    {
      label: "Custom Date 12",
      value: displayList(data.customData.customDate12)
    },
    {
      label: "Custom Date 13",
      value: displayList(data.customData.customDate13)
    },
    {
      label: "Custom Int 1",
      value: displayList(data.customData.customInt1)
    },
    {
      label: "Custom Int 2",
      value: displayList(data.customData.customInt2)
    },
    {
      label: "Custom Int 3",
      value: displayList(data.customData.customInt3)
    },
    {
      label: "Custom Int 4",
      value: displayList(data.customData.customInt4)
    },
    {
      label: "Custom Int 5",
      value: displayList(data.customData.customInt5)
    },
    {
      label: "Custom Int 6",
      value: displayList(data.customData.customInt6)
    },
    {
      label: "Custom Int 7",
      value: displayList(data.customData.customInt7)
    },
    {
      label: "Custom Int 8",
      value: displayList(data.customData.customInt8)
    },
    {
      label: "Custom Int 9",
      value: displayList(data.customData.customInt9)
    },
    {
      label: "Custom Int 10",
      value: displayList(data.customData.customInt10)
    },
    {
      label: "Custom Int 11",
      value: displayList(data.customData.customInt11)
    },
    {
      label: "Custom Int 12",
      value: displayList(data.customData.customInt12)
    },
    {
      label: "Custom Int 13",
      value: displayList(data.customData.customInt13)
    },
    {
      label: "Custom Int 14",
      value: displayList(data.customData.customInt14)
    },
    {
      label: "Custom Int 15",
      value: displayList(data.customData.customInt15)
    },
    {
      label: "Custom Int 16",
      value: displayList(data.customData.customInt16)
    },
    {
      label: "Custom Int 17",
      value: displayList(data.customData.customInt17)
    },
    {
      label: "Custom Int 18",
      value: displayList(data.customData.customInt18)
    },
    {
      label: "Custom Int 19",
      value: displayList(data.customData.customInt19)
    },
    {
      label: "Custom Int 20",
      value: displayList(data.customData.customInt20)
    },
    {
      label: "Custom Int 21",
      value: displayList(data.customData.customInt21)
    },
    {
      label: "Custom Int 22",
      value: displayList(data.customData.customInt22)
    },
    {
      label: "Custom Int 23",
      value: displayList(data.customData.customInt23)
    },
    {
      label: "Custom Float 1",
      value: displayList(data.customData.customFloat1)
    },
    {
      label: "Custom Float 2",
      value: displayList(data.customData.customFloat2)
    },
    {
      label: "Custom Float 3",
      value: displayList(data.customData.customFloat3)
    },
    {
      label: "Custom Float 4",
      value: displayList(data.customData.customFloat4)
    },
    {
      label: "Custom Float 5",
      value: displayList(data.customData.customFloat5)
    },
    {
      label: "Custom Float 6",
      value: displayList(data.customData.customFloat6)
    },
    {
      label: "Custom Float 7",
      value: displayList(data.customData.customFloat7)
    },
    {
      label: "Custom Float 8",
      value: displayList(data.customData.customFloat8)
    },
    {
      label: "Custom Float 9",
      value: displayList(data.customData.customFloat9)
    },
    {
      label: "Custom Float 10",
      value: displayList(data.customData.customFloat10)
    },
    {
      label: "Custom Float 11",
      value: displayList(data.customData.customFloat11)
    },
    {
      label: "Custom Float 12",
      value: displayList(data.customData.customFloat12)
    },
    {
      label: "Custom Float 13",
      value: displayList(data.customData.customFloat13)
    },
    {
      label: "Custom Float 14",
      value: displayList(data.customData.customFloat14)
    },
    {
      label: "Custom Float 15",
      value: displayList(data.customData.customFloat15)
    },
    {
      label: "Custom Float 16",
      value: displayList(data.customData.customFloat16)
    },
    {
      label: "Custom Float 17",
      value: displayList(data.customData.customFloat17)
    },
    {
      label: "Custom Float 18",
      value: displayList(data.customData.customFloat18)
    },
    {
      label: "Custom Float 19",
      value: displayList(data.customData.customFloat19)
    },
    {
      label: "Custom Float 20",
      value: displayList(data.customData.customFloat20)
    },
    {
      label: "Custom Float 21",
      value: displayList(data.customData.customFloat21)
    },
    {
      label: "Custom Float 22",
      value: displayList(data.customData.customFloat22)
    },
    {
      label: "Custom Float 23",
      value: displayList(data.customData.customFloat23)
    },
    {
      label: "Custom Text Block 1",
      value: displayList(data.customData.customTextBlock1)
    },
    {
      label: "Custom Text Block 2",
      value: displayList(data.customData.customTextBlock2)
    },
    {
      label: "Custom Text Block 3",
      value: displayList(data.customData.customTextBlock3)
    },
    {
      label: "Custom Text Block 4",
      value: displayList(data.customData.customTextBlock4)
    },
    {
      label: "Custom Text Block 5",
      value: displayList(data.customData.customTextBlock5)
    },
    {
      label: "Custom Text Block 6",
      value: displayList(data.customData.customTextBlock6)
    },
    {
      label: "Custom Text Block 7",
      value: displayList(data.customData.customTextBlock7)
    },
    {
      label: "Custom Text Block 8",
      value: displayList(data.customData.customTextBlock8)
    },
    {
      label: "Custom Text Block 9",
      value: displayList(data.customData.customTextBlock9)
    },
    {
      label: "Custom Text Block 10",
      value: displayList(data.customData.customTextBlock10)
    }
  ];
}
var BullhornCandidateCustomFields = ({
  bullhornCandidate: bullhornCandidate2
}) => {
  const data = useFragment(
    fragment,
    bullhornCandidate2
  );
  const [filterText, setFilterText] = useState(null);
  const fields = useMemo(() => {
    return createFields(data).map((f, i) => {
      return {
        ...f,
        id: i
      };
    });
  }, [data]);
  const filteredFields = fields.filter((f) => {
    if (filterText === null) {
      return true;
    }
    return f.label.toLocaleLowerCase().includes(filterText.toLocaleLowerCase());
  });
  const rows = filteredFields.map((field) => {
    return /* @__PURE__ */ jsxs2(EdRow, { rowKey: field.id.toString(), children: [
      /* @__PURE__ */ jsx2(EdColumnCell, { children: field.label }),
      /* @__PURE__ */ jsx2(EdColumnCell, { children: field.value?.toString() })
    ] }, field.id);
  });
  return /* @__PURE__ */ jsxs2(Fragment, { children: [
    /* @__PURE__ */ jsx2("div", { className: "flex items-center space-x-4", children: /* @__PURE__ */ jsxs2("div", { className: "flex items-center space-x-4 p-2", children: [
      /* @__PURE__ */ jsx2("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
      /* @__PURE__ */ jsx2("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx2(
        Input,
        {
          placeholder: " Filter by Name  ",
          name: "filter",
          onValueChange: (filter) => setFilterText(filter)
        },
        "filter"
      ) })
    ] }) }),
    /* @__PURE__ */ jsx2(EdTable, { fixedHeight: false, defaultColumns: columns, rows })
  ] });
};

// src/bullhorn/components/candidates/BullhornCandidateDetail.tsx
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var fragment2 = BullhornCandidateDetail_bullhornCandidate_graphql_default;
var BullhornCandidateDetail = ({
  candidate,
  actions
}) => {
  const [showCustomFields, toggleCustomFields] = useToggle();
  const data = useFragment2(
    fragment2,
    candidate
  );
  return /* @__PURE__ */ jsx3(
    DescriptionList,
    {
      heading: "Candidate",
      description: /* @__PURE__ */ jsxs3("div", { className: "mt-4", children: [
        /* @__PURE__ */ jsxs3("div", { className: "mb-3 mt-2 flex space-x-4 text-gray-900", children: [
          /* @__PURE__ */ jsx3("div", { children: data.firstName }),
          /* @__PURE__ */ jsx3("div", { children: data.lastName })
        ] }),
        /* @__PURE__ */ jsx3(AuditFields, { createdOn: data.createdOn, updatedOn: data.updatedOn })
      ] }),
      items: /* @__PURE__ */ jsxs3(Fragment2, { children: [
        actions,
        /* @__PURE__ */ jsx3(DescriptionItem, { label: "Email", children: data.email }),
        /* @__PURE__ */ jsx3(DescriptionItem, { label: "Bullhorn Id", children: data.bullhornCandidateId }),
        /* @__PURE__ */ jsx3(DescriptionItem, { label: "Mapping", children: data.mappingStatus }),
        data.vaultProfileId && /* @__PURE__ */ jsx3(DescriptionItem, { label: "Vault Profile", children: /* @__PURE__ */ jsx3("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ jsx3("div", { children: data.vaultSyncStatus }) }) }),
        data.recruitProfileId && /* @__PURE__ */ jsx3(DescriptionItem, { label: "Recruit Profile", children: data.recruitSyncStatus }),
        /* @__PURE__ */ jsx3(DescriptionItem, { label: "Custom Fields", children: /* @__PURE__ */ jsx3("div", { children: /* @__PURE__ */ jsxs3(LinkButton, { clicked: toggleCustomFields, children: [
          showCustomFields && /* @__PURE__ */ jsx3("span", { children: "Hide Custom Fields" }),
          !showCustomFields && /* @__PURE__ */ jsx3("span", { children: "View Custom Fields" })
        ] }) }) }),
        /* @__PURE__ */ jsx3("div", { children: showCustomFields && /* @__PURE__ */ jsx3(BullhornCandidateCustomFields, { bullhornCandidate: data }) })
      ] })
    }
  );
};
var BullhornCandidateDetail_default = BullhornCandidateDetail;

// src/bullhorn/components/candidates/__generated__/BullhornCandidatesListPaginationQuery.graphql.ts
var node3 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedOn": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornCandidatesListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "BullhornCandidatesList_bullhornCandidates"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "BullhornCandidatesListPaginationQuery",
      "selections": [
        {
          "alias": null,
          "args": v3,
          "concreteType": "BullhornCandidatesConnection",
          "kind": "LinkedField",
          "name": "bullhornCandidates",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BullhornCandidatesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BullhornCandidate",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "candidateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "mappingStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastErrorCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastErrorMessage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recruitProfileId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recruitSyncStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vaultProfileId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vaultSyncStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bullhornCandidateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bullhornSyncStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "BullhornCandidatesList_bullhornCandidates",
          "kind": "LinkedHandle",
          "name": "bullhornCandidates"
        }
      ]
    },
    "params": {
      "cacheID": "92d1f9a3312db772bcfb0fba7c045365",
      "id": null,
      "metadata": {},
      "name": "BullhornCandidatesListPaginationQuery",
      "operationKind": "query",
      "text": "query BullhornCandidatesListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $tenantId: UUID!\n  $where: BullhornCandidateFilter\n) {\n  ...BullhornCandidatesList_bullhornCandidates_2HEEH6\n}\n\nfragment BullhornCandidateRow_bullhornCandidate on BullhornCandidate {\n  id\n  bullhornCandidateId\n  status\n  createdOn\n  updatedOn\n  candidateId\n  description\n  firstName\n  lastName\n  email\n  mappingStatus\n  lastErrorCode\n  lastErrorMessage\n  recruitProfileId\n  recruitSyncStatus\n  vaultProfileId\n  vaultSyncStatus\n  bullhornSyncStatus\n}\n\nfragment BullhornCandidatesList_bullhornCandidates_2HEEH6 on Query {\n  bullhornCandidates(tenantId: $tenantId, first: $first, after: $after, order: [{updatedOn: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        candidateId\n        firstName\n        lastName\n        email\n        createdOn\n        updatedOn\n        status\n        mappingStatus\n        lastErrorCode\n        lastErrorMessage\n        recruitProfileId\n        recruitSyncStatus\n        vaultProfileId\n        vaultSyncStatus\n        ...BullhornCandidateRow_bullhornCandidate\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node3.hash = "346fb04e0e64cf043a6d63be22f30315";
var BullhornCandidatesListPaginationQuery_graphql_default = node3;

// src/bullhorn/components/candidates/__generated__/BullhornCandidatesList_bullhornCandidates.graphql.ts
var node4 = function() {
  var v0 = [
    "bullhornCandidates"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "tenantId"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": BullhornCandidatesListPaginationQuery_graphql_default
      }
    },
    "name": "BullhornCandidatesList_bullhornCandidates",
    "selections": [
      {
        "alias": "bullhornCandidates",
        "args": null,
        "concreteType": "BullhornCandidatesConnection",
        "kind": "LinkedField",
        "name": "__BullhornCandidatesList_bullhornCandidates_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BullhornCandidatesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BullhornCandidate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "candidateId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mappingStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastErrorCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastErrorMessage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recruitProfileId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recruitSyncStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vaultProfileId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vaultSyncStatus",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BullhornCandidateRow_bullhornCandidate"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node4.hash = "346fb04e0e64cf043a6d63be22f30315";
var BullhornCandidatesList_bullhornCandidates_graphql_default = node4;

// src/bullhorn/components/candidates/BullhornCandidatesList.tsx
import { useCallback as useCallback2 } from "react";
import { usePaginationFragment } from "react-relay";
import { EdListHeader, EdTable as EdTable2 } from "shared-ui";

// src/bullhorn/components/candidates/__generated__/BullhornCandidateRow_bullhornCandidate.graphql.ts
var node5 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BullhornCandidateRow_bullhornCandidate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bullhornCandidateId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "candidateId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mappingStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastErrorCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastErrorMessage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitProfileId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recruitSyncStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vaultProfileId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vaultSyncStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bullhornSyncStatus",
      "storageKey": null
    }
  ],
  "type": "BullhornCandidate",
  "abstractKey": null
};
node5.hash = "6ccb1c90c4298bf9a54ac4a24e3fdb06";
var BullhornCandidateRow_bullhornCandidate_graphql_default = node5;

// src/bullhorn/components/candidates/BullhornCandidateRow.tsx
import { useCallback } from "react";
import { useFragment as useFragment3 } from "react-relay";
import { EdActionCell, EdColumnCell as EdColumnCell2, EdRow as EdRow2, LinkButton as LinkButton2 } from "shared-ui";
import { formatDateTime } from "shared-lib";
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var ProfileStatus = ({
  label,
  status
}) => {
  let statusLabel;
  switch (status.toLowerCase()) {
    case "done":
      statusLabel = /* @__PURE__ */ jsx4(
        "div",
        {
          className: "bg-success-100 text-success-800 inline-flex rounded-full px-2 text-xs font-semibold leading-5",
          children: label
        }
      );
      break;
    case "pending":
      statusLabel = /* @__PURE__ */ jsx4(
        "div",
        {
          className: "text-success-500 inline-flex rounded-full px-2 text-xs font-semibold leading-5",
          children: label
        }
      );
      break;
    case "failed":
      statusLabel = /* @__PURE__ */ jsx4(
        "div",
        {
          className: "bg-danger-100 text-danger-800 inline-flex rounded-full px-2 text-xs font-semibold leading-5",
          children: label
        }
      );
      break;
    default:
      statusLabel = /* @__PURE__ */ jsx4("div", { className: "text-gray-500", children: label });
  }
  return /* @__PURE__ */ jsx4("div", { children: statusLabel });
};
var bullhornCandidate = BullhornCandidateRow_bullhornCandidate_graphql_default;
var BullhornCandidateRow = (props) => {
  const data = useFragment3(
    bullhornCandidate,
    props.candidate
  );
  const select = useCallback(() => {
    props.selected(data);
  }, []);
  return /* @__PURE__ */ jsxs4(EdRow2, { clicked: select, rowKey: data.id, children: [
    /* @__PURE__ */ jsx4(EdColumnCell2, { children: data.bullhornCandidateId }),
    /* @__PURE__ */ jsx4(EdColumnCell2, { children: formatDateTime(data.createdOn) }),
    /* @__PURE__ */ jsx4(EdColumnCell2, { children: data.firstName }),
    /* @__PURE__ */ jsx4(EdColumnCell2, { children: data.lastName }),
    /* @__PURE__ */ jsx4(EdColumnCell2, { wrap: true, children: /* @__PURE__ */ jsx4("div", { className: "w-64 break-all text-sm", children: data.email }) }),
    /* @__PURE__ */ jsx4(EdColumnCell2, { children: data.mappingStatus }),
    /* @__PURE__ */ jsxs4(EdColumnCell2, { children: [
      data.vaultProfileId && /* @__PURE__ */ jsx4(ProfileStatus, { label: "Vault", status: data.vaultSyncStatus }),
      data.recruitProfileId && /* @__PURE__ */ jsx4(ProfileStatus, { label: "Recruit", status: data.recruitSyncStatus }),
      !data.recruitProfileId && !data.vaultProfileId && /* @__PURE__ */ jsx4("div", { children: "No Profile" })
    ] }),
    /* @__PURE__ */ jsx4(EdActionCell, { children: /* @__PURE__ */ jsx4(LinkButton2, { label: "Select", clicked: select }) })
  ] });
};
var BullhornCandidateRow_default = BullhornCandidateRow;

// src/bullhorn/components/candidates/BullhornCandidatesList.tsx
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var columns2 = [
  { id: "bullhornId", name: "Bullhorn Id" },
  { id: "createdOn", name: "Created On" },
  { id: "firstName", name: "First Name" },
  { id: "lastName", name: "Last Name" },
  { id: "email", name: "Email" },
  { id: "mapping", name: "Mapping" },
  { id: "sync", name: "Sync" }
];
var fragment3 = BullhornCandidatesList_bullhornCandidates_graphql_default;
var BullhornCandidatesList = ({
  onSelect,
  bullhornCandidatesKey
}) => {
  const select = useCallback2(
    (e) => {
      onSelect({
        nodeId: e.id,
        id: e.candidateId
      });
    },
    []
  );
  const paging = usePaginationFragment(fragment3, bullhornCandidatesKey);
  const { data } = paging;
  const rows = data.bullhornCandidates?.edges?.map((e) => {
    return /* @__PURE__ */ jsx5(
      BullhornCandidateRow_default,
      {
        candidate: e.node,
        selected: select
      },
      e.node.id
    );
  });
  return /* @__PURE__ */ jsxs5("div", { children: [
    /* @__PURE__ */ jsx5(
      EdListHeader,
      {
        total: data.bullhornCandidates?.totalCount,
        paging
      }
    ),
    /* @__PURE__ */ jsx5("div", { className: "flex", children: /* @__PURE__ */ jsx5("div", { className: "w-full", children: /* @__PURE__ */ jsx5(EdTable2, { defaultColumns: columns2, rows }) }) })
  ] });
};
var BullhornCandidatesList_default = BullhornCandidatesList;

// src/bullhorn/components/candidates/BullhornReplaceTalentPoolCandidateButton.tsx
import { useCallback as useCallback3 } from "react";
import { ConnectionHandler, useRelayEnvironment } from "react-relay";
import { createClientMutationId } from "shared-lib";
import { Button } from "shared-ui";

// src/bullhorn/mutations/candidates/__generated__/SyncCandidateMutation.graphql.ts
var node6 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidate",
    "kind": "LinkedField",
    "name": "candidate",
    "plural": false,
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BullhornCandidate",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mappingStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bullhornSyncStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastErrorCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastErrorMessage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recruitProfileId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recruitSyncStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vaultProfileId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vaultSyncStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedOn",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "SyncCandidateMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "SyncCandidatePayload",
          "kind": "LinkedField",
          "name": "syncCandidate",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "SyncCandidateMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "SyncCandidatePayload",
          "kind": "LinkedField",
          "name": "syncCandidate",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "prependEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "candidate",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3,
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "4cdf157f234b6ed5a75987fd00097034",
      "id": null,
      "metadata": {},
      "name": "SyncCandidateMutation",
      "operationKind": "mutation",
      "text": "mutation SyncCandidateMutation(\n  $input: SyncCandidateInput!\n) {\n  syncCandidate(input: $input) {\n    candidate {\n      __typename\n      cursor\n      node {\n        id\n        candidateId\n        email\n        firstName\n        lastName\n        status\n        description\n        mappingStatus\n        bullhornSyncStatus\n        lastErrorCode\n        lastErrorMessage\n        recruitProfileId\n        recruitSyncStatus\n        vaultProfileId\n        vaultSyncStatus\n        createdOn\n        updatedOn\n      }\n    }\n    userErrors {\n      __typename\n      code\n      message\n    }\n  }\n}\n"
    }
  };
}();
node6.hash = "b7614dfdb51d26b6cbfdb7d3549fdb9f";
var SyncCandidateMutation_graphql_default = node6;

// src/bullhorn/mutations/candidates/SyncCandidateMutation.ts
import { createConnectedCommitMutation } from "shared-lib";
var mutation = SyncCandidateMutation_graphql_default;
var commit = createConnectedCommitMutation(mutation);
var SyncCandidateMutation_default = { commit };

// src/bullhorn/mutations/candidates/__generated__/UploadCandidateResumeMutation.graphql.ts
var node7 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidate",
    "kind": "LinkedField",
    "name": "candidate",
    "plural": false,
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BullhornCandidate",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mappingStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bullhornSyncStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastErrorCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastErrorMessage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recruitProfileId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recruitSyncStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vaultProfileId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vaultSyncStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedOn",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "UploadCandidateResumeMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "UploadCandidateResumePayload",
          "kind": "LinkedField",
          "name": "uploadCandidateResume",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "UploadCandidateResumeMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "UploadCandidateResumePayload",
          "kind": "LinkedField",
          "name": "uploadCandidateResume",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "prependEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "candidate",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3,
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "de729215c7f63d4d9510c77e4bc3b52c",
      "id": null,
      "metadata": {},
      "name": "UploadCandidateResumeMutation",
      "operationKind": "mutation",
      "text": "mutation UploadCandidateResumeMutation(\n  $input: UploadCandidateResumeInput!\n) {\n  uploadCandidateResume(input: $input) {\n    candidate {\n      __typename\n      cursor\n      node {\n        id\n        candidateId\n        email\n        firstName\n        lastName\n        status\n        description\n        mappingStatus\n        bullhornSyncStatus\n        lastErrorCode\n        lastErrorMessage\n        recruitProfileId\n        recruitSyncStatus\n        vaultProfileId\n        vaultSyncStatus\n        createdOn\n        updatedOn\n      }\n    }\n    userErrors {\n      __typename\n      code\n      message\n    }\n  }\n}\n"
    }
  };
}();
node7.hash = "56671d4cc15f8752ed4f5b6e550d7f74";
var UploadCandidateResumeMutation_graphql_default = node7;

// src/bullhorn/mutations/candidates/UploadCandidateResumeMutation.ts
import { createConnectedCommitMutation as createConnectedCommitMutation2 } from "shared-lib";
var mutation2 = UploadCandidateResumeMutation_graphql_default;
var commit2 = createConnectedCommitMutation2(mutation2);
var UploadCandidateResumeMutation_default = { commit: commit2 };

// src/bullhorn/mutations/candidates/__generated__/ReplaceTalentPoolCandidateMutation.graphql.ts
var node8 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidate",
    "kind": "LinkedField",
    "name": "candidate",
    "plural": false,
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BullhornCandidate",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mappingStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bullhornSyncStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastErrorCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastErrorMessage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recruitProfileId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recruitSyncStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vaultProfileId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vaultSyncStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedOn",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "ReplaceTalentPoolCandidateMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "CandidatePayload",
          "kind": "LinkedField",
          "name": "replaceTalentPoolCandidate",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "ReplaceTalentPoolCandidateMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "CandidatePayload",
          "kind": "LinkedField",
          "name": "replaceTalentPoolCandidate",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "prependEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "candidate",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3,
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "e4c4b302bd5b55d14545436c71faf081",
      "id": null,
      "metadata": {},
      "name": "ReplaceTalentPoolCandidateMutation",
      "operationKind": "mutation",
      "text": "mutation ReplaceTalentPoolCandidateMutation(\n  $input: ReplaceTalentPoolCandidateInput!\n) {\n  replaceTalentPoolCandidate(input: $input) {\n    candidate {\n      __typename\n      cursor\n      node {\n        id\n        candidateId\n        email\n        firstName\n        lastName\n        status\n        description\n        mappingStatus\n        bullhornSyncStatus\n        lastErrorCode\n        lastErrorMessage\n        recruitProfileId\n        recruitSyncStatus\n        vaultProfileId\n        vaultSyncStatus\n        createdOn\n        updatedOn\n      }\n    }\n    userErrors {\n      __typename\n      code\n      message\n    }\n  }\n}\n"
    }
  };
}();
node8.hash = "393322505ed82311cd66a672686d2249";
var ReplaceTalentPoolCandidateMutation_graphql_default = node8;

// src/bullhorn/mutations/candidates/ReplaceTalentPoolCandidateMutation.ts
import { createConnectedCommitMutation as createConnectedCommitMutation3 } from "shared-lib";
var mutation3 = ReplaceTalentPoolCandidateMutation_graphql_default;
var commit3 = createConnectedCommitMutation3(mutation3);
var ReplaceTalentPoolCandidateMutation_default = { commit: commit3 };

// src/bullhorn/mutations/candidates/__generated__/RefreshVaultCandidateMutation.graphql.ts
var node9 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfCandidate",
    "kind": "LinkedField",
    "name": "candidate",
    "plural": false,
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BullhornCandidate",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mappingStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bullhornSyncStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastErrorCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastErrorMessage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recruitProfileId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recruitSyncStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vaultProfileId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vaultSyncStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedOn",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "RefreshVaultCandidateMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "CandidatePayload",
          "kind": "LinkedField",
          "name": "refreshVaultCandidate",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "RefreshVaultCandidateMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "CandidatePayload",
          "kind": "LinkedField",
          "name": "refreshVaultCandidate",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "prependEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "candidate",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3,
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "6a3128666cc5cddcceda0e8425ad994d",
      "id": null,
      "metadata": {},
      "name": "RefreshVaultCandidateMutation",
      "operationKind": "mutation",
      "text": "mutation RefreshVaultCandidateMutation(\n  $input: CandidateByIdInput!\n) {\n  refreshVaultCandidate(input: $input) {\n    candidate {\n      __typename\n      cursor\n      node {\n        id\n        candidateId\n        email\n        firstName\n        lastName\n        status\n        description\n        mappingStatus\n        bullhornSyncStatus\n        lastErrorCode\n        lastErrorMessage\n        recruitProfileId\n        recruitSyncStatus\n        vaultProfileId\n        vaultSyncStatus\n        createdOn\n        updatedOn\n      }\n    }\n    userErrors {\n      __typename\n      code\n      message\n    }\n  }\n}\n"
    }
  };
}();
node9.hash = "3e2461326b3143184cc0a429eba3369e";
var RefreshVaultCandidateMutation_graphql_default = node9;

// src/bullhorn/mutations/candidates/RefreshVaultCandidateMutation.ts
import { createConnectedCommitMutation as createConnectedCommitMutation4 } from "shared-lib";
var mutation4 = RefreshVaultCandidateMutation_graphql_default;
var commit4 = createConnectedCommitMutation4(mutation4);
var RefreshVaultCandidateMutation_default = { commit: commit4 };

// src/bullhorn/mutations/config/__generated__/TenantUpdateFetchConfigurationMutation.graphql.ts
var node10 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = [
    {
      "alias": null,
      "args": null,
      "concreteType": "FetchField",
      "kind": "LinkedField",
      "name": "fields",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fieldName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fieldValue",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfTenantConfig",
    "kind": "LinkedField",
    "name": "tenantConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BullhornTenantConfig",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FetchConfiguration",
            "kind": "LinkedField",
            "name": "jobOrderFetchConfiguration",
            "plural": false,
            "selections": v2,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FetchConfiguration",
            "kind": "LinkedField",
            "name": "candidateFetchConfiguration",
            "plural": false,
            "selections": v2,
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TenantUpdateFetchConfigurationMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "UpdateFetchConfigurationPayload",
          "kind": "LinkedField",
          "name": "bullhornTenantUpdateFetchConfiguration",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4,
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TenantUpdateFetchConfigurationMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "UpdateFetchConfigurationPayload",
          "kind": "LinkedField",
          "name": "bullhornTenantUpdateFetchConfiguration",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4,
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "5b005b9896dd0d2270ffa152035af90e",
      "id": null,
      "metadata": {},
      "name": "TenantUpdateFetchConfigurationMutation",
      "operationKind": "mutation",
      "text": "mutation TenantUpdateFetchConfigurationMutation(\n  $input: UpdateFetchConfigurationInput!\n) {\n  bullhornTenantUpdateFetchConfiguration(input: $input) {\n    tenantConfig {\n      node {\n        id\n        updatedOn\n        jobOrderFetchConfiguration {\n          fields {\n            fieldName\n            fieldValue\n          }\n        }\n        candidateFetchConfiguration {\n          fields {\n            fieldName\n            fieldValue\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      code\n      message\n    }\n  }\n}\n"
    }
  };
}();
node10.hash = "e107be7c85e1458f71115651e4302c73";
var TenantUpdateFetchConfigurationMutation_graphql_default = node10;

// src/bullhorn/mutations/config/TenantUpdateFetchConfigurationMutation.ts
import { createCommitMutation } from "shared-lib";
var mutation5 = TenantUpdateFetchConfigurationMutation_graphql_default;
var commit5 = createCommitMutation(mutation5);
var TenantUpdateFetchConfigurationMutation_default = { commit: commit5 };

// src/bullhorn/mutations/config/__generated__/TenantToggleEnabledMutation.graphql.ts
var node11 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfTenantConfig",
    "kind": "LinkedField",
    "name": "tenantConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BullhornTenantConfig",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEnabled",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TenantToggleEnabledMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "ToggleTenantEnabledPayload",
          "kind": "LinkedField",
          "name": "toggleTenantEnabled",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3,
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TenantToggleEnabledMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "ToggleTenantEnabledPayload",
          "kind": "LinkedField",
          "name": "toggleTenantEnabled",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v3,
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "bd6838b92926811d852318be0e224887",
      "id": null,
      "metadata": {},
      "name": "TenantToggleEnabledMutation",
      "operationKind": "mutation",
      "text": "mutation TenantToggleEnabledMutation(\n  $input: ToggleTenantEnabledPayloadInput!\n) {\n  toggleTenantEnabled(input: $input) {\n    tenantConfig {\n      node {\n        id\n        updatedOn\n        isEnabled\n      }\n    }\n    userErrors {\n      __typename\n      code\n      message\n    }\n  }\n}\n"
    }
  };
}();
node11.hash = "793136b1c126b6607af2860ac9866d30";
var TenantToggleEnabledMutation_graphql_default = node11;

// src/bullhorn/mutations/config/TenantToggleEnabledMutation.ts
import { createConnectedCommitMutation as createConnectedCommitMutation5 } from "shared-lib";
var mutation6 = TenantToggleEnabledMutation_graphql_default;
var commit6 = createConnectedCommitMutation5(mutation6);
var TenantToggleEnabledMutation_default = { commit: commit6 };

// src/bullhorn/mutations/events/__generated__/ProcessStandardEventMutation.graphql.ts
var node12 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfStandardEvent",
    "kind": "LinkedField",
    "name": "standardEvent",
    "plural": false,
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BullhornStandardEvent",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requestId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tenantId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "eventId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "eventType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "eventTimestamp",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "entityEventType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "entityName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedProperties",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "ProcessStandardEventMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "ProcessStandardEventPayload",
          "kind": "LinkedField",
          "name": "processStandardEvent",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "ProcessStandardEventMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "ProcessStandardEventPayload",
          "kind": "LinkedField",
          "name": "processStandardEvent",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "prependEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "standardEvent",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3,
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f7b70133ceca0c75cff18f69f556db6d",
      "id": null,
      "metadata": {},
      "name": "ProcessStandardEventMutation",
      "operationKind": "mutation",
      "text": "mutation ProcessStandardEventMutation(\n  $input: ProcessStandardEventInput!\n) {\n  processStandardEvent(input: $input) {\n    standardEvent {\n      __typename\n      cursor\n      node {\n        id\n        createdOn\n        requestId\n        tenantId\n        eventId\n        eventType\n        eventTimestamp\n        entityEventType\n        entityName\n        updatedOn\n        updatedProperties\n      }\n    }\n    userErrors {\n      __typename\n      code\n      message\n    }\n  }\n}\n"
    }
  };
}();
node12.hash = "ddffcd4fb96274cd23033cecb53fc458";
var ProcessStandardEventMutation_graphql_default = node12;

// src/bullhorn/mutations/events/ProcessStandardEventMutation.ts
import { commitMutation } from "react-relay";
import { logError, logInfo } from "shared-lib";
var mutation7 = ProcessStandardEventMutation_graphql_default;
var tempID = 0;
function commit7(environment, input, connectionId, onCompleted, onError) {
  return commitMutation(environment, {
    mutation: mutation7,
    variables: {
      input: {
        ...input,
        clientMutationId: (tempID++).toString()
      },
      connections: [connectionId]
    },
    onCompleted: (response) => {
      logInfo(response);
      onCompleted();
    },
    onError: (error) => {
      logError(error);
      if (onError) {
        onError(error);
      }
    }
  });
}
var ProcessStandardEventMutation_default = { commit: commit7 };

// src/bullhorn/mutations/job-orders/__generated__/CreateJobSubmissionsMutation.graphql.ts
var node13 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfJobOrder",
    "kind": "LinkedField",
    "name": "jobOrder",
    "plural": false,
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BullhornJobOrder",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedOn",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "CreateJobSubmissionsMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "JobOrderPayload",
          "kind": "LinkedField",
          "name": "createJobSubmissions",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "CreateJobSubmissionsMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "JobOrderPayload",
          "kind": "LinkedField",
          "name": "createJobSubmissions",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "prependEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "jobOrder",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3,
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "1a7dd735b32027b072e84f6a4f3b7c52",
      "id": null,
      "metadata": {},
      "name": "CreateJobSubmissionsMutation",
      "operationKind": "mutation",
      "text": "mutation CreateJobSubmissionsMutation(\n  $input: CreateJobSubmissionsInput!\n) {\n  createJobSubmissions(input: $input) {\n    jobOrder {\n      __typename\n      cursor\n      node {\n        id\n        status\n        title\n        description\n        createdOn\n        updatedOn\n      }\n    }\n    userErrors {\n      __typename\n      code\n      message\n    }\n  }\n}\n"
    }
  };
}();
node13.hash = "55c053f61e25e2ac4a7d30f8955b3085";
var CreateJobSubmissionsMutation_graphql_default = node13;

// src/bullhorn/mutations/job-orders/CreateJobSubmissionsMutation.ts
import { commitMutation as commitMutation2 } from "react-relay";
import { logError as logError2, logInfo as logInfo2 } from "shared-lib";
var mutation8 = CreateJobSubmissionsMutation_graphql_default;
var tempID2 = 0;
function commit8(environment, input, connectionId, onCompleted, onError) {
  return commitMutation2(environment, {
    mutation: mutation8,
    variables: {
      input: {
        ...input,
        clientMutationId: (tempID2++).toString()
      },
      connections: [connectionId]
    },
    onCompleted: (response) => {
      logInfo2(response);
      onCompleted(response);
    },
    onError: (error) => {
      logError2(error);
      if (onError) {
        onError(error);
      }
    }
  });
}
var CreateJobSubmissionsMutation_default = { commit: commit8 };

// src/bullhorn/mutations/job-orders/__generated__/FetchJobOrderMutation.graphql.ts
var node14 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfJobOrder",
    "kind": "LinkedField",
    "name": "jobOrder",
    "plural": false,
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BullhornJobOrder",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedOn",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "FetchJobOrderMutation",
      "selections": [
        {
          "alias": "command",
          "args": v2,
          "concreteType": "JobOrderPayload",
          "kind": "LinkedField",
          "name": "fetchJobOrderFromBullhorn",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "FetchJobOrderMutation",
      "selections": [
        {
          "alias": "command",
          "args": v2,
          "concreteType": "JobOrderPayload",
          "kind": "LinkedField",
          "name": "fetchJobOrderFromBullhorn",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "prependEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "jobOrder",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3,
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "aa338e75147552fc15afd41d45b884a5",
      "id": null,
      "metadata": {},
      "name": "FetchJobOrderMutation",
      "operationKind": "mutation",
      "text": "mutation FetchJobOrderMutation(\n  $input: FetchJobOrderInput!\n) {\n  command: fetchJobOrderFromBullhorn(input: $input) {\n    jobOrder {\n      __typename\n      cursor\n      node {\n        id\n        status\n        title\n        description\n        createdOn\n        updatedOn\n      }\n    }\n    userErrors {\n      __typename\n      code\n      message\n    }\n  }\n}\n"
    }
  };
}();
node14.hash = "0269778c554e7f84e654c0a2363de101";
var FetchJobOrderMutation_graphql_default = node14;

// src/bullhorn/mutations/job-orders/FetchJobOrderMutation.ts
import { commitMutation as commitMutation3 } from "react-relay";
import { logError as logError3, logInfo as logInfo3 } from "shared-lib";
var mutation9 = FetchJobOrderMutation_graphql_default;
var tempID3 = 0;
function commit9(environment, input, connectionId, onCompleted, onError) {
  return commitMutation3(environment, {
    mutation: mutation9,
    variables: {
      input: {
        ...input,
        clientMutationId: (tempID3++).toString()
      },
      connections: [connectionId]
    },
    onCompleted: (response) => {
      logInfo3(response);
      onCompleted(response);
    },
    onError: (error) => {
      logError3(error);
      if (onError) {
        onError(error);
      }
    }
  });
}
var FetchJobOrderMutation_default = { commit: commit9 };

// src/bullhorn/mutations/job-orders/__generated__/RefreshJobOrderMutation.graphql.ts
var node15 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfJobOrder",
    "kind": "LinkedField",
    "name": "jobOrder",
    "plural": false,
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BullhornJobOrder",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedOn",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "RefreshJobOrderMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "JobOrderPayload",
          "kind": "LinkedField",
          "name": "refreshJobOrderFromBullhorn",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "RefreshJobOrderMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "JobOrderPayload",
          "kind": "LinkedField",
          "name": "refreshJobOrderFromBullhorn",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "prependEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "jobOrder",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3,
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "43ddc6b5cef5394df294f6fa269e096f",
      "id": null,
      "metadata": {},
      "name": "RefreshJobOrderMutation",
      "operationKind": "mutation",
      "text": "mutation RefreshJobOrderMutation(\n  $input: RefreshJobOrderInput!\n) {\n  refreshJobOrderFromBullhorn(input: $input) {\n    jobOrder {\n      __typename\n      cursor\n      node {\n        id\n        status\n        title\n        description\n        createdOn\n        updatedOn\n      }\n    }\n    userErrors {\n      __typename\n      code\n      message\n    }\n  }\n}\n"
    }
  };
}();
node15.hash = "acc07480a87934c845f85ef872db8fdf";
var RefreshJobOrderMutation_graphql_default = node15;

// src/bullhorn/mutations/job-orders/RefreshJobOrderMutation.ts
import { commitMutation as commitMutation4 } from "react-relay";
import { logError as logError4, logInfo as logInfo4 } from "shared-lib";
var mutation10 = RefreshJobOrderMutation_graphql_default;
var tempID4 = 0;
function commit10(environment, input, connectionId, onCompleted, onError) {
  return commitMutation4(environment, {
    mutation: mutation10,
    variables: {
      input: {
        ...input,
        clientMutationId: (tempID4++).toString()
      },
      connections: [connectionId]
    },
    onCompleted: (response) => {
      logInfo4(response);
      onCompleted(response);
    },
    onError: (error) => {
      logError4(error);
      if (onError) {
        onError(error);
      }
    }
  });
}
var RefreshJobOrderMutation_default = { commit: commit10 };

// src/bullhorn/mutations/job-orders/__generated__/SyncJobOrderMutation.graphql.ts
var node16 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfJobOrder",
    "kind": "LinkedField",
    "name": "jobOrder",
    "plural": false,
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BullhornJobOrder",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedOn",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "SyncJobOrderMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "SyncJobOrderPayload",
          "kind": "LinkedField",
          "name": "syncJobOrder",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "SyncJobOrderMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "SyncJobOrderPayload",
          "kind": "LinkedField",
          "name": "syncJobOrder",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "prependEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "jobOrder",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3,
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "12de216e7f877d17953fa153576775cb",
      "id": null,
      "metadata": {},
      "name": "SyncJobOrderMutation",
      "operationKind": "mutation",
      "text": "mutation SyncJobOrderMutation(\n  $input: SyncJobOrderInput!\n) {\n  syncJobOrder(input: $input) {\n    jobOrder {\n      __typename\n      cursor\n      node {\n        id\n        status\n        title\n        description\n        createdOn\n        updatedOn\n      }\n    }\n    userErrors {\n      __typename\n      code\n      message\n    }\n  }\n}\n"
    }
  };
}();
node16.hash = "24268a5242ffd267fee6e4b77a807f90";
var SyncJobOrderMutation_graphql_default = node16;

// src/bullhorn/mutations/job-orders/SyncJobOrderMutation.ts
import { commitMutation as commitMutation5 } from "react-relay";
import { logError as logError5, logInfo as logInfo5 } from "shared-lib";
var mutation11 = SyncJobOrderMutation_graphql_default;
var tempID5 = 0;
function commit11(environment, input, connectionId, onCompleted, onError) {
  return commitMutation5(environment, {
    mutation: mutation11,
    variables: {
      input: {
        ...input,
        clientMutationId: (tempID5++).toString()
      },
      connections: [connectionId]
    },
    onCompleted: (response) => {
      logInfo5(response);
      onCompleted();
    },
    onError: (error) => {
      logError5(error);
      if (onError) {
        onError(error);
      }
    }
  });
}
var SyncJobOrderMutation_default = { commit: commit11 };

// src/bullhorn/mutations/job-orders/__generated__/SubmitPendingJobSubmissionsMutation.graphql.ts
var node17 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfJobOrder",
    "kind": "LinkedField",
    "name": "jobOrder",
    "plural": false,
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BullhornJobOrder",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedOn",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "SubmitPendingJobSubmissionsMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "JobOrderPayload",
          "kind": "LinkedField",
          "name": "submitPendingJobSubmissions",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "SubmitPendingJobSubmissionsMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "JobOrderPayload",
          "kind": "LinkedField",
          "name": "submitPendingJobSubmissions",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "prependEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "jobOrder",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3,
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "10dd63ab3aaf41b53fcce43799afe837",
      "id": null,
      "metadata": {},
      "name": "SubmitPendingJobSubmissionsMutation",
      "operationKind": "mutation",
      "text": "mutation SubmitPendingJobSubmissionsMutation(\n  $input: SubmitPendingJobSubmissionsInput!\n) {\n  submitPendingJobSubmissions(input: $input) {\n    jobOrder {\n      __typename\n      cursor\n      node {\n        id\n        status\n        title\n        description\n        createdOn\n        updatedOn\n      }\n    }\n    userErrors {\n      __typename\n      code\n      message\n    }\n  }\n}\n"
    }
  };
}();
node17.hash = "f9babc809105a736e2831f888625f151";
var SubmitPendingJobSubmissionsMutation_graphql_default = node17;

// src/bullhorn/mutations/job-orders/SubmitPendingJobSubmissionsMutation.ts
import { createConnectedCommitMutation as createConnectedCommitMutation6 } from "shared-lib";
var mutation12 = SubmitPendingJobSubmissionsMutation_graphql_default;
var commit12 = createConnectedCommitMutation6(mutation12);
var SubmitPendingJobSubmissionsMutation_default = { commit: commit12 };

// src/bullhorn/mutations/job-submissions/__generated__/SyncJobSubmissionMutation.graphql.ts
var node18 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfJobSubmission",
    "kind": "LinkedField",
    "name": "jobSubmission",
    "plural": false,
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BullhornJobSubmission",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v4,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BullhornJobOrder",
            "kind": "LinkedField",
            "name": "jobOrder",
            "plural": false,
            "selections": [
              v4,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BullhornCandidate",
            "kind": "LinkedField",
            "name": "candidate",
            "plural": false,
            "selections": [
              v4,
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedOn",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "SyncJobSubmissionMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "SyncJobSubmissionPayload",
          "kind": "LinkedField",
          "name": "syncJobSubmission",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v6,
                v7
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "SyncJobSubmissionMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "SyncJobSubmissionPayload",
          "kind": "LinkedField",
          "name": "syncJobSubmission",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "prependEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "jobSubmission",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3,
                v6,
                v7
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "9dfdd246937e39957173c1cbde397b78",
      "id": null,
      "metadata": {},
      "name": "SyncJobSubmissionMutation",
      "operationKind": "mutation",
      "text": "mutation SyncJobSubmissionMutation(\n  $input: SyncJobSubmissionInput!\n) {\n  syncJobSubmission(input: $input) {\n    jobSubmission {\n      __typename\n      cursor\n      node {\n        id\n        status\n        jobOrder {\n          id\n          title\n        }\n        candidate {\n          id\n          email\n          firstName\n          lastName\n        }\n        createdOn\n        updatedOn\n      }\n    }\n    userErrors {\n      __typename\n      code\n      message\n    }\n  }\n}\n"
    }
  };
}();
node18.hash = "10fd74bb018541b6e8ad662bfaeebfd1";
var SyncJobSubmissionMutation_graphql_default = node18;

// src/bullhorn/mutations/job-submissions/SyncJobSubmissionMutation.ts
import { createConnectedCommitMutation as createConnectedCommitMutation7 } from "shared-lib";
var mutation13 = SyncJobSubmissionMutation_graphql_default;
var commit13 = createConnectedCommitMutation7(mutation13);
var SyncJobSubmissionMutation_default = { commit: commit13 };

// src/bullhorn/mutations/tenant-config/__generated__/BullhornChangeJobOrderWorkflowConfigurationMutation.graphql.ts
var node19 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = [
    {
      "alias": null,
      "args": null,
      "concreteType": "FetchField",
      "kind": "LinkedField",
      "name": "fields",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fieldName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fieldValue",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfTenantConfig",
    "kind": "LinkedField",
    "name": "tenantConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BullhornTenantConfig",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdByAccountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedByAccountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tenantId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TenantWorkflowConfiguration",
            "kind": "LinkedField",
            "name": "workflowConfiguration",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vaultJobSubmissionWorkflowId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recommendationJobSubmissionWorkflowId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jobOrderWorkflowId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "candidateWorkflowId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "applicationJobSubmissionWorkflowId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FetchConfiguration",
            "kind": "LinkedField",
            "name": "candidateFetchConfiguration",
            "plural": false,
            "selections": v2,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FetchConfiguration",
            "kind": "LinkedField",
            "name": "jobOrderFetchConfiguration",
            "plural": false,
            "selections": v2,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "restAuthorizeBaseUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "restTokenBaseUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "restLoginBaseUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornChangeJobOrderWorkflowConfigurationMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "TenantConfigPayload",
          "kind": "LinkedField",
          "name": "bullhornChangeJobOrderWorkflowConfiguration",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v4,
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "BullhornChangeJobOrderWorkflowConfigurationMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "TenantConfigPayload",
          "kind": "LinkedField",
          "name": "bullhornChangeJobOrderWorkflowConfiguration",
          "plural": false,
          "selections": [
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v4,
                v5
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "7c64a8bf6da153fb5b51d09ac4e4820f",
      "id": null,
      "metadata": {},
      "name": "BullhornChangeJobOrderWorkflowConfigurationMutation",
      "operationKind": "mutation",
      "text": "mutation BullhornChangeJobOrderWorkflowConfigurationMutation(\n  $input: ChangeTenantWorkflowConfigurationInput!\n) {\n  bullhornChangeJobOrderWorkflowConfiguration(input: $input) {\n    tenantConfig {\n      node {\n        id\n        createdOn\n        createdByAccountType\n        createdById\n        updatedOn\n        updatedByAccountType\n        updatedById\n        tenantId\n        name\n        isEnabled\n        workflowConfiguration {\n          vaultJobSubmissionWorkflowId\n          recommendationJobSubmissionWorkflowId\n          jobOrderWorkflowId\n          candidateWorkflowId\n          applicationJobSubmissionWorkflowId\n        }\n        candidateFetchConfiguration {\n          fields {\n            fieldName\n            fieldValue\n          }\n        }\n        jobOrderFetchConfiguration {\n          fields {\n            fieldName\n            fieldValue\n          }\n        }\n        restAuthorizeBaseUrl\n        restTokenBaseUrl\n        restLoginBaseUrl\n      }\n    }\n    userErrors {\n      __typename\n      code\n      message\n    }\n  }\n}\n"
    }
  };
}();
node19.hash = "4d6d5f2f3b1fe79c70df1954a509b499";
var BullhornChangeJobOrderWorkflowConfigurationMutation_graphql_default = node19;

// src/bullhorn/mutations/tenant-config/BullhornChangeJobOrderWorkflowConfigurationMutation.ts
import { createCommitMutation as createCommitMutation2 } from "shared-lib";
var mutation14 = BullhornChangeJobOrderWorkflowConfigurationMutation_graphql_default;
var commit14 = createCommitMutation2(mutation14);
var BullhornChangeJobOrderWorkflowConfigurationMutation_default = { commit: commit14 };

// src/bullhorn/mutations/tenants/__generated__/TenantChangeDefaultMappingConfigurationMutation.graphql.ts
var node20 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "concreteType": "BullhornTenant",
    "kind": "LinkedField",
    "name": "tenant",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "defaultJobOrderMappingConfigurationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "defaultCandidateMappingConfigurationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "defaultJobSubmissionMappingConfigurationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "TenantChangeDefaultMappingConfigurationMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "ChangeDefaultMappingConfigurationPayload",
          "kind": "LinkedField",
          "name": "bullhornTenantChangeDefaultMappingConfiguration",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3,
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "TenantChangeDefaultMappingConfigurationMutation",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "ChangeDefaultMappingConfigurationPayload",
          "kind": "LinkedField",
          "name": "bullhornTenantChangeDefaultMappingConfiguration",
          "plural": false,
          "selections": [
            v2,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                v3,
                v4
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "faa034461bb31eac91b89581efe6ae1e",
      "id": null,
      "metadata": {},
      "name": "TenantChangeDefaultMappingConfigurationMutation",
      "operationKind": "mutation",
      "text": "mutation TenantChangeDefaultMappingConfigurationMutation(\n  $input: ChangeDefaultMappingConfigurationInput!\n) {\n  bullhornTenantChangeDefaultMappingConfiguration(input: $input) {\n    tenant {\n      id\n      createdOn\n      updatedOn\n      name\n      defaultJobOrderMappingConfigurationId\n      defaultCandidateMappingConfigurationId\n      defaultJobSubmissionMappingConfigurationId\n    }\n    userErrors {\n      __typename\n      code\n      message\n    }\n  }\n}\n"
    }
  };
}();
node20.hash = "2d6c76785392c73a1b39d0bebb2aac26";
var TenantChangeDefaultMappingConfigurationMutation_graphql_default = node20;

// src/bullhorn/mutations/tenants/TenantChangeDefaultMappingConfigurationMutation.ts
import { createCommitMutation as createCommitMutation3 } from "shared-lib";
var mutation15 = TenantChangeDefaultMappingConfigurationMutation_graphql_default;
var commit15 = createCommitMutation3(mutation15);
var TenantChangeDefaultMappingConfigurationMutation_default = { commit: commit15 };

// src/bullhorn/components/candidates/BullhornReplaceTalentPoolCandidateButton.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
var BullhornReplaceTalentPoolCandidateButton = (props) => {
  const {
    onRequestStart,
    onRequestDone,
    onRequestError,
    candidateId,
    ...rest
  } = props;
  const environment = useRelayEnvironment();
  const connectionId = ConnectionHandler.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "BullhornJobOrderList_bullhornJobOrders"
  );
  const onClicked = useCallback3(() => {
    if (!candidateId) {
      return;
    }
    onRequestStart();
    const clientMutationId = createClientMutationId();
    const input = {
      id: candidateId,
      clientMutationId
    };
    ReplaceTalentPoolCandidateMutation_default.commit(
      environment,
      input,
      connectionId,
      () => {
        onRequestDone();
      },
      (error) => {
        onRequestError(error);
      }
    );
  }, []);
  return /* @__PURE__ */ jsx6(Button, { color: "primary", clicked: onClicked, ...rest, children: "Update Profile" });
};

// src/bullhorn/components/candidates/BullhornSyncCandidateElevateButton.tsx
import { useCallback as useCallback4 } from "react";
import { ConnectionHandler as ConnectionHandler2, useRelayEnvironment as useRelayEnvironment2 } from "react-relay";
import { createClientMutationId as createClientMutationId2 } from "shared-lib";
import { Button as Button2 } from "shared-ui";
import { jsx as jsx7 } from "react/jsx-runtime";
var BullhornSyncCandidateElevateButton = (props) => {
  const {
    onRequestStart,
    onRequestDone,
    onRequestError,
    candidateId,
    ...rest
  } = props;
  const environment = useRelayEnvironment2();
  const connectionId = ConnectionHandler2.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "BullhornJobOrderList_bullhornJobOrders"
  );
  const onClicked = useCallback4(() => {
    if (!candidateId) {
      return;
    }
    onRequestStart();
    const clientMutationId = createClientMutationId2();
    const input = {
      id: candidateId,
      clientMutationId
    };
    SyncCandidateMutation_default.commit(
      environment,
      input,
      connectionId,
      () => {
        onRequestDone();
      },
      (error) => {
        onRequestError(error);
      }
    );
  }, []);
  return /* @__PURE__ */ jsx7(Button2, { color: "primary", clicked: onClicked, ...rest, children: "Sync To Elevate" });
};

// src/bullhorn/components/candidates/BullhornUploadCandidateResumeButton.tsx
import { useCallback as useCallback5 } from "react";
import { ConnectionHandler as ConnectionHandler3, useRelayEnvironment as useRelayEnvironment3 } from "react-relay";
import { createClientMutationId as createClientMutationId3 } from "shared-lib";
import { Button as Button3 } from "shared-ui";
import { jsx as jsx8 } from "react/jsx-runtime";
var BullhornUploadCandidateResumeButton = (props) => {
  const {
    onRequestStart,
    onRequestDone,
    onRequestError,
    candidateId,
    ...rest
  } = props;
  const environment = useRelayEnvironment3();
  const connectionId = ConnectionHandler3.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "BullhornJobOrderList_bullhornJobOrders"
  );
  const onClicked = useCallback5(() => {
    if (!candidateId) {
      return;
    }
    onRequestStart();
    const clientMutationId = createClientMutationId3();
    const input = {
      id: candidateId,
      clientMutationId
    };
    UploadCandidateResumeMutation_default.commit(
      environment,
      input,
      connectionId,
      () => {
        onRequestDone();
      },
      (error) => {
        onRequestError(error);
      }
    );
  }, []);
  return /* @__PURE__ */ jsx8(Button3, { color: "primary", clicked: onClicked, ...rest, children: "Upload Resume" });
};

// src/bullhorn/components/candidates/BullhornRefreshVaultCandidateButton.tsx
import { useCallback as useCallback6 } from "react";
import { ConnectionHandler as ConnectionHandler4, useRelayEnvironment as useRelayEnvironment4 } from "react-relay";
import { createClientMutationId as createClientMutationId4 } from "shared-lib";
import { Button as Button4 } from "shared-ui";
import { jsx as jsx9 } from "react/jsx-runtime";
var BullhornRefreshVaultCandidateButton = (props) => {
  const {
    onRequestStart,
    onRequestDone,
    onRequestError,
    candidateId,
    ...rest
  } = props;
  const environment = useRelayEnvironment4();
  const connectionId = ConnectionHandler4.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "BullhornJobOrderList_bullhornJobOrders"
  );
  const onClicked = useCallback6(() => {
    if (!candidateId) {
      return;
    }
    onRequestStart();
    const clientMutationId = createClientMutationId4();
    const input = {
      id: candidateId,
      clientMutationId
    };
    RefreshVaultCandidateMutation_default.commit(
      environment,
      input,
      connectionId,
      () => {
        onRequestDone();
      },
      (error) => {
        onRequestError(error);
      }
    );
  }, []);
  return /* @__PURE__ */ jsx9(Button4, { color: "primary", clicked: onClicked, ...rest, children: "Refresh From Bullhorn" });
};

// src/bullhorn/components/job-orders/BullhornJobOrderTabs.tsx
import { TabButton } from "shared-ui";
import { jsx as jsx10 } from "react/jsx-runtime";
var BullhornJobOrderTabs = ({ tabs }) => {
  if (!tabs || tabs.length === 0) {
    return /* @__PURE__ */ jsx10("div", {});
  }
  return /* @__PURE__ */ jsx10("div", { children: /* @__PURE__ */ jsx10("nav", { className: "flex space-x-4", "aria-label": "Tabs", children: tabs.map((tab) => /* @__PURE__ */ jsx10(
    TabButton,
    {
      name: tab.name,
      current: tab.current,
      onClick: tab.onClick
    },
    tab.name
  )) }) });
};
var BullhornJobOrderTabs_default = BullhornJobOrderTabs;

// src/bullhorn/components/job-orders/__generated__/BullhornJobOrderJobSubmissionsListQuery.graphql.ts
var node21 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "jobOrderId"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tenantId"
  }, v2 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedOn": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    },
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "jobOrderId"
            }
          ],
          "kind": "ObjectValue",
          "name": "jobOrderId"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornJobOrderJobSubmissionsListQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BullhornJobSubmissionsByJobOrderList_bullhornJobSubmissions"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "BullhornJobOrderJobSubmissionsListQuery",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "BullhornJobSubmissionsConnection",
          "kind": "LinkedField",
          "name": "bullhornJobSubmissions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BullhornJobSubmissionsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BullhornJobSubmission",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v3,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "source",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bullhornSyncStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bullhornJobSubmissionId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BullhornJobOrder",
                      "kind": "LinkedField",
                      "name": "jobOrder",
                      "plural": false,
                      "selections": [
                        v3,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "title",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BullhornCandidate",
                      "kind": "LinkedField",
                      "name": "candidate",
                      "plural": false,
                      "selections": [
                        v3,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "email",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recruitProfileId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recruitSyncStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "vaultProfileId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "vaultSyncStatus",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastErrorCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastErrorMessage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v2,
          "filters": [],
          "handle": "connection",
          "key": "BullhornJobSubmissionsByJobOrderList_bullhornJobSubmissions",
          "kind": "LinkedHandle",
          "name": "bullhornJobSubmissions"
        }
      ]
    },
    "params": {
      "cacheID": "455fa671033e8b73eedbadcb77baf023",
      "id": null,
      "metadata": {},
      "name": "BullhornJobOrderJobSubmissionsListQuery",
      "operationKind": "query",
      "text": "query BullhornJobOrderJobSubmissionsListQuery(\n  $tenantId: UUID!\n  $jobOrderId: UUID!\n) {\n  ...BullhornJobSubmissionsByJobOrderList_bullhornJobSubmissions\n}\n\nfragment BullhornJobSubmissionRow_bullhornJobSubmission on BullhornJobSubmission {\n  id\n  createdOn\n  updatedOn\n  source\n  status\n  bullhornSyncStatus\n  bullhornJobSubmissionId\n  jobOrder {\n    id\n    title\n  }\n  candidate {\n    id\n    firstName\n    lastName\n    email\n    recruitProfileId\n    recruitSyncStatus\n    vaultProfileId\n    vaultSyncStatus\n  }\n  lastErrorCode\n  lastErrorMessage\n}\n\nfragment BullhornJobSubmissionsByJobOrderList_bullhornJobSubmissions on Query {\n  bullhornJobSubmissions(tenantId: $tenantId, first: 10, where: {jobOrderId: {eq: $jobOrderId}}, order: [{updatedOn: DESC}]) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        ...BullhornJobSubmissionRow_bullhornJobSubmission\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node21.hash = "96d57c5c4cc9cc0081e4cb8e5fe57e88";
var BullhornJobOrderJobSubmissionsListQuery_graphql_default = node21;

// src/bullhorn/components/job-orders/BullhornJobOrderJobSubmissionsList.tsx
import { Suspense, useCallback as useCallback10 } from "react";
import { useLazyLoadQuery } from "react-relay";
import { EdSkeleton } from "shared-ui";

// src/bullhorn/components/job-submissions/__generated__/BullhornJobSubmissionDetail_bullhornJobSubmission.graphql.ts
var node22 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "BullhornJobSubmissionDetail_bullhornJobSubmission",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BullhornJobOrder",
        "kind": "LinkedField",
        "name": "jobOrder",
        "plural": false,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BullhornCandidate",
        "kind": "LinkedField",
        "name": "candidate",
        "plural": false,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastErrorCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastErrorMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bullhornSyncStatus",
        "storageKey": null
      }
    ],
    "type": "BullhornJobSubmission",
    "abstractKey": null
  };
}();
node22.hash = "2a4951ccba3107adb8f234bdac52fe9b";
var BullhornJobSubmissionDetail_bullhornJobSubmission_graphql_default = node22;

// src/bullhorn/components/job-submissions/BullhornJobSubmissionDetail.tsx
import { Fragment as Fragment3 } from "react";
import { useFragment as useFragment4 } from "react-relay";
import {
  AuditFields as AuditFields2,
  DescriptionItem as DescriptionItem2,
  DescriptionList as DescriptionList2,
  LinkButton as LinkButton3
} from "shared-ui";
import { jsx as jsx11, jsxs as jsxs6 } from "react/jsx-runtime";
var fragment4 = BullhornJobSubmissionDetail_bullhornJobSubmission_graphql_default;
var BullhornJobSubmissionDetail = ({
  bullhornJobSubmission: bullhornJobSubmission2,
  actions,
  onSelectJobOrder,
  onSelectCandidate
}) => {
  const data = useFragment4(
    fragment4,
    bullhornJobSubmission2
  );
  return /* @__PURE__ */ jsx11("div", { className: "flex", children: /* @__PURE__ */ jsx11(
    DescriptionList2,
    {
      heading: /* @__PURE__ */ jsx11("div", { className: "flex space-x-2", children: /* @__PURE__ */ jsx11("span", { className: "text-info-600", children: "Job Submission" }) }),
      description: "Bullhorn Job Submission",
      items: /* @__PURE__ */ jsxs6(Fragment3, { children: [
        /* @__PURE__ */ jsx11("div", { className: "p-4", children: /* @__PURE__ */ jsx11(
          AuditFields2,
          {
            createdOn: data.createdOn,
            updatedOn: data.updatedOn
          }
        ) }),
        actions,
        /* @__PURE__ */ jsx11(DescriptionItem2, { label: "Candidate", children: /* @__PURE__ */ jsxs6("div", { className: "items-top flex justify-between", children: [
          /* @__PURE__ */ jsxs6("div", { children: [
            data.candidate.firstName,
            " ",
            data.candidate.lastName,
            /* @__PURE__ */ jsx11("div", { className: "mt-2", children: data.candidate.email })
          ] }),
          onSelectCandidate ? /* @__PURE__ */ jsx11("div", { children: /* @__PURE__ */ jsx11(
            LinkButton3,
            {
              label: "View",
              clicked: onSelectCandidate
            }
          ) }) : null
        ] }) }),
        /* @__PURE__ */ jsx11(DescriptionItem2, { label: "Job Order", children: /* @__PURE__ */ jsxs6("div", { className: "items-top flex justify-between", children: [
          /* @__PURE__ */ jsx11("div", { children: data.jobOrder.title }),
          onSelectJobOrder ? /* @__PURE__ */ jsx11("div", { children: /* @__PURE__ */ jsx11(
            LinkButton3,
            {
              label: "View",
              clicked: onSelectJobOrder
            }
          ) }) : null
        ] }) }),
        /* @__PURE__ */ jsx11(DescriptionItem2, { label: "Bullhorn", children: data.bullhornSyncStatus }),
        data.lastErrorCode && /* @__PURE__ */ jsxs6(DescriptionItem2, { label: "Most Recent Error", children: [
          /* @__PURE__ */ jsx11("div", { className: "font-medium", children: data.lastErrorCode }),
          /* @__PURE__ */ jsx11("div", { className: "prose-xl mt-2", children: data.lastErrorMessage })
        ] })
      ] })
    }
  ) });
};
var BullhornJobSubmissionDetail_default = BullhornJobSubmissionDetail;

// src/bullhorn/components/job-submissions/__generated__/BullhornJobSubmissionRow_bullhornJobSubmission.graphql.ts
var node23 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "BullhornJobSubmissionRow_bullhornJobSubmission",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "source",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bullhornSyncStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bullhornJobSubmissionId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BullhornJobOrder",
        "kind": "LinkedField",
        "name": "jobOrder",
        "plural": false,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BullhornCandidate",
        "kind": "LinkedField",
        "name": "candidate",
        "plural": false,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recruitProfileId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recruitSyncStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vaultProfileId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vaultSyncStatus",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastErrorCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastErrorMessage",
        "storageKey": null
      }
    ],
    "type": "BullhornJobSubmission",
    "abstractKey": null
  };
}();
node23.hash = "3a82f69a96ae4ac5b08bf192d3bcca4f";
var BullhornJobSubmissionRow_bullhornJobSubmission_graphql_default = node23;

// src/bullhorn/components/job-submissions/BullhornJobSubmissionRow.tsx
import { useCallback as useCallback7 } from "react";
import { useFragment as useFragment5 } from "react-relay";
import { EdActionCell as EdActionCell2, EdColumnCell as EdColumnCell3, EdRow as EdRow3, LinkButton as LinkButton4 } from "shared-ui";
import { parseDate, timeAgo } from "shared-lib";
import { jsx as jsx12, jsxs as jsxs7 } from "react/jsx-runtime";
var bullhornJobSubmission = BullhornJobSubmissionRow_bullhornJobSubmission_graphql_default;
var BullhornJobSubmissionRow = (props) => {
  const data = useFragment5(bullhornJobSubmission, props.bullhornJobSubmission);
  const select = useCallback7(() => {
    props.selected(data);
  }, []);
  return /* @__PURE__ */ jsxs7(EdRow3, { clicked: select, rowKey: data.id, children: [
    /* @__PURE__ */ jsxs7(EdColumnCell3, { children: [
      /* @__PURE__ */ jsxs7("div", { children: [
        data.candidate.firstName,
        " ",
        data.candidate.lastName
      ] }),
      /* @__PURE__ */ jsx12("div", { children: data.candidate.email })
    ] }),
    /* @__PURE__ */ jsx12(EdColumnCell3, { children: data.jobOrder.title }),
    /* @__PURE__ */ jsx12(EdColumnCell3, { children: data.bullhornSyncStatus }),
    /* @__PURE__ */ jsx12(EdColumnCell3, { children: data.candidate ? /* @__PURE__ */ jsxs7("div", { children: [
      data.candidate.recruitProfileId ? /* @__PURE__ */ jsx12("div", { children: "Talent Pool" }) : null,
      data.candidate.vaultProfileId ? /* @__PURE__ */ jsx12("div", { children: "Vault" }) : null
    ] }) : /* @__PURE__ */ jsx12("div", { children: "Unknown" }) }),
    /* @__PURE__ */ jsx12(EdColumnCell3, { children: timeAgo(parseDate(data.createdOn)) }),
    /* @__PURE__ */ jsx12(EdColumnCell3, { children: timeAgo(parseDate(data.updatedOn)) }),
    /* @__PURE__ */ jsx12(EdColumnCell3, { children: data.lastErrorCode ? /* @__PURE__ */ jsxs7("div", { children: [
      /* @__PURE__ */ jsx12("div", { children: data.lastErrorCode }),
      /* @__PURE__ */ jsx12("div", { children: data.lastErrorMessage })
    ] }) : /* @__PURE__ */ jsx12("div", { children: "No Error" }) }),
    /* @__PURE__ */ jsx12(EdActionCell2, { children: /* @__PURE__ */ jsx12(LinkButton4, { label: "Select", clicked: select }) })
  ] });
};
var BullhornJobSubmissionRow_default = BullhornJobSubmissionRow;

// src/bullhorn/components/job-submissions/__generated__/BullhornJobSubmissionListPaginationQuery.graphql.ts
var node24 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedOn": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornJobSubmissionListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "BullhornJobSubmissionList_bullhornJobSubmissions"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "BullhornJobSubmissionListPaginationQuery",
      "selections": [
        {
          "alias": null,
          "args": v3,
          "concreteType": "BullhornJobSubmissionsConnection",
          "kind": "LinkedField",
          "name": "bullhornJobSubmissions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BullhornJobSubmissionsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BullhornJobSubmission",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "source",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bullhornSyncStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bullhornJobSubmissionId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BullhornJobOrder",
                      "kind": "LinkedField",
                      "name": "jobOrder",
                      "plural": false,
                      "selections": [
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "title",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BullhornCandidate",
                      "kind": "LinkedField",
                      "name": "candidate",
                      "plural": false,
                      "selections": [
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "email",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recruitProfileId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recruitSyncStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "vaultProfileId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "vaultSyncStatus",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastErrorCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastErrorMessage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "BullhornJobSubmissionList_bullhornJobSubmissions",
          "kind": "LinkedHandle",
          "name": "bullhornJobSubmissions"
        }
      ]
    },
    "params": {
      "cacheID": "7ff3e4c5d2b6a8e9de4dc47c019006f7",
      "id": null,
      "metadata": {},
      "name": "BullhornJobSubmissionListPaginationQuery",
      "operationKind": "query",
      "text": "query BullhornJobSubmissionListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $tenantId: UUID!\n  $where: BullhornJobSubmissionFilter\n) {\n  ...BullhornJobSubmissionList_bullhornJobSubmissions_2HEEH6\n}\n\nfragment BullhornJobSubmissionList_bullhornJobSubmissions_2HEEH6 on Query {\n  bullhornJobSubmissions(tenantId: $tenantId, first: $first, after: $after, order: [{updatedOn: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        ...BullhornJobSubmissionRow_bullhornJobSubmission\n        __typename\n      }\n    }\n  }\n}\n\nfragment BullhornJobSubmissionRow_bullhornJobSubmission on BullhornJobSubmission {\n  id\n  createdOn\n  updatedOn\n  source\n  status\n  bullhornSyncStatus\n  bullhornJobSubmissionId\n  jobOrder {\n    id\n    title\n  }\n  candidate {\n    id\n    firstName\n    lastName\n    email\n    recruitProfileId\n    recruitSyncStatus\n    vaultProfileId\n    vaultSyncStatus\n  }\n  lastErrorCode\n  lastErrorMessage\n}\n"
    }
  };
}();
node24.hash = "9103de3f526cf1b54d4f43f292a38e62";
var BullhornJobSubmissionListPaginationQuery_graphql_default = node24;

// src/bullhorn/components/job-submissions/__generated__/BullhornJobSubmissionList_bullhornJobSubmissions.graphql.ts
var node25 = function() {
  var v0 = [
    "bullhornJobSubmissions"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "tenantId"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": BullhornJobSubmissionListPaginationQuery_graphql_default
      }
    },
    "name": "BullhornJobSubmissionList_bullhornJobSubmissions",
    "selections": [
      {
        "alias": "bullhornJobSubmissions",
        "args": null,
        "concreteType": "BullhornJobSubmissionsConnection",
        "kind": "LinkedField",
        "name": "__BullhornJobSubmissionList_bullhornJobSubmissions_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BullhornJobSubmissionsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BullhornJobSubmission",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BullhornJobSubmissionRow_bullhornJobSubmission"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node25.hash = "9103de3f526cf1b54d4f43f292a38e62";
var BullhornJobSubmissionList_bullhornJobSubmissions_graphql_default = node25;

// src/bullhorn/components/job-submissions/BullhornJobSubmissionList.tsx
import { useCallback as useCallback8 } from "react";
import { usePaginationFragment as usePaginationFragment2 } from "react-relay";
import { EdListHeader as EdListHeader2, EdTable as EdTable3 } from "shared-ui";
import { jsx as jsx13, jsxs as jsxs8 } from "react/jsx-runtime";
var columns3 = [
  { id: "candidate", name: "Candidate" },
  { id: "jobOrder", name: "Job Order" },
  { id: "bullhornSync", name: "Bullhorn Sync" },
  { id: "bullhornId", name: "Bullhorn Id" },
  { id: "source", name: "Source" },
  { id: "createdOn", name: "Created On" },
  { id: "updatedOn", name: "Updated On" },
  { id: "error", name: "Error" }
];
var fragment5 = BullhornJobSubmissionList_bullhornJobSubmissions_graphql_default;
var BullhornJobSubmissionList = ({
  onSelect,
  bullhornJobSubmissionsKey
}) => {
  const select = useCallback8((event) => {
    onSelect(event);
  }, []);
  const paging = usePaginationFragment2(fragment5, bullhornJobSubmissionsKey);
  const { data } = paging;
  const { bullhornJobSubmissions } = data;
  if (!bullhornJobSubmissions) {
    return /* @__PURE__ */ jsx13("div", { children: "Loading..." });
  }
  const { edges, totalCount } = bullhornJobSubmissions;
  const rows = edges?.map((e) => {
    return /* @__PURE__ */ jsx13(
      BullhornJobSubmissionRow_default,
      {
        bullhornJobSubmission: e.node,
        selected: select
      },
      e.node.id
    );
  });
  return /* @__PURE__ */ jsxs8("div", { children: [
    /* @__PURE__ */ jsx13(EdListHeader2, { total: totalCount, paging }),
    /* @__PURE__ */ jsx13("div", { className: "flex", children: /* @__PURE__ */ jsx13("div", { className: "w-full", children: /* @__PURE__ */ jsx13(EdTable3, { defaultColumns: columns3, rows }) }) })
  ] });
};
var BullhornJobSubmissionList_default = BullhornJobSubmissionList;

// src/bullhorn/components/job-submissions/__generated__/BullhornJobSubmissionsByJobOrderListPaginationQuery.graphql.ts
var node26 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "jobOrderId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedOn": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    },
    {
      "fields": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "eq",
              "variableName": "jobOrderId"
            }
          ],
          "kind": "ObjectValue",
          "name": "jobOrderId"
        }
      ],
      "kind": "ObjectValue",
      "name": "where"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornJobSubmissionsByJobOrderListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "BullhornJobSubmissionsByJobOrderList_bullhornJobSubmissions"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "BullhornJobSubmissionsByJobOrderListPaginationQuery",
      "selections": [
        {
          "alias": null,
          "args": v3,
          "concreteType": "BullhornJobSubmissionsConnection",
          "kind": "LinkedField",
          "name": "bullhornJobSubmissions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BullhornJobSubmissionsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BullhornJobSubmission",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "source",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bullhornSyncStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bullhornJobSubmissionId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BullhornJobOrder",
                      "kind": "LinkedField",
                      "name": "jobOrder",
                      "plural": false,
                      "selections": [
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "title",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BullhornCandidate",
                      "kind": "LinkedField",
                      "name": "candidate",
                      "plural": false,
                      "selections": [
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "firstName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "email",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recruitProfileId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recruitSyncStatus",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "vaultProfileId",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "vaultSyncStatus",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastErrorCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastErrorMessage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "BullhornJobSubmissionsByJobOrderList_bullhornJobSubmissions",
          "kind": "LinkedHandle",
          "name": "bullhornJobSubmissions"
        }
      ]
    },
    "params": {
      "cacheID": "3145dbd4329429a77c8244b2e96dda3f",
      "id": null,
      "metadata": {},
      "name": "BullhornJobSubmissionsByJobOrderListPaginationQuery",
      "operationKind": "query",
      "text": "query BullhornJobSubmissionsByJobOrderListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $jobOrderId: UUID\n  $tenantId: UUID!\n) {\n  ...BullhornJobSubmissionsByJobOrderList_bullhornJobSubmissions_2HEEH6\n}\n\nfragment BullhornJobSubmissionRow_bullhornJobSubmission on BullhornJobSubmission {\n  id\n  createdOn\n  updatedOn\n  source\n  status\n  bullhornSyncStatus\n  bullhornJobSubmissionId\n  jobOrder {\n    id\n    title\n  }\n  candidate {\n    id\n    firstName\n    lastName\n    email\n    recruitProfileId\n    recruitSyncStatus\n    vaultProfileId\n    vaultSyncStatus\n  }\n  lastErrorCode\n  lastErrorMessage\n}\n\nfragment BullhornJobSubmissionsByJobOrderList_bullhornJobSubmissions_2HEEH6 on Query {\n  bullhornJobSubmissions(tenantId: $tenantId, first: $first, after: $after, where: {jobOrderId: {eq: $jobOrderId}}, order: [{updatedOn: DESC}]) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        ...BullhornJobSubmissionRow_bullhornJobSubmission\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node26.hash = "bee125247f9b1f8eb372fc116ed63a2c";
var BullhornJobSubmissionsByJobOrderListPaginationQuery_graphql_default = node26;

// src/bullhorn/components/job-submissions/__generated__/BullhornJobSubmissionsByJobOrderList_bullhornJobSubmissions.graphql.ts
var node27 = function() {
  var v0 = [
    "bullhornJobSubmissions"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "jobOrderId"
      },
      {
        "kind": "RootArgument",
        "name": "tenantId"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": BullhornJobSubmissionsByJobOrderListPaginationQuery_graphql_default
      }
    },
    "name": "BullhornJobSubmissionsByJobOrderList_bullhornJobSubmissions",
    "selections": [
      {
        "alias": "bullhornJobSubmissions",
        "args": null,
        "concreteType": "BullhornJobSubmissionsConnection",
        "kind": "LinkedField",
        "name": "__BullhornJobSubmissionsByJobOrderList_bullhornJobSubmissions_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BullhornJobSubmissionsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BullhornJobSubmission",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BullhornJobSubmissionRow_bullhornJobSubmission"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node27.hash = "bee125247f9b1f8eb372fc116ed63a2c";
var BullhornJobSubmissionsByJobOrderList_bullhornJobSubmissions_graphql_default = node27;

// src/bullhorn/components/job-submissions/BullhornJobSubmissionsByJobOrderList.tsx
import { useCallback as useCallback9 } from "react";
import { usePaginationFragment as usePaginationFragment3 } from "react-relay";
import { EdListHeader as EdListHeader3, EdTable as EdTable4 } from "shared-ui";
import { jsx as jsx14, jsxs as jsxs9 } from "react/jsx-runtime";
var columns4 = [
  { id: "candidate", name: "Candidate" },
  { id: "jobOrder", name: "Job Order" },
  { id: "bullhorn", name: "Bullhorn" },
  { id: "source", name: "Source" },
  { id: "createdOn", name: "Created On" },
  { id: "updatedOn", name: "Updated On" },
  { id: "error", name: "Error" }
];
var fragment6 = BullhornJobSubmissionsByJobOrderList_bullhornJobSubmissions_graphql_default;
var BullhornJobSubmissionsByJobOrderList = ({
  onSelect,
  bullhornJobSubmissionsKey
}) => {
  const select = useCallback9((event) => {
    onSelect(event);
  }, []);
  const paging = usePaginationFragment3(fragment6, bullhornJobSubmissionsKey);
  const { data } = paging;
  const { bullhornJobSubmissions } = data;
  const rows = bullhornJobSubmissions?.edges?.map((e) => {
    return /* @__PURE__ */ jsx14(
      BullhornJobSubmissionRow_default,
      {
        bullhornJobSubmission: e.node,
        selected: select
      },
      e.node.id
    );
  });
  return /* @__PURE__ */ jsxs9("div", { children: [
    /* @__PURE__ */ jsx14(
      EdListHeader3,
      {
        total: bullhornJobSubmissions?.totalCount,
        paging
      }
    ),
    /* @__PURE__ */ jsx14("div", { className: "flex", children: /* @__PURE__ */ jsx14("div", { className: "w-full", children: /* @__PURE__ */ jsx14(EdTable4, { defaultColumns: columns4, rows }) }) })
  ] });
};
var BullhornJobSubmissionsByJobOrderList_default = BullhornJobSubmissionsByJobOrderList;

// src/bullhorn/components/job-orders/BullhornJobOrderJobSubmissionsList.tsx
import { jsx as jsx15 } from "react/jsx-runtime";
var graphqlQuery = BullhornJobOrderJobSubmissionsListQuery_graphql_default;
var BullhornJobOrderJobSubmissionsList = ({
  onSelect,
  tenant,
  jobOrderId
}) => {
  const select = useCallback10((event) => {
    onSelect(event);
  }, []);
  const { tenantId } = tenant;
  const query3 = useLazyLoadQuery(
    graphqlQuery,
    { tenantId, jobOrderId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx15(Suspense, { fallback: /* @__PURE__ */ jsx15(EdSkeleton, {}), children: /* @__PURE__ */ jsx15(
    BullhornJobSubmissionsByJobOrderList_default,
    {
      onSelect,
      bullhornJobSubmissionsKey: query3
    }
  ) });
};
var BullhornJobOrderJobSubmissionsList_default = BullhornJobOrderJobSubmissionsList;

// src/bullhorn/components/job-orders/__generated__/BullhornJobOrderDetail_bullhornJobOrder.graphql.ts
var node28 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BullhornJobOrderDetail_bullhornJobOrder",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobOrderId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bullhornJobOrderId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vacancySyncStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vacancyStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vacancyId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dateAdded",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BullhornPerson",
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BullhornJobOrderCustomFields_bullhornJobOrder"
    }
  ],
  "type": "BullhornJobOrder",
  "abstractKey": null
};
node28.hash = "653fe1b0e6caf0bc61f870dc1ad35d20";
var BullhornJobOrderDetail_bullhornJobOrder_graphql_default = node28;

// src/bullhorn/components/job-orders/BullhornJobOrderDetail.tsx
import { Fragment as Fragment5, useContext } from "react";
import { useFragment as useFragment7 } from "react-relay";
import { formatDateTime as formatDateTime2, GlobalSettingsContext, useToggle as useToggle2 } from "shared-lib";
import {
  AuditFields as AuditFields3,
  DescriptionItem as DescriptionItem3,
  DescriptionList as DescriptionList3,
  HtmlDisplay,
  LinkButton as LinkButton5
} from "shared-ui";

// src/bullhorn/components/job-orders/__generated__/BullhornJobOrderCustomFields_bullhornJobOrder.graphql.ts
var node29 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BullhornJobOrderCustomFields_bullhornJobOrder",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobOrderId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BullhornJobOrderCustomData",
      "kind": "LinkedField",
      "name": "customData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText3",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText4",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText5",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText6",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText7",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText8",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText9",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText10",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText11",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText12",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText13",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText14",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText15",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText16",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText17",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText18",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText19",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText20",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText21",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText22",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText23",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText24",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText25",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText26",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText27",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText28",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText29",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText30",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText31",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText32",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText33",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText34",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText35",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText36",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText37",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText38",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText39",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customText40",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customDate1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customDate2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customDate3",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt3",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt4",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt5",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt6",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt7",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customInt8",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customFloat3",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customTextBlock1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customTextBlock2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customTextBlock3",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customTextBlock4",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customTextBlock5",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomText1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomText2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomText3",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomText4",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomText5",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomText6",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomText7",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomText8",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomText9",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomText10",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomFloat1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomFloat2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomFloat3",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomDate1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomDate2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomDate3",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomInt1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomInt2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomInt3",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomTextBlock1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomTextBlock2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correlatedCustomTextBlock3",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BullhornJobOrder",
  "abstractKey": null
};
node29.hash = "2b0ffbfc4988118771eaf20cef364e65";
var BullhornJobOrderCustomFields_bullhornJobOrder_graphql_default = node29;

// src/bullhorn/components/job-orders/BullhornJobOrderCustomFields.tsx
import { Fragment as Fragment4, useState as useState2 } from "react";
import { useFragment as useFragment6 } from "react-relay";
import {
  EdColumnCell as EdColumnCell4,
  EdRow as EdRow4,
  EdTable as EdTable5,
  Input as Input2
} from "shared-ui";
import { isNotNull as isNotNull2 } from "shared-lib";
import { jsx as jsx16, jsxs as jsxs10 } from "react/jsx-runtime";
var fragment7 = BullhornJobOrderCustomFields_bullhornJobOrder_graphql_default;
var columns5 = [
  { id: "Name", name: "Name" },
  { id: "Value", name: "Value" }
];
function displayList2(list) {
  if (list == null || list.length == 0) {
    return "";
  }
  return list.filter(isNotNull2).map((i) => i.toString()).join(",");
}
var BullhornJobOrderCustomFields = ({
  bullhornJobOrder: bullhornJobOrder4
}) => {
  const data = useFragment6(
    fragment7,
    bullhornJobOrder4
  );
  const [filterText, setFilterText] = useState2(null);
  const fields = [
    {
      id: 1,
      label: "Custom Text 1",
      value: displayList2(data.customData.customText1)
    },
    {
      id: 2,
      label: "Custom Text 2",
      value: displayList2(data.customData.customText2)
    },
    {
      id: 3,
      label: "Custom Text 3",
      value: displayList2(data.customData.customText3)
    },
    {
      id: 4,
      label: "Custom Text 4",
      value: displayList2(data.customData.customText4)
    },
    {
      id: 5,
      label: "Custom Text 5",
      value: displayList2(data.customData.customText5)
    },
    {
      id: 6,
      label: "Custom Text 6",
      value: displayList2(data.customData.customText6)
    },
    {
      id: 7,
      label: "Custom Text 7",
      value: displayList2(data.customData.customText7)
    },
    {
      id: 8,
      label: "Custom Text 8",
      value: displayList2(data.customData.customText8)
    },
    {
      id: 9,
      label: "Custom Text 9",
      value: displayList2(data.customData.customText9)
    },
    {
      id: 10,
      label: "Custom Text 10",
      value: displayList2(data.customData.customText10)
    },
    {
      id: 11,
      label: "Custom Text 11",
      value: displayList2(data.customData.customText11)
    },
    {
      id: 12,
      label: "Custom Text 12",
      value: displayList2(data.customData.customText12)
    },
    {
      id: 13,
      label: "Custom Text 13",
      value: displayList2(data.customData.customText13)
    },
    {
      id: 14,
      label: "Custom Text 14",
      value: displayList2(data.customData.customText14)
    },
    {
      id: 15,
      label: "Custom Text 15",
      value: displayList2(data.customData.customText15)
    },
    {
      id: 16,
      label: "Custom Text 16",
      value: displayList2(data.customData.customText16)
    },
    {
      id: 17,
      label: "Custom Text 17",
      value: displayList2(data.customData.customText17)
    },
    {
      id: 18,
      label: "Custom Text 18",
      value: displayList2(data.customData.customText18)
    },
    {
      id: 19,
      label: "Custom Text 19",
      value: displayList2(data.customData.customText19)
    },
    {
      id: 20,
      label: "Custom Text 20",
      value: displayList2(data.customData.customText20)
    },
    {
      id: 21,
      label: "Custom Text 21",
      value: displayList2(data.customData.customText21)
    },
    {
      id: 22,
      label: "Custom Text 22",
      value: displayList2(data.customData.customText22)
    },
    {
      id: 23,
      label: "Custom Text 23",
      value: displayList2(data.customData.customText23)
    },
    {
      id: 24,
      label: "Custom Text 24",
      value: displayList2(data.customData.customText24)
    },
    {
      id: 25,
      label: "Custom Text 25",
      value: displayList2(data.customData.customText25)
    },
    {
      id: 26,
      label: "Custom Text 26",
      value: displayList2(data.customData.customText26)
    },
    {
      id: 27,
      label: "Custom Text 27",
      value: displayList2(data.customData.customText27)
    },
    {
      id: 28,
      label: "Custom Text 28",
      value: displayList2(data.customData.customText28)
    },
    {
      id: 29,
      label: "Custom Text 29",
      value: displayList2(data.customData.customText29)
    },
    {
      id: 30,
      label: "Custom Text 30",
      value: displayList2(data.customData.customText30)
    },
    {
      id: 31,
      label: "Custom Text 31",
      value: displayList2(data.customData.customText31)
    },
    {
      id: 32,
      label: "Custom Text 32",
      value: displayList2(data.customData.customText32)
    },
    {
      id: 33,
      label: "Custom Text 33",
      value: displayList2(data.customData.customText33)
    },
    {
      id: 34,
      label: "Custom Text 34",
      value: displayList2(data.customData.customText34)
    },
    {
      id: 35,
      label: "Custom Text 35",
      value: displayList2(data.customData.customText35)
    },
    {
      id: 36,
      label: "Custom Text 36",
      value: displayList2(data.customData.customText36)
    },
    {
      id: 37,
      label: "Custom Text 37",
      value: displayList2(data.customData.customText37)
    },
    {
      id: 38,
      label: "Custom Text 38",
      value: displayList2(data.customData.customText38)
    },
    {
      id: 39,
      label: "Custom Text 39",
      value: displayList2(data.customData.customText39)
    },
    {
      id: 40,
      label: "Custom Text 40",
      value: displayList2(data.customData.customText40)
    },
    {
      id: 41,
      label: "Custom Date 1",
      value: displayList2(data.customData.customDate1)
    },
    {
      id: 42,
      label: "Custom Date 2",
      value: displayList2(data.customData.customDate2)
    },
    {
      id: 43,
      label: "Custom Date 3",
      value: displayList2(data.customData.customDate3)
    },
    {
      id: 44,
      label: "Custom Int 1",
      value: displayList2(data.customData.customInt1)
    },
    {
      id: 45,
      label: "Custom Int 2",
      value: displayList2(data.customData.customInt2)
    },
    {
      id: 46,
      label: "Custom Int 3",
      value: displayList2(data.customData.customInt3)
    },
    {
      id: 47,
      label: "Custom Int 4",
      value: displayList2(data.customData.customInt4)
    },
    {
      id: 48,
      label: "Custom Int 5",
      value: displayList2(data.customData.customInt5)
    },
    {
      id: 49,
      label: "Custom Int 6",
      value: displayList2(data.customData.customInt6)
    },
    {
      id: 50,
      label: "Custom Int 7",
      value: displayList2(data.customData.customInt7)
    },
    {
      id: 51,
      label: "Custom Int 8",
      value: displayList2(data.customData.customInt8)
    },
    {
      id: 52,
      label: "Custom Float 1",
      value: displayList2(data.customData.customFloat1)
    },
    {
      id: 53,
      label: "Custom Float 2",
      value: displayList2(data.customData.customFloat2)
    },
    {
      id: 54,
      label: "Custom Float 3",
      value: displayList2(data.customData.customFloat3)
    },
    {
      id: 55,
      label: "Custom Text Block 1",
      value: displayList2(data.customData.customTextBlock1)
    },
    {
      id: 56,
      label: "Custom Text Block 2",
      value: displayList2(data.customData.customTextBlock2)
    },
    {
      id: 57,
      label: "Custom Text Block 3",
      value: displayList2(data.customData.customTextBlock3)
    },
    {
      id: 58,
      label: "Custom Text Block 4",
      value: displayList2(data.customData.customTextBlock4)
    },
    {
      id: 59,
      label: "Custom Text Block 5",
      value: displayList2(data.customData.customTextBlock5)
    },
    {
      id: 60,
      label: "Correlated Custom Text 1",
      value: displayList2(data.customData.correlatedCustomText1)
    },
    {
      id: 61,
      label: "Correlated Custom Text 2",
      value: displayList2(data.customData.correlatedCustomText2)
    },
    {
      id: 62,
      label: "Correlated Custom Text 3",
      value: displayList2(data.customData.correlatedCustomText3)
    },
    {
      id: 63,
      label: "Correlated Custom Text 4",
      value: displayList2(data.customData.correlatedCustomText4)
    },
    {
      id: 64,
      label: "Correlated Custom Text 5",
      value: displayList2(data.customData.correlatedCustomText5)
    },
    {
      id: 65,
      label: "Correlated Custom Text 6",
      value: displayList2(data.customData.correlatedCustomText6)
    },
    {
      id: 66,
      label: "Correlated Custom Text 7",
      value: displayList2(data.customData.correlatedCustomText7)
    },
    {
      id: 67,
      label: "Correlated Custom Text 8",
      value: displayList2(data.customData.correlatedCustomText8)
    },
    {
      id: 68,
      label: "Correlated Custom Text 9",
      value: displayList2(data.customData.correlatedCustomText9)
    },
    {
      id: 69,
      label: "Correlated Custom Text 10",
      value: displayList2(data.customData.correlatedCustomText10)
    },
    {
      id: 70,
      label: "Correlated Custom Float 1",
      value: displayList2(data.customData.correlatedCustomFloat1)
    },
    {
      id: 71,
      label: "Correlated Custom Float 2",
      value: displayList2(data.customData.correlatedCustomFloat2)
    },
    {
      id: 72,
      label: "Correlated Custom Float 3",
      value: displayList2(data.customData.correlatedCustomFloat3)
    },
    {
      id: 73,
      label: "Correlated Custom Date 1",
      value: displayList2(data.customData.correlatedCustomDate1)
    },
    {
      id: 74,
      label: "Correlated Custom Date 2",
      value: displayList2(data.customData.correlatedCustomDate2)
    },
    {
      id: 75,
      label: "Correlated Custom Date 3",
      value: displayList2(data.customData.correlatedCustomDate3)
    },
    {
      id: 76,
      label: "Correlated Custom Int 1",
      value: displayList2(data.customData.correlatedCustomInt1)
    },
    {
      id: 77,
      label: "Correlated Custom Int 2",
      value: displayList2(data.customData.correlatedCustomInt2)
    },
    {
      id: 78,
      label: "Correlated Custom Int 3",
      value: displayList2(data.customData.correlatedCustomInt3)
    },
    {
      id: 79,
      label: "Correlated Custom Text Block 1",
      value: displayList2(data.customData.correlatedCustomTextBlock1)
    },
    {
      id: 80,
      label: "Correlated Custom Text Block 2",
      value: displayList2(data.customData.correlatedCustomTextBlock2)
    },
    {
      id: 81,
      label: "Correlated Custom Text Block 3",
      value: displayList2(data.customData.correlatedCustomTextBlock3)
    }
  ];
  const filteredFields = fields.filter((f) => {
    if (filterText === null) {
      return true;
    }
    return f.label.toLocaleLowerCase().includes(filterText.toLocaleLowerCase());
  });
  const rows = filteredFields.map((field) => {
    return /* @__PURE__ */ jsxs10(EdRow4, { rowKey: field.id.toString(), children: [
      /* @__PURE__ */ jsx16(EdColumnCell4, { children: field.label }),
      /* @__PURE__ */ jsx16(EdColumnCell4, { children: field.value })
    ] }, field.id);
  });
  return /* @__PURE__ */ jsxs10(Fragment4, { children: [
    /* @__PURE__ */ jsx16("div", { className: "flex items-center space-x-4", children: /* @__PURE__ */ jsxs10("div", { className: "flex items-center space-x-4 p-2", children: [
      /* @__PURE__ */ jsx16("label", { className: "text-gray-700", htmlFor: "filter", children: "Filter" }),
      /* @__PURE__ */ jsx16("div", { className: "sm:w-64", children: /* @__PURE__ */ jsx16(
        Input2,
        {
          placeholder: " Filter by Name  ",
          name: "filter",
          onValueChange: (filter) => setFilterText(filter)
        },
        "filter"
      ) })
    ] }) }),
    /* @__PURE__ */ jsx16(
      EdTable5,
      {
        fixedHeight: false,
        defaultColumns: columns5,
        rows
      }
    )
  ] });
};

// src/bullhorn/components/job-orders/BullhornJobOrderDetail.tsx
import { jsx as jsx17, jsxs as jsxs11 } from "react/jsx-runtime";
var fragment8 = BullhornJobOrderDetail_bullhornJobOrder_graphql_default;
function vacancyLink(host, employerId, vacancyId) {
  return `https://${host}/admin.app/recruit/vacancies/${employerId}/vacancy/${vacancyId}/wizard`;
}
var BullhornJobOrderDetail = ({
  employerId,
  bullhornJobOrder: bullhornJobOrder4,
  actions
}) => {
  const settings = useContext(GlobalSettingsContext);
  const data = useFragment7(
    fragment8,
    bullhornJobOrder4
  );
  const [showDescription, toggleDescription] = useToggle2();
  const [showCustomFields, toggleCustomFields] = useToggle2();
  return /* @__PURE__ */ jsx17("div", { className: "flex", children: /* @__PURE__ */ jsx17(
    DescriptionList3,
    {
      classes: "sm:w-1/3 md:w-2/3",
      heading: /* @__PURE__ */ jsx17("span", { className: "text-info-600", children: "Job Order" }),
      description: /* @__PURE__ */ jsxs11("div", { className: "mt-4", children: [
        /* @__PURE__ */ jsx17("div", { className: "mb-3 mt-2 text-gray-900", children: data.title }),
        /* @__PURE__ */ jsx17(
          AuditFields3,
          {
            createdOn: data.createdOn,
            updatedOn: data.updatedOn
          }
        )
      ] }),
      items: /* @__PURE__ */ jsxs11(Fragment5, { children: [
        actions,
        /* @__PURE__ */ jsx17(DescriptionItem3, { label: "Date Added", children: formatDateTime2(data.dateAdded) }),
        data.owner && /* @__PURE__ */ jsx17(DescriptionItem3, { label: "Owner", children: /* @__PURE__ */ jsxs11("div", { className: "flex items-center space-x-2", children: [
          /* @__PURE__ */ jsx17("div", { children: data.owner.firstName }),
          /* @__PURE__ */ jsx17("div", { children: data.owner.lastName }),
          /* @__PURE__ */ jsxs11("div", { className: "text-info-500 font-medium", children: [
            "(",
            data.owner.userId,
            ")"
          ] })
        ] }) }),
        /* @__PURE__ */ jsx17(DescriptionItem3, { label: "Sync Status", children: data.vacancySyncStatus }),
        /* @__PURE__ */ jsx17(DescriptionItem3, { label: "Bullhorn Id", children: data.bullhornJobOrderId }),
        data.vacancyStatus && /* @__PURE__ */ jsx17(DescriptionItem3, { label: "Status", children: data.vacancyStatus }),
        data.vacancyId && /* @__PURE__ */ jsx17(DescriptionItem3, { label: "Vacancy", children: /* @__PURE__ */ jsx17(
          "a",
          {
            className: "text-info-500 font-medium",
            target: "_blank",
            rel: "noreferrer",
            href: vacancyLink(
              settings.identityServerServerHost,
              employerId,
              data.vacancyId
            ),
            children: "Vacancy"
          }
        ) }),
        /* @__PURE__ */ jsx17(DescriptionItem3, { label: "Description", children: /* @__PURE__ */ jsx17("div", { children: /* @__PURE__ */ jsxs11(LinkButton5, { clicked: toggleDescription, children: [
          showDescription && /* @__PURE__ */ jsx17("span", { children: "Hide Description" }),
          !showDescription && /* @__PURE__ */ jsx17("span", { children: "View Description" })
        ] }) }) }),
        /* @__PURE__ */ jsx17("div", { children: showDescription && /* @__PURE__ */ jsx17("div", { className: "prose-xl mt-4 bg-white p-6", children: /* @__PURE__ */ jsx17(HtmlDisplay, { html: data.description }) }) }),
        /* @__PURE__ */ jsx17(DescriptionItem3, { label: "Custom Fields", children: /* @__PURE__ */ jsx17("div", { children: /* @__PURE__ */ jsxs11(LinkButton5, { clicked: toggleCustomFields, children: [
          showCustomFields && /* @__PURE__ */ jsx17("span", { children: "Hide Custom Fields" }),
          !showCustomFields && /* @__PURE__ */ jsx17("span", { children: "View Custom Fields" })
        ] }) }) }),
        /* @__PURE__ */ jsx17("div", { children: showCustomFields && /* @__PURE__ */ jsx17(BullhornJobOrderCustomFields, { bullhornJobOrder: data }) })
      ] })
    }
  ) });
};
var BullhornJobOrderDetail_default = BullhornJobOrderDetail;

// src/bullhorn/components/job-orders/__generated__/BullhornJobOrderRow_bullhornJobOrder.graphql.ts
var node30 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "BullhornJobOrderRow_bullhornJobOrder",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jobOrderId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bullhornJobOrderId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dateAdded",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vacancySyncStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BullhornJobSubmission",
        "kind": "LinkedField",
        "name": "jobSubmissions",
        "plural": true,
        "selections": [
          v0
        ],
        "storageKey": null
      }
    ],
    "type": "BullhornJobOrder",
    "abstractKey": null
  };
}();
node30.hash = "0621780fd619f43d98e6053f05afb4d7";
var BullhornJobOrderRow_bullhornJobOrder_graphql_default = node30;

// src/bullhorn/components/job-orders/BullhornJobOrderRow.tsx
import { useCallback as useCallback11 } from "react";
import { useFragment as useFragment8 } from "react-relay";
import { EdActionCell as EdActionCell3, EdColumnCell as EdColumnCell5, EdRow as EdRow5, LinkButton as LinkButton6 } from "shared-ui";
import { formatDateTime as formatDateTime3 } from "shared-lib";
import { jsx as jsx18, jsxs as jsxs12 } from "react/jsx-runtime";
var bullhornJobOrder = BullhornJobOrderRow_bullhornJobOrder_graphql_default;
var BullhornJobOrderRow = (props) => {
  const data = useFragment8(bullhornJobOrder, props.bullhornJobOrder);
  const select = useCallback11(() => {
    props.selected(data);
  }, []);
  return /* @__PURE__ */ jsxs12(EdRow5, { clicked: select, rowKey: data.id, children: [
    /* @__PURE__ */ jsx18(EdColumnCell5, { children: data.title }),
    /* @__PURE__ */ jsx18(EdColumnCell5, { children: data.bullhornJobOrderId }),
    /* @__PURE__ */ jsx18(EdColumnCell5, { children: formatDateTime3(data.dateAdded) }),
    /* @__PURE__ */ jsx18(EdColumnCell5, { children: formatDateTime3(data.updatedOn) }),
    /* @__PURE__ */ jsx18(EdColumnCell5, { children: data.jobSubmissions.length }),
    /* @__PURE__ */ jsx18(EdColumnCell5, { children: data.vacancySyncStatus }),
    /* @__PURE__ */ jsx18(EdColumnCell5, { children: data.status }),
    /* @__PURE__ */ jsx18(EdActionCell3, { children: /* @__PURE__ */ jsx18(LinkButton6, { label: "Select", clicked: select }) })
  ] });
};
var BullhornJobOrderRow_default = BullhornJobOrderRow;

// src/bullhorn/components/job-orders/__generated__/BullhornJobOrderListPaginationQuery.graphql.ts
var node31 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornJobOrderListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "BullhornJobOrderList_bullhornJobOrders"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "BullhornJobOrderListPaginationQuery",
      "selections": [
        {
          "alias": null,
          "args": v3,
          "concreteType": "BullhornJobOrdersConnection",
          "kind": "LinkedField",
          "name": "bullhornJobOrders",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BullhornJobOrdersEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BullhornJobOrder",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobOrderId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "dateAdded",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vacancySyncStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bullhornJobOrderId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BullhornJobSubmission",
                      "kind": "LinkedField",
                      "name": "jobSubmissions",
                      "plural": true,
                      "selections": [
                        v4
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "BullhornJobOrderList_bullhornJobOrders",
          "kind": "LinkedHandle",
          "name": "bullhornJobOrders"
        }
      ]
    },
    "params": {
      "cacheID": "997c83eb700fa6584abc57adc8be2729",
      "id": null,
      "metadata": {},
      "name": "BullhornJobOrderListPaginationQuery",
      "operationKind": "query",
      "text": "query BullhornJobOrderListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $order: [BullhornJobOrderSort!]\n  $tenantId: UUID!\n  $where: BullhornJobOrderFilter\n) {\n  ...BullhornJobOrderList_bullhornJobOrders_2HEEH6\n}\n\nfragment BullhornJobOrderList_bullhornJobOrders_2HEEH6 on Query {\n  bullhornJobOrders(tenantId: $tenantId, first: $first, after: $after, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        jobOrderId\n        dateAdded\n        updatedOn\n        title\n        status\n        vacancySyncStatus\n        ...BullhornJobOrderRow_bullhornJobOrder\n        __typename\n      }\n    }\n  }\n}\n\nfragment BullhornJobOrderRow_bullhornJobOrder on BullhornJobOrder {\n  id\n  jobOrderId\n  bullhornJobOrderId\n  dateAdded\n  updatedOn\n  title\n  status\n  vacancySyncStatus\n  jobSubmissions {\n    id\n  }\n}\n"
    }
  };
}();
node31.hash = "1a02cc542dfafbb058a359410a3607dc";
var BullhornJobOrderListPaginationQuery_graphql_default = node31;

// src/bullhorn/components/job-orders/__generated__/BullhornJobOrderList_bullhornJobOrders.graphql.ts
var node32 = function() {
  var v0 = [
    "bullhornJobOrders"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "order"
      },
      {
        "kind": "RootArgument",
        "name": "tenantId"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": BullhornJobOrderListPaginationQuery_graphql_default
      }
    },
    "name": "BullhornJobOrderList_bullhornJobOrders",
    "selections": [
      {
        "alias": "bullhornJobOrders",
        "args": null,
        "concreteType": "BullhornJobOrdersConnection",
        "kind": "LinkedField",
        "name": "__BullhornJobOrderList_bullhornJobOrders_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BullhornJobOrdersEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BullhornJobOrder",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "jobOrderId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dateAdded",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vacancySyncStatus",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BullhornJobOrderRow_bullhornJobOrder"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node32.hash = "1a02cc542dfafbb058a359410a3607dc";
var BullhornJobOrderList_bullhornJobOrders_graphql_default = node32;

// src/bullhorn/components/job-orders/BullhornJobOrderList.tsx
import { useCallback as useCallback12 } from "react";
import { usePaginationFragment as usePaginationFragment4 } from "react-relay";
import {
  EdListHeader as EdListHeader4,
  EdTable as EdTable6,
  selectColumn,
  SortDir
} from "shared-ui";
import { jsx as jsx19, jsxs as jsxs13 } from "react/jsx-runtime";
var defaultColumns = [
  { id: "title", name: "Title" },
  { id: "bullhornId", name: "Bullhorn Id" },
  { id: "dateAdded", name: "Date Added", sort: true },
  {
    id: "updatedOn",
    name: "Last Elevate Update",
    sort: true,
    sortValue: SortDir.Desc
  },
  { id: "submissions", name: "Submissions" },
  { id: "vacancySync", name: "Vacancy Sync" },
  { id: "status", name: "Status" }
];
var fragment9 = BullhornJobOrderList_bullhornJobOrders_graphql_default;
var BullhornJobOrderList = ({
  onSelect,
  bullhornJobOrdersKey
}) => {
  const rowSelected = useCallback12(
    (e) => {
      onSelect({
        id: e.jobOrderId
      });
    },
    []
  );
  const paging = usePaginationFragment4(fragment9, bullhornJobOrdersKey);
  const onSortChanged = useCallback12((columns14) => {
    const hasOrderBy = columns14.filter((c) => c.sort && c.sortValue).length > 0;
    if (hasOrderBy === false) {
      return;
    }
    const orderBy = [];
    const dateAdded = selectColumn("dateAdded", columns14);
    if (dateAdded) {
      orderBy.push({ dateAdded });
    }
    const updatedOn = selectColumn("updatedOn", columns14);
    if (updatedOn) {
      orderBy.push({ updatedOn });
    }
    refetch(
      { first: 10, order: orderBy },
      {
        fetchPolicy: "network-only",
        onComplete: (e) => {
          if (e) {
            console.error(e);
          } else {
            console.log("changed sort on job order list");
          }
        }
      }
    );
  }, []);
  const { data, refetch } = paging;
  const rows = data.bullhornJobOrders?.edges?.map((e) => {
    return /* @__PURE__ */ jsx19(
      BullhornJobOrderRow_default,
      {
        bullhornJobOrder: e.node,
        selected: rowSelected
      },
      e.node.id
    );
  });
  return /* @__PURE__ */ jsxs13("div", { children: [
    /* @__PURE__ */ jsx19(
      EdListHeader4,
      {
        total: data.bullhornJobOrders?.totalCount,
        paging
      }
    ),
    /* @__PURE__ */ jsx19("div", { className: "flex", children: /* @__PURE__ */ jsx19("div", { className: "w-full", children: /* @__PURE__ */ jsx19(
      EdTable6,
      {
        defaultColumns,
        rows,
        onSortChanged
      }
    ) }) })
  ] });
};
var BullhornJobOrderList_default = BullhornJobOrderList;

// src/bullhorn/components/job-orders/CreateJobSubmissionsButton.tsx
import { useCallback as useCallback13 } from "react";
import { ConnectionHandler as ConnectionHandler5, useRelayEnvironment as useRelayEnvironment5 } from "react-relay";
import { Button as Button5 } from "shared-ui";
import { jsx as jsx20 } from "react/jsx-runtime";
var CreateJobSubmissionsButton = (props) => {
  const { title, onDone, jobOrderId, ...rest } = props;
  const environment = useRelayEnvironment5();
  const connectionId = ConnectionHandler5.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "BullhornJobOrderList_bullhornJobOrders"
  );
  const createJobSubmissionsEvent = useCallback13(() => {
    if (!jobOrderId) {
      return;
    }
    const input = {
      id: jobOrderId
    };
    CreateJobSubmissionsMutation_default.commit(
      environment,
      input,
      connectionId,
      (response) => {
        onDone(response);
      }
    );
  }, []);
  return /* @__PURE__ */ jsx20(Button5, { clicked: createJobSubmissionsEvent, ...rest, children: title ? title : "Create Job Submissions" });
};

// src/bullhorn/components/job-orders/SyncJobOrderButton.tsx
import { useCallback as useCallback14 } from "react";
import { ConnectionHandler as ConnectionHandler6, useRelayEnvironment as useRelayEnvironment6 } from "react-relay";
import { Button as Button6 } from "shared-ui";
import { jsx as jsx21 } from "react/jsx-runtime";
var SyncJobOrderButton = (props) => {
  const { title, onDone, jobOrderId, ...rest } = props;
  const environment = useRelayEnvironment6();
  const connectionId = ConnectionHandler6.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "BullhornJobOrderList_bullhornJobOrders"
  );
  const syncJobOrderEvent = useCallback14(() => {
    if (!jobOrderId) {
      return;
    }
    const input = {
      id: jobOrderId
    };
    SyncJobOrderMutation_default.commit(environment, input, connectionId, () => {
      onDone();
    });
  }, []);
  return /* @__PURE__ */ jsx21(Button6, { clicked: syncJobOrderEvent, ...rest, children: title ? title : "Sync To Elevate" });
};

// src/bullhorn/components/job-orders/SubmitPendingJobSubmissionsButton.tsx
import { useCallback as useCallback15 } from "react";
import { ConnectionHandler as ConnectionHandler7, useRelayEnvironment as useRelayEnvironment7 } from "react-relay";
import { createUUID } from "shared-lib";
import { Button as Button7 } from "shared-ui";
import { jsx as jsx22 } from "react/jsx-runtime";
var SubmitPendingJobSubmissionsButton = (props) => {
  const { title, onDone, jobOrderId, ...rest } = props;
  const environment = useRelayEnvironment7();
  const connectionId = ConnectionHandler7.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "BullhornJobOrderList_bullhornJobOrders"
  );
  const syncJobOrderEvent = useCallback15(() => {
    if (!jobOrderId) {
      return;
    }
    const input = {
      id: jobOrderId,
      clientMutationId: createUUID()
    };
    SubmitPendingJobSubmissionsMutation_default.commit(
      environment,
      input,
      connectionId,
      () => {
        onDone();
      }
    );
  }, []);
  return /* @__PURE__ */ jsx22(Button7, { clicked: syncJobOrderEvent, ...rest, children: title ? title : "Submit Pending Job Submissions" });
};

// src/bullhorn/components/job-orders/RefreshJobOrderButton.tsx
import { useCallback as useCallback16 } from "react";
import { ConnectionHandler as ConnectionHandler8, useRelayEnvironment as useRelayEnvironment8 } from "react-relay";
import { Button as Button8 } from "shared-ui";
import { jsx as jsx23 } from "react/jsx-runtime";
var RefreshJobOrderButton = (props) => {
  const { title, onDone, jobOrderId, ...rest } = props;
  const environment = useRelayEnvironment8();
  const connectionId = ConnectionHandler8.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "BullhornJobOrderList_bullhornJobOrders"
  );
  const createJobSubmissionsEvent = useCallback16(() => {
    if (!jobOrderId) {
      return;
    }
    const input = {
      id: jobOrderId
    };
    RefreshJobOrderMutation_default.commit(
      environment,
      input,
      connectionId,
      (response) => {
        onDone(response);
      }
    );
  }, []);
  return /* @__PURE__ */ jsx23(Button8, { clicked: createJobSubmissionsEvent, ...rest, children: title ? title : "Refresh Job Order" });
};

// src/bullhorn/components/job-orders/FetchJobOrderButton.tsx
import { useCallback as useCallback17 } from "react";
import { ConnectionHandler as ConnectionHandler9, useRelayEnvironment as useRelayEnvironment9 } from "react-relay";
import { Button as Button9 } from "shared-ui";
import { jsx as jsx24 } from "react/jsx-runtime";
var FetchJobOrderButton = (props) => {
  const { title, onDone, onFail, jobOrderId, tenantId, ...rest } = props;
  const environment = useRelayEnvironment9();
  const connectionId = ConnectionHandler9.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "BullhornJobOrderList_bullhornJobOrders"
  );
  const fetchJobOrderEvent = useCallback17(() => {
    if (!jobOrderId) {
      return;
    }
    const input = {
      jobOrderId,
      tenantId
    };
    FetchJobOrderMutation_default.commit(
      environment,
      input,
      connectionId,
      () => {
        onDone();
      },
      (error) => {
        onFail(error);
      }
    );
  }, []);
  return /* @__PURE__ */ jsx24(Button9, { clicked: fetchJobOrderEvent, ...rest, children: title ? title : "Fetch To Elevate" });
};

// src/bullhorn/components/job-orders/JobOrderDownloadForm.tsx
import { useCallback as useCallback18, useState as useState3 } from "react";
import { ConnectionHandler as ConnectionHandler10, useRelayEnvironment as useRelayEnvironment10 } from "react-relay";
import { useForm } from "react-hook-form";
import { Button as Button10, ButtonList, FormRow } from "shared-ui";
import { jsx as jsx25, jsxs as jsxs14 } from "react/jsx-runtime";
var resolver = async (values) => {
  let errors = {};
  if (!values.jobOrderId) {
    errors = {
      ...errors,
      jobOrderId: {
        type: "required",
        message: "This is required."
      }
    };
  }
  return {
    values: {
      jobOrderId: values.jobOrderId
    },
    errors
  };
};
var JobOrderDownloadForm = ({
  onDone,
  onFail,
  tenantId
}) => {
  const environment = useRelayEnvironment10();
  const [error, setError] = useState3(
    null
  );
  const connectionId = ConnectionHandler10.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "BullhornJobOrderList_bullhornJobOrders"
  );
  const fetchJobOrder = useCallback18((form) => {
    if (!form.jobOrderId) {
      return;
    }
    const input = {
      jobOrderId: parseInt(form.jobOrderId),
      tenantId
    };
    FetchJobOrderMutation_default.commit(
      environment,
      input,
      connectionId,
      ({ command }) => {
        if (command.errors && command.errors && command.errors.length > 0) {
          setError(command.errors[0]);
        } else {
          onDone();
        }
      },
      (error2) => {
        onFail(error2);
      }
    );
  }, []);
  const {
    register,
    handleSubmit,
    formState: { errors, isValid }
  } = useForm({ resolver, mode: "onChange" });
  return /* @__PURE__ */ jsx25("form", { className: "sm:m-8 sm:w-1/3", onSubmit: handleSubmit(fetchJobOrder), children: /* @__PURE__ */ jsxs14("div", { className: "bg-white shadow sm:rounded-md ", children: [
    /* @__PURE__ */ jsx25("div", { className: "text-info-500 px-5 pt-5 font-medium", children: /* @__PURE__ */ jsx25("h2", { children: "Download Bullhorn Job Order" }) }),
    error ? /* @__PURE__ */ jsxs14("div", { className: "m-4 rounded-md border p-2", children: [
      /* @__PURE__ */ jsxs14("div", { className: "flex items-center space-x-2", children: [
        /* @__PURE__ */ jsx25("div", { className: "w-16 py-1 text-right text-gray-500", children: "Code" }),
        /* @__PURE__ */ jsx25("div", { className: "text-danger-500 font-medium", children: error.code })
      ] }),
      /* @__PURE__ */ jsxs14("div", { className: "flex items-center space-x-2 py-1", children: [
        /* @__PURE__ */ jsx25("div", { className: "w-16 text-right text-gray-500", children: "Message" }),
        /* @__PURE__ */ jsx25("div", { className: "text-danger-500 font-medium", children: error.message })
      ] })
    ] }) : null,
    /* @__PURE__ */ jsxs14("div", { className: "space-y-6 px-4 py-5 sm:p-6", children: [
      /* @__PURE__ */ jsxs14(
        FormRow,
        {
          label: /* @__PURE__ */ jsx25(
            "label",
            {
              htmlFor: "jobOrderId",
              className: "block text-sm font-medium text-gray-700",
              children: "Job Order Id"
            }
          ),
          children: [
            /* @__PURE__ */ jsx25(
              "input",
              {
                type: "number",
                className: "focus:ring-info-500 focus:border-info-500 block w-full flex-1 rounded-none rounded-r-md border border-gray-200 border-gray-300 sm:text-sm",
                defaultValue: "",
                ...register("jobOrderId", { required: true })
              }
            ),
            errors.jobOrderId && /* @__PURE__ */ jsx25("span", { children: "A Job Order Id is required" })
          ]
        }
      ),
      /* @__PURE__ */ jsx25(ButtonList, { children: /* @__PURE__ */ jsx25(Button10, { type: "submit", color: "primary", disabled: !isValid, children: "Download" }) })
    ] })
  ] }) });
};

// src/bullhorn/components/events/__generated__/BullhornEventRow_bullhornStandardEvent.graphql.ts
var node33 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BullhornEventRow_bullhornStandardEvent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "standardEventId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requestId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityEventType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventTimestamp",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedProperties",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityProcessResult",
      "storageKey": null
    }
  ],
  "type": "BullhornStandardEvent",
  "abstractKey": null
};
node33.hash = "efa532f208932e1858c773f3abbba585";
var BullhornEventRow_bullhornStandardEvent_graphql_default = node33;

// src/bullhorn/components/events/BullhornEventRow.tsx
import { useCallback as useCallback19 } from "react";
import { useFragment as useFragment9 } from "react-relay";
import { EdActionCell as EdActionCell4, EdColumnCell as EdColumnCell6, EdRow as EdRow6, LinkButton as LinkButton7 } from "shared-ui";
import { jsx as jsx26, jsxs as jsxs15 } from "react/jsx-runtime";
var bullhornStandardEvent = BullhornEventRow_bullhornStandardEvent_graphql_default;
var BullhornEventRow = (props) => {
  const data = useFragment9(
    bullhornStandardEvent,
    props.bullhornStandardEvent
  );
  const select = useCallback19(() => {
    props.selected(data);
  }, []);
  return /* @__PURE__ */ jsxs15(EdRow6, { clicked: select, rowKey: data.id, children: [
    /* @__PURE__ */ jsx26(EdColumnCell6, { children: data.eventId }),
    /* @__PURE__ */ jsx26(EdColumnCell6, { children: data.createdOn }),
    /* @__PURE__ */ jsx26(EdColumnCell6, { children: data.eventType }),
    /* @__PURE__ */ jsx26(EdColumnCell6, { children: data.entityName }),
    /* @__PURE__ */ jsx26(EdColumnCell6, { children: data.entityEventType }),
    /* @__PURE__ */ jsx26(EdColumnCell6, { children: data.status }),
    /* @__PURE__ */ jsx26(EdColumnCell6, { children: data.entityProcessResult }),
    /* @__PURE__ */ jsx26(EdActionCell4, { children: /* @__PURE__ */ jsx26(LinkButton7, { label: "Select", clicked: select }) })
  ] });
};
var BullhornEventRow_default = BullhornEventRow;

// src/bullhorn/components/events/__generated__/BullhornEventsListPaginationQuery.graphql.ts
var node34 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "createdOn": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornEventsListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "BullhornEventsList_bullhornStandardEvents"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "BullhornEventsListPaginationQuery",
      "selections": [
        {
          "alias": null,
          "args": v3,
          "concreteType": "BullhornStandardEventsConnection",
          "kind": "LinkedField",
          "name": "bullhornStandardEvents",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BullhornStandardEventsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BullhornStandardEvent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityEventType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "standardEventId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "requestId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventTimestamp",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedProperties",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityProcessResult",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "BullhornEventsList_bullhornStandardEvents",
          "kind": "LinkedHandle",
          "name": "bullhornStandardEvents"
        }
      ]
    },
    "params": {
      "cacheID": "35f9ae9cf50fe83eb5d85ba6e8d1979e",
      "id": null,
      "metadata": {},
      "name": "BullhornEventsListPaginationQuery",
      "operationKind": "query",
      "text": "query BullhornEventsListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $tenantId: UUID!\n  $where: BullhornStandardEventFilter\n) {\n  ...BullhornEventsList_bullhornStandardEvents_2HEEH6\n}\n\nfragment BullhornEventRow_bullhornStandardEvent on BullhornStandardEvent {\n  id\n  status\n  standardEventId\n  createdOn\n  requestId\n  entityName\n  entityEventType\n  eventId\n  eventTimestamp\n  eventType\n  updatedProperties\n  entityProcessResult\n}\n\nfragment BullhornEventsList_bullhornStandardEvents_2HEEH6 on Query {\n  bullhornStandardEvents(tenantId: $tenantId, first: $first, after: $after, order: [{createdOn: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        entityName\n        entityEventType\n        ...BullhornEventRow_bullhornStandardEvent\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node34.hash = "e3163e092ec472e95ddada55d2c2e7ec";
var BullhornEventsListPaginationQuery_graphql_default = node34;

// src/bullhorn/components/events/__generated__/BullhornEventsList_bullhornStandardEvents.graphql.ts
var node35 = function() {
  var v0 = [
    "bullhornStandardEvents"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "tenantId"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": BullhornEventsListPaginationQuery_graphql_default
      }
    },
    "name": "BullhornEventsList_bullhornStandardEvents",
    "selections": [
      {
        "alias": "bullhornStandardEvents",
        "args": null,
        "concreteType": "BullhornStandardEventsConnection",
        "kind": "LinkedField",
        "name": "__BullhornEventsList_bullhornStandardEvents_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BullhornStandardEventsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BullhornStandardEvent",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "entityName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "entityEventType",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BullhornEventRow_bullhornStandardEvent"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node35.hash = "e3163e092ec472e95ddada55d2c2e7ec";
var BullhornEventsList_bullhornStandardEvents_graphql_default = node35;

// src/bullhorn/components/events/BullhornEventsList.tsx
import { memo, useCallback as useCallback20 } from "react";
import { usePaginationFragment as usePaginationFragment5 } from "react-relay";
import { EdListHeader as EdListHeader5, EdTable as EdTable7 } from "shared-ui";
import { jsx as jsx27, jsxs as jsxs16 } from "react/jsx-runtime";
var columns6 = [
  { id: "eventId", name: "EventId" },
  { id: "createdOn", name: "Created On" },
  { id: "eventType", name: "Event Type" },
  { id: "entityName", name: "Entity Name" },
  { id: "entityEventType", name: "Entity Event Type" },
  { id: "status", name: "Status" },
  { id: "processResult", name: "Process Result" }
];
var fragment10 = BullhornEventsList_bullhornStandardEvents_graphql_default;
var BullhornEventsList = ({
  onSelect,
  bullhornStandardEventsKey
}) => {
  const select = useCallback20((event) => {
    onSelect(event);
  }, []);
  const paging = usePaginationFragment5(fragment10, bullhornStandardEventsKey);
  const { data } = paging;
  const { bullhornStandardEvents } = data;
  const rows = bullhornStandardEvents?.edges?.map((e) => {
    return /* @__PURE__ */ jsx27(
      BullhornEventRow_default,
      {
        bullhornStandardEvent: e.node,
        selected: select
      },
      e.node.id
    );
  });
  return /* @__PURE__ */ jsxs16("div", { children: [
    /* @__PURE__ */ jsx27(EdListHeader5, { paging }),
    /* @__PURE__ */ jsx27("div", { className: "flex", children: /* @__PURE__ */ jsx27("div", { className: "w-full", children: /* @__PURE__ */ jsx27(EdTable7, { defaultColumns: columns6, rows }) }) })
  ] });
};
var BullhornEventsList_default = memo(BullhornEventsList);

// src/bullhorn/components/tenants/__generated__/BullhornTenantConfigQuery.graphql.ts
var node36 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "alias": null,
      "args": null,
      "concreteType": "FetchField",
      "kind": "LinkedField",
      "name": "fields",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fieldName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fieldValue",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ], v2 = [
    {
      "alias": "config",
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "id"
        }
      ],
      "concreteType": "BullhornTenantConfig",
      "kind": "LinkedField",
      "name": "bullhornTenantConfigByTenantNodeId",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tenantId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "restAuthorizeBaseUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "restLoginBaseUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "restTokenBaseUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FetchConfiguration",
          "kind": "LinkedField",
          "name": "candidateFetchConfiguration",
          "plural": false,
          "selections": v1,
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FetchConfiguration",
          "kind": "LinkedField",
          "name": "jobOrderFetchConfiguration",
          "plural": false,
          "selections": v1,
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornTenantConfigQuery",
      "selections": v2,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "BullhornTenantConfigQuery",
      "selections": v2
    },
    "params": {
      "cacheID": "faa8c2a37344b48312f9302507f7e5ba",
      "id": null,
      "metadata": {},
      "name": "BullhornTenantConfigQuery",
      "operationKind": "query",
      "text": "query BullhornTenantConfigQuery(\n  $id: ID!\n) {\n  config: bullhornTenantConfigByTenantNodeId(id: $id) {\n    id\n    tenantId\n    name\n    isEnabled\n    restAuthorizeBaseUrl\n    restLoginBaseUrl\n    restTokenBaseUrl\n    candidateFetchConfiguration {\n      fields {\n        fieldName\n        fieldValue\n      }\n    }\n    jobOrderFetchConfiguration {\n      fields {\n        fieldName\n        fieldValue\n      }\n    }\n  }\n}\n"
    }
  };
}();
node36.hash = "f785ae9e3260b702dfdf370642694597";
var BullhornTenantConfigQuery_graphql_default = node36;

// src/bullhorn/components/tenants/BullhornTenantConfig.tsx
import { useCallback as useCallback36 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery4 } from "react-relay";
import { useToggle as useToggle5 } from "shared-lib";
import { EdCard, EdGridLayout } from "shared-ui";

// src/bullhorn/components/config/components/FetchConfigurationViewer.tsx
import { useCallback as useCallback34 } from "react";
import { Button as Button18 } from "shared-ui";
import { useToggle as useToggle3 } from "shared-lib";

// src/bullhorn/components/config/components/__generated__/FetchConfigurationEditorQuery.graphql.ts
var node37 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "entity"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  }, v2 = [
    {
      "alias": "customFields",
      "args": [
        {
          "kind": "Variable",
          "name": "entity",
          "variableName": "entity"
        }
      ],
      "concreteType": "IntegrationFieldMapping",
      "kind": "LinkedField",
      "name": "integrationFetchFields",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fieldId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fieldLabel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "apiField",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IntegrationFieldDefinition",
          "kind": "LinkedField",
          "name": "entityField",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationFieldTypes",
              "kind": "LinkedField",
              "name": "dataType",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                },
                v1,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            v1,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FetchConfigurationEditorQuery",
      "selections": v2,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FetchConfigurationEditorQuery",
      "selections": v2
    },
    "params": {
      "cacheID": "6e14911454db10109cf68ec3f0b56edf",
      "id": null,
      "metadata": {},
      "name": "FetchConfigurationEditorQuery",
      "operationKind": "query",
      "text": "query FetchConfigurationEditorQuery(\n  $entity: CustomFieldEntities!\n) {\n  customFields: integrationFetchFields(entity: $entity) {\n    fieldId\n    fieldLabel\n    apiField\n    entityField {\n      dataType {\n        displayName\n        key\n        value\n      }\n      key\n      label\n    }\n  }\n}\n"
    }
  };
}();
node37.hash = "0719b38b1f582e0c1eed4638deca97fe";
var FetchConfigurationEditorQuery_graphql_default = node37;

// src/bullhorn/components/config/components/FetchConfigurationEditor.tsx
import { useCallback as useCallback33, useState as useState10 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery3, useRelayEnvironment as useRelayEnvironment11 } from "react-relay";
import { Button as Button17, ButtonList as ButtonList7, Input as Input4, SelectMenu as SelectMenu5 } from "shared-ui";
import { logInfo as logInfo6 } from "shared-lib";

// src/custom-data/components/CreateFieldMappingFieldForm.tsx
import { useCallback as useCallback24, useState as useState7 } from "react";
import { createUUID as createUUID2 } from "shared-lib";
import { Button as Button11, ButtonList as ButtonList2, FieldLabel as FieldLabel2 } from "shared-ui";

// src/custom-data/components/MappableForm.tsx
import { useCallback as useCallback23, useEffect as useEffect3, useState as useState6 } from "react";
import { isNullOrWhiteSpace } from "shared-lib";
import { FieldLabel, Input as Input3, SelectMenu as SelectMenu3 } from "shared-ui";

// src/custom-data/models/FieldMappings.ts
var MappableProcessorType = /* @__PURE__ */ ((MappableProcessorType3) => {
  MappableProcessorType3["Field"] = "Field";
  MappableProcessorType3["Literal"] = "Literal";
  MappableProcessorType3["FieldFormat"] = "FieldFormat";
  MappableProcessorType3["Expression"] = "Expression";
  return MappableProcessorType3;
})(MappableProcessorType || {});
var processTypes = [
  {
    id: "Field" /* Field */,
    name: "Field" /* Field */
  },
  {
    id: "FieldFormat" /* FieldFormat */,
    name: "FieldFormat" /* FieldFormat */
  },
  {
    id: "Literal" /* Literal */,
    name: "Literal" /* Literal */
  },
  {
    id: "Expression" /* Expression */,
    name: "Expression" /* Expression */
  }
];
var MappableDataType = /* @__PURE__ */ ((MappableDataType3) => {
  MappableDataType3["String"] = "String";
  MappableDataType3["Integer"] = "Integer";
  MappableDataType3["Float"] = "Float";
  MappableDataType3["DateTime"] = "DateTime";
  return MappableDataType3;
})(MappableDataType || {});
var dataTypes = [
  {
    id: "String" /* String */,
    name: "String" /* String */
  },
  {
    id: "Integer" /* Integer */,
    name: "Integer" /* Integer */
  },
  {
    id: "Float" /* Float */,
    name: "Float" /* Float */
  },
  {
    id: "DateTime" /* DateTime */,
    name: "DateTime" /* DateTime */
  }
];
function hasFieldDefinition(processType) {
  if (processType === null) {
    return false;
  }
  return processType === "Field" /* Field */ || processType === "FieldFormat" /* FieldFormat */;
}
function hasValueField(processType) {
  if (processType === null) {
    return false;
  }
  return processType === "Literal" /* Literal */ || processType === "FieldFormat" /* FieldFormat */ || processType === "Expression" /* Expression */;
}
function getDataType(dataType) {
  return dataType.key;
}
function fieldDefinitionToListItem(definition) {
  return {
    id: definition.key,
    name: definition.label
  };
}
function fieldDefinitionsToListItems(fields) {
  return fields.map(fieldDefinitionToListItem);
}
function integrationFieldMappingToListItem(mapping) {
  return {
    id: mapping.fieldId,
    name: mapping.fieldLabel
  };
}
function integrationFieldMappingsToListItems(fields) {
  return fields.map(integrationFieldMappingToListItem);
}

// src/custom-data/components/ProcessorTypeList.tsx
import { useCallback as useCallback21, useEffect, useState as useState4 } from "react";
import { SelectMenu } from "shared-ui";
import { jsx as jsx28 } from "react/jsx-runtime";
var ProcessorTypeList = ({
  type,
  onSelect
}) => {
  const [item, setTtem] = useState4(null);
  const onItemChange = useCallback21(
    (item2) => {
      const processorType = item2.id;
      onSelect(processorType);
    },
    [item]
  );
  useEffect(() => {
    if (type) {
      const item2 = processTypes.find((i) => i.id == type);
      if (item2) {
        setTtem(item2);
      }
    }
  }, []);
  return /* @__PURE__ */ jsx28(
    SelectMenu,
    {
      title: "Processor",
      items: processTypes,
      onChange: onItemChange,
      value: item
    }
  );
};

// src/custom-data/components/DataTypeList.tsx
import { useCallback as useCallback22, useEffect as useEffect2, useState as useState5 } from "react";
import { SelectMenu as SelectMenu2 } from "shared-ui";
import { jsx as jsx29 } from "react/jsx-runtime";
var DataTypeList = ({ type, onSelect }) => {
  const [item, setItem] = useState5(null);
  const onItemChange = useCallback22(
    (item2) => {
      setItem(item2);
    },
    [item]
  );
  useEffect2(() => {
    if (type) {
      const item2 = dataTypes.find((i) => i.id == type);
      if (item2) {
        setItem(item2);
      }
    }
  }, []);
  useEffect2(() => {
    if (type && item) {
      const dataType = item.id;
      onSelect(dataType);
    }
  }, [item]);
  return /* @__PURE__ */ jsx29(
    SelectMenu2,
    {
      title: "Data Type",
      items: dataTypes,
      onChange: onItemChange,
      value: item
    }
  );
};

// src/custom-data/components/MappableForm.tsx
import { jsx as jsx30, jsxs as jsxs17 } from "react/jsx-runtime";
var MappableForm = ({
  fieldDefinitions,
  fields,
  onChange
}) => {
  const [field, setField] = useState6(null);
  const [name, setName] = useState6(null);
  const [value, setValue] = useState6(null);
  const [dataType, setDataType] = useState6(
    "String" /* String */
  );
  const [processorType, setProcessorType] = useState6("Field" /* Field */);
  const onSetField = useCallback23(
    (item) => {
      setField(item);
      const field2 = fieldDefinitions.find((d) => d.key === item.id);
      if (!field2) {
        throw "Invalid Source Definitions List";
      }
      if (isNullOrWhiteSpace(name)) {
        setName(field2.label);
        setDataType(getDataType(field2.dataType));
      }
    },
    [field, name, dataType]
  );
  const onSetName = useCallback23(
    (value2) => {
      setName(value2);
    },
    [name]
  );
  const onSetValue = useCallback23(
    (value2) => {
      setValue(value2);
    },
    [value]
  );
  const onSetDataType = useCallback23(
    (value2) => {
      setDataType(value2);
    },
    [dataType]
  );
  useEffect3(() => {
    if (!processorType || !dataType || !name) {
      return;
    }
    let key, label, dataTypeKey;
    if (hasFieldDefinition(processorType) && field) {
      const fieldDefinition = fieldDefinitions.find((d) => d.key === field.id);
      if (!fieldDefinition) {
        throw "Invalid Source Definitions List";
      }
      key = fieldDefinition.key;
      label = fieldDefinition.label;
      dataTypeKey = fieldDefinition.dataType.key;
    } else {
      key = name;
      label = name;
      dataTypeKey = dataType;
    }
    onChange({
      key,
      label,
      dataTypeKey,
      processorTypeKey: processorType,
      value
    });
  }, [field, name, dataType, value]);
  return /* @__PURE__ */ jsx30("div", { children: /* @__PURE__ */ jsxs17("div", { className: "p-2", children: [
    /* @__PURE__ */ jsx30("div", { className: "p-2", children: /* @__PURE__ */ jsx30(
      ProcessorTypeList,
      {
        type: processorType ?? "Field" /* Field */,
        onSelect: setProcessorType
      }
    ) }),
    hasFieldDefinition(processorType) ? /* @__PURE__ */ jsx30("div", { className: "p-2", children: /* @__PURE__ */ jsx30(
      SelectMenu3,
      {
        title: "Field",
        items: fields,
        onChange: onSetField,
        value: field
      }
    ) }) : /* @__PURE__ */ jsx30("div", { className: "p-2", children: /* @__PURE__ */ jsx30(DataTypeList, { onSelect: onSetDataType, type: dataType }) }),
    /* @__PURE__ */ jsxs17("div", { className: "p-2", children: [
      /* @__PURE__ */ jsx30("div", { className: "m-1", children: /* @__PURE__ */ jsx30(FieldLabel, { htmlFor: "sourceName", label: "Name" }) }),
      /* @__PURE__ */ jsx30(
        Input3,
        {
          name: "sourceName",
          value: name || "",
          onValueChange: onSetName
        },
        "sourceName"
      )
    ] }),
    hasValueField(processorType) ? /* @__PURE__ */ jsxs17("div", { className: "p-2", children: [
      /* @__PURE__ */ jsx30("div", { className: "m-1", children: /* @__PURE__ */ jsx30(FieldLabel, { htmlFor: "sourceValue", label: "Value" }) }),
      /* @__PURE__ */ jsx30(
        Input3,
        {
          name: "sourceValue",
          value: value || "",
          onValueChange: onSetValue
        },
        "sourceValue"
      )
    ] }) : /* @__PURE__ */ jsx30("div", {})
  ] }) });
};

// src/custom-data/components/CreateFieldMappingFieldForm.tsx
import { jsx as jsx31, jsxs as jsxs18 } from "react/jsx-runtime";
var CreateFieldMappingFieldForm = ({
  sourceFieldDefinitions,
  targetFieldDefinitions,
  sourceFields,
  targetFields,
  onCreated,
  onCancel
}) => {
  const [source, setSource] = useState7(null);
  const onSetSource = useCallback24(
    (value) => {
      setSource(value);
    },
    [source]
  );
  const [target, setTarget] = useState7(null);
  const onSetTarget = useCallback24(
    (value) => {
      setTarget(value);
    },
    [target]
  );
  const onAdd = useCallback24(() => {
    if (!source || !target) {
      return;
    }
    const id = createUUID2();
    const field = {
      id,
      source,
      target
    };
    onCreated(field);
  }, [source, target]);
  return /* @__PURE__ */ jsxs18("div", { children: [
    /* @__PURE__ */ jsxs18("div", { className: "p-2", children: [
      /* @__PURE__ */ jsx31("div", { className: "border-b px-2  py-3", children: /* @__PURE__ */ jsx31(FieldLabel2, { color: "primary", label: "Source" }) }),
      /* @__PURE__ */ jsx31(
        MappableForm,
        {
          fieldDefinitions: sourceFieldDefinitions,
          fields: sourceFields,
          onChange: onSetSource
        }
      )
    ] }),
    /* @__PURE__ */ jsxs18("div", { className: "p-2", children: [
      /* @__PURE__ */ jsx31("div", { className: "border-b px-2  py-3", children: /* @__PURE__ */ jsx31(FieldLabel2, { color: "primary", label: "Target" }) }),
      /* @__PURE__ */ jsx31(
        MappableForm,
        {
          fieldDefinitions: targetFieldDefinitions,
          fields: targetFields,
          onChange: onSetTarget
        }
      )
    ] }),
    /* @__PURE__ */ jsxs18(ButtonList2, { children: [
      /* @__PURE__ */ jsx31(Button11, { color: "primary", disabled: !source || !target, clicked: onAdd, children: "Add" }),
      /* @__PURE__ */ jsx31(Button11, { clicked: onCancel, children: "Cancel" })
    ] })
  ] });
};

// src/custom-data/components/FieldMappingConfigurationCreateForm.tsx
import { useCallback as useCallback25 } from "react";
import { useForm as useForm2 } from "react-hook-form";
import {
  Button as Button12,
  ButtonList as ButtonList3,
  DependentSelectField,
  FormInput,
  FormRow as FormRow2
} from "shared-ui";

// src/lib/Events.ts
var AllEntityEventTypes = "ALL";
var EntityEventTypes = [
  {
    id: AllEntityEventTypes,
    label: "All"
  },
  {
    id: "INSERTED",
    label: "Inserted"
  },
  {
    id: "UPDATED",
    label: "Updated"
  },
  {
    id: "DELETED",
    label: "Deleted"
  }
];

// src/lib/Systems.ts
var ElevateVacancyEntity = "Vacancy";
var ElevateProfileEntity = "Profile";
var ElevateApplicationEntity = "Application";
var ElevateEntities = [
  { id: ElevateVacancyEntity, name: ElevateVacancyEntity },
  { id: ElevateProfileEntity, name: ElevateProfileEntity },
  { id: ElevateApplicationEntity, name: ElevateApplicationEntity }
];
var BullhornJobOrderEntity = "JobOrder";
var BullhornCandidateEntity = "Candidate";
var BullhornJobSubmissionEntity = "JobSubmission";
var BullhornEntities = [
  { id: BullhornJobOrderEntity, name: BullhornJobOrderEntity },
  { id: BullhornCandidateEntity, name: BullhornCandidateEntity },
  { id: BullhornJobSubmissionEntity, name: BullhornJobSubmissionEntity }
];
var ElevateSystem = "Elevate";
var BullhornSystem = "Bullhorn";
var IntegrationSystems = [
  { id: ElevateSystem, name: ElevateSystem },
  { id: BullhornSystem, name: BullhornSystem }
];
var IntegrationEntityMap = /* @__PURE__ */ new Map();
IntegrationEntityMap.set(ElevateSystem, ElevateEntities);
IntegrationEntityMap.set(BullhornSystem, BullhornEntities);

// src/lib/EventLogs.ts
var EventLogItemTypesList = [
  {
    id: "All",
    name: "All"
  },
  {
    id: "BullhornTenant",
    name: "Tenant"
  },
  {
    id: "BullhornCandidate",
    name: "Candidate"
  },
  {
    id: "BullhornJobOrder",
    name: "Job Order"
  },
  {
    id: "BullhornJobSubmission",
    name: "Job Submission"
  }
];
var EventLogItemLevelList = [
  {
    id: "All",
    label: "All"
  },
  {
    id: "Info",
    label: "Info"
  },
  {
    id: "Warning",
    label: "Warning"
  },
  {
    id: "Error",
    label: "Error"
  }
];

// src/custom-data/components/FieldMappingConfigurationCreateForm.tsx
import { jsx as jsx32, jsxs as jsxs19 } from "react/jsx-runtime";
var FieldMappingConfigurationCreateForm = ({
  onSubmit
}) => {
  const submit = useCallback25((form) => {
    if (!form.name || !form.sourceField || !form.sourceField.parentId || !form.sourceField.childId || !form.targetField || !form.targetField.parentId || !form.targetField.childId) {
      return;
    }
    onSubmit({
      name: form.name,
      sourceType: form.sourceField.childId,
      sourceSystem: form.sourceField.parentId,
      targetType: form.targetField.childId,
      targetSystem: form.targetField.parentId
    });
  }, []);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors }
  } = useForm2();
  return /* @__PURE__ */ jsx32("form", { onSubmit: handleSubmit(submit), children: /* @__PURE__ */ jsx32("div", { className: "shadow sm:rounded-md", children: /* @__PURE__ */ jsxs19("div", { className: "space-y-6 bg-white px-4 py-5 sm:p-6", children: [
    /* @__PURE__ */ jsxs19(
      FormRow2,
      {
        label: /* @__PURE__ */ jsx32(
          "label",
          {
            htmlFor: "name",
            className: "block text-sm font-medium text-gray-700",
            children: "Name"
          }
        ),
        children: [
          /* @__PURE__ */ jsx32(
            FormInput,
            {
              type: "text",
              placeholder: " Name ",
              defaultValue: "",
              name: "name",
              required: true,
              register
            }
          ),
          errors.nameRequired && /* @__PURE__ */ jsx32("span", { children: "A name is required" })
        ]
      }
    ),
    /* @__PURE__ */ jsx32(
      FormRow2,
      {
        label: /* @__PURE__ */ jsx32(
          "label",
          {
            htmlFor: "name",
            className: "block text-sm font-medium text-gray-700",
            children: "Source"
          }
        ),
        children: /* @__PURE__ */ jsx32(
          DependentSelectField,
          {
            className: "w-full",
            name: "sourceField",
            control,
            parentTitle: "System",
            childTitle: "Type",
            parentItems: IntegrationSystems,
            childItems: IntegrationEntityMap
          }
        )
      }
    ),
    /* @__PURE__ */ jsx32(
      FormRow2,
      {
        label: /* @__PURE__ */ jsx32(
          "label",
          {
            htmlFor: "name",
            className: "block text-sm font-medium text-gray-700",
            children: "Target"
          }
        ),
        children: /* @__PURE__ */ jsx32(
          DependentSelectField,
          {
            className: "w-full",
            name: "targetField",
            control,
            parentTitle: "System",
            childTitle: "Type",
            parentItems: IntegrationSystems,
            childItems: IntegrationEntityMap
          }
        )
      }
    ),
    /* @__PURE__ */ jsx32(ButtonList3, { children: /* @__PURE__ */ jsx32(Button12, { type: "submit", children: "Create" }) })
  ] }) }) });
};

// src/custom-data/components/__generated__/FieldMappingConfigurationDetail_fieldMappingConfiguration.graphql.ts
var node38 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  }, v2 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    v1
  ], v3 = [
    v1,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "processorTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FieldMappingConfigurationDetail_fieldMappingConfiguration",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IntegrationSystemsType",
        "kind": "LinkedField",
        "name": "sourceSystem",
        "plural": false,
        "selections": v2,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sourceType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IntegrationSystemsType",
        "kind": "LinkedField",
        "name": "targetSystem",
        "plural": false,
        "selections": v2,
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "targetType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IntegrationMappableAction",
        "kind": "LinkedField",
        "name": "mappings",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationMappable",
            "kind": "LinkedField",
            "name": "source",
            "plural": false,
            "selections": v3,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationMappable",
            "kind": "LinkedField",
            "name": "target",
            "plural": false,
            "selections": v3,
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "IntegrationFieldMappingConfiguration",
    "abstractKey": null
  };
}();
node38.hash = "728a23f49039dffc2718e281112fa671";
var FieldMappingConfigurationDetail_fieldMappingConfiguration_graphql_default = node38;

// src/custom-data/components/FieldMappingConfigurationDetail.tsx
import { Fragment as Fragment6 } from "react";
import { useFragment as useFragment10 } from "react-relay";
import {
  AuditFields as AuditFields4,
  DescriptionItem as DescriptionItem4,
  DescriptionList as DescriptionList4,
  EdColumnCell as EdColumnCell7,
  EdRow as EdRow7,
  EdTable as EdTable8
} from "shared-ui";
import { jsx as jsx33, jsxs as jsxs20 } from "react/jsx-runtime";
var fragment11 = FieldMappingConfigurationDetail_fieldMappingConfiguration_graphql_default;
var columns7 = [
  { id: "label", name: "Label" },
  { id: "processorType", name: "Processor Type" },
  { id: "dataType", name: "Data Type" },
  { id: "dataValue", name: "Data Value" },
  { id: "transform", name: "Transform" },
  { id: "target", name: "Target" },
  { id: "type", name: "Type" },
  { id: "value", name: "Value" }
];
var FieldMappingConfigurationDetail = ({
  fieldMappingConfiguration: fieldMappingConfiguration2,
  actions,
  className
}) => {
  const data = useFragment10(
    fragment11,
    fieldMappingConfiguration2
  );
  const rows = data.mappings.map((action) => {
    return /* @__PURE__ */ jsxs20(EdRow7, { clicked: () => {
    }, rowKey: action.id, children: [
      /* @__PURE__ */ jsx33(EdColumnCell7, { children: action.source.label }),
      /* @__PURE__ */ jsx33(EdColumnCell7, { children: action.source.processorTypeKey }),
      /* @__PURE__ */ jsx33(EdColumnCell7, { children: action.source.dataTypeKey }),
      /* @__PURE__ */ jsx33(EdColumnCell7, { children: action.source.value ?? "" }),
      /* @__PURE__ */ jsx33(EdColumnCell7, { children: /* @__PURE__ */ jsx33("div", { className: "font-medium text-gray-800", children: "Set" }) }),
      /* @__PURE__ */ jsx33(EdColumnCell7, { children: action.target.label }),
      /* @__PURE__ */ jsx33(EdColumnCell7, { children: action.target.processorTypeKey }),
      /* @__PURE__ */ jsx33(EdColumnCell7, { children: action.target.dataTypeKey }),
      /* @__PURE__ */ jsx33(EdColumnCell7, { children: action.target.value ?? "" })
    ] }, action.id);
  });
  return /* @__PURE__ */ jsx33("div", { className, children: /* @__PURE__ */ jsx33(
    DescriptionList4,
    {
      heading: /* @__PURE__ */ jsx33("span", { className: "text-info-600", children: data.name }),
      description: /* @__PURE__ */ jsx33("div", { className: "mt-4", children: /* @__PURE__ */ jsx33(
        AuditFields4,
        {
          createdOn: data.createdOn,
          updatedOn: data.updatedOn
        }
      ) }),
      items: /* @__PURE__ */ jsxs20(Fragment6, { children: [
        actions,
        /* @__PURE__ */ jsx33(DescriptionItem4, { label: "Source", children: /* @__PURE__ */ jsxs20("p", { className: "text-md pt-1 text-gray-500", children: [
          data.sourceSystem.displayName,
          " ",
          data.sourceType
        ] }) }),
        /* @__PURE__ */ jsx33(DescriptionItem4, { label: "Target", children: /* @__PURE__ */ jsxs20("p", { className: "text-md pt-1 text-gray-500", children: [
          data.targetSystem.displayName,
          " ",
          data.targetType
        ] }) }),
        /* @__PURE__ */ jsx33("div", { className: "my-4 p-4", children: /* @__PURE__ */ jsx33(
          EdTable8,
          {
            fixedHeight: false,
            defaultColumns: columns7,
            rows
          }
        ) })
      ] })
    }
  ) });
};
var FieldMappingConfigurationDetail_default = FieldMappingConfigurationDetail;

// src/custom-data/components/FieldMappingConfigurationEditForm.tsx
import { useCallback as useCallback26 } from "react";
import { useForm as useForm3 } from "react-hook-form";
import { Button as Button13, ButtonList as ButtonList4, DependentSelectField as DependentSelectField2, FormRow as FormRow3 } from "shared-ui";
import { jsx as jsx34, jsxs as jsxs21 } from "react/jsx-runtime";
var FieldMappingConfigurationEditForm = ({
  sourceSystem,
  sourceType,
  targetSystem,
  targetType,
  name,
  onSave,
  onCancel
}) => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors }
  } = useForm3();
  const onSubmit = useCallback26((data) => {
    onSave(data);
  }, []);
  return /* @__PURE__ */ jsxs21("form", { onSubmit: handleSubmit(onSubmit), children: [
    /* @__PURE__ */ jsx34("div", { className: "px-2 py-4 font-medium", children: /* @__PURE__ */ jsxs21("p", { children: [
      "Mapping fields from",
      " ",
      /* @__PURE__ */ jsx34("span", { className: "text-info-500", children: sourceType }),
      " to",
      " ",
      /* @__PURE__ */ jsx34("span", { className: "text-info-500", children: targetType })
    ] }) }),
    /* @__PURE__ */ jsx34("div", { className: "shadow sm:rounded-md", children: /* @__PURE__ */ jsxs21("div", { className: "space-y-6 bg-white px-4 py-5 sm:p-6", children: [
      /* @__PURE__ */ jsxs21(
        FormRow3,
        {
          label: /* @__PURE__ */ jsx34(
            "label",
            {
              htmlFor: "name",
              className: "block text-sm font-medium text-gray-700",
              children: "Name"
            }
          ),
          children: [
            /* @__PURE__ */ jsx34(
              "input",
              {
                type: "text",
                className: "focus:ring-info-500 focus:border-info-500 sm:text-md block w-full flex-1 rounded-none rounded-r-md border-gray-300",
                defaultValue: name,
                ...register("name", { required: true })
              }
            ),
            errors.nameRequired && /* @__PURE__ */ jsx34("span", { children: "A name is required" })
          ]
        }
      ),
      /* @__PURE__ */ jsx34(
        FormRow3,
        {
          label: /* @__PURE__ */ jsx34(
            "label",
            {
              htmlFor: "name",
              className: "block text-sm font-medium text-gray-700",
              children: "Source"
            }
          ),
          children: /* @__PURE__ */ jsx34(
            DependentSelectField2,
            {
              name: "sourceField",
              control,
              parentTitle: "System",
              childTitle: "Type",
              parentItems: IntegrationSystems,
              childItems: IntegrationEntityMap,
              initialParentId: sourceSystem,
              initialChildId: sourceType
            }
          )
        }
      ),
      /* @__PURE__ */ jsx34(
        FormRow3,
        {
          label: /* @__PURE__ */ jsx34(
            "label",
            {
              htmlFor: "name",
              className: "block text-sm font-medium text-gray-700",
              children: "Target"
            }
          ),
          children: /* @__PURE__ */ jsx34(
            DependentSelectField2,
            {
              name: "targetField",
              control,
              parentTitle: "System",
              childTitle: "Type",
              parentItems: IntegrationSystems,
              childItems: IntegrationEntityMap,
              initialParentId: targetSystem,
              initialChildId: targetType
            }
          )
        }
      ),
      /* @__PURE__ */ jsxs21(ButtonList4, { children: [
        /* @__PURE__ */ jsx34(Button13, { type: "submit", children: "Save" }),
        /* @__PURE__ */ jsx34(Button13, { clicked: onCancel, children: "Cancel" })
      ] })
    ] }) })
  ] });
};

// src/custom-data/components/FieldMappingConfigurationFieldsForm.tsx
import { useCallback as useCallback28, useState as useState8 } from "react";
import { Button as Button15, ButtonList as ButtonList5, FormRow as FormRow4, FieldLabel as FieldLabel3, InlineEdit } from "shared-ui";

// src/custom-data/components/FieldMappingFieldsList.tsx
import { Fragment as Fragment7, useCallback as useCallback27 } from "react";
import {
  Button as Button14,
  EdActionCell as EdActionCell5,
  EdColumnCell as EdColumnCell8,
  EdRow as EdRow8,
  EdTable as EdTable9
} from "shared-ui";
import { jsx as jsx35, jsxs as jsxs22 } from "react/jsx-runtime";
var columns8 = [
  { id: "source", name: "Source" },
  { id: "target", name: "Target" }
];
var FieldMappingFieldsList = ({
  fields,
  onRemove
}) => {
  const onRemoveField = useCallback27(
    (field) => {
      onRemove(field);
    },
    [fields]
  );
  const rows = fields.map((field) => {
    return /* @__PURE__ */ jsxs22(EdRow8, { clicked: () => {
    }, rowKey: field.id, children: [
      /* @__PURE__ */ jsx35(EdColumnCell8, { children: field.source.label }),
      /* @__PURE__ */ jsx35(EdColumnCell8, { children: field.target.label }),
      /* @__PURE__ */ jsx35(EdActionCell5, { children: /* @__PURE__ */ jsx35(Button14, { clicked: () => onRemoveField(field), children: "Remove" }) })
    ] }, field.id);
  });
  return /* @__PURE__ */ jsx35(Fragment7, { children: /* @__PURE__ */ jsx35(
    EdTable9,
    {
      fixedHeight: false,
      defaultColumns: columns8,
      rows
    }
  ) });
};

// src/custom-data/components/FieldMappingConfigurationFieldsForm.tsx
import { jsx as jsx36, jsxs as jsxs23 } from "react/jsx-runtime";
var FieldMappingConfigurationFieldsForm = ({
  sourceFieldDefinitions,
  targetFieldDefinitions,
  name,
  isBusy,
  actions,
  onSave,
  onCancel
}) => {
  const sourceFieldList = fieldDefinitionsToListItems(sourceFieldDefinitions);
  const targetFieldList = fieldDefinitionsToListItems(targetFieldDefinitions);
  const [currentName, setCurrentName] = useState8(name);
  const [currentActions, setCurrentActions] = useState8(actions);
  const [editState, setEditState] = useState8("Editing" /* Editing */);
  const onSetAdding = useCallback28(() => {
    setEditState("Adding" /* Adding */);
  }, [editState]);
  const onSetEditing = useCallback28(() => {
    setEditState("Editing" /* Editing */);
  }, [editState]);
  const onRemoveAction = useCallback28(
    (action) => {
      const actions2 = currentActions.filter((f) => f.id !== action.id);
      setCurrentActions(actions2);
    },
    [currentActions]
  );
  const onSubmit = useCallback28(() => {
    onSave({
      name: currentName,
      actions: currentActions
    });
  }, [currentName, currentActions]);
  const onAddAction = useCallback28(
    (action) => {
      const updatedActions = [...currentActions, action];
      setCurrentActions(updatedActions);
      onSetEditing();
    },
    [editState, currentActions]
  );
  let currentTab;
  switch (editState) {
    case "Editing" /* Editing */: {
      currentTab = /* @__PURE__ */ jsxs23("div", { className: "border border-gray-100 bg-white p-4 shadow", children: [
        /* @__PURE__ */ jsx36(
          FormRow4,
          {
            label: /* @__PURE__ */ jsx36("div", { className: "flex justify-between", children: /* @__PURE__ */ jsx36(FieldLabel3, { htmlFor: "Name", label: "Name" }) }),
            children: /* @__PURE__ */ jsx36(
              InlineEdit,
              {
                classes: "w-full",
                label: "Name",
                value: currentName,
                setValue: setCurrentName
              }
            )
          }
        ),
        /* @__PURE__ */ jsx36(
          FormRow4,
          {
            label: /* @__PURE__ */ jsxs23("div", { className: "flex items-center justify-between border-b py-2", children: [
              /* @__PURE__ */ jsx36(FieldLabel3, { htmlFor: "Fields", label: "Fields" }),
              /* @__PURE__ */ jsx36(Button15, { clicked: onSetAdding, children: "New" })
            ] }),
            children: /* @__PURE__ */ jsx36("div", { className: "py-4", children: /* @__PURE__ */ jsx36(
              FieldMappingFieldsList,
              {
                fields: currentActions,
                onRemove: onRemoveAction
              }
            ) })
          }
        ),
        /* @__PURE__ */ jsxs23(ButtonList5, { children: [
          /* @__PURE__ */ jsx36(Button15, { color: "gray", clicked: onCancel, children: "Cancel" }),
          /* @__PURE__ */ jsx36(Button15, { disabled: isBusy, clicked: onSubmit, children: "Save" })
        ] })
      ] });
      break;
    }
    case "Adding" /* Adding */: {
      currentTab = /* @__PURE__ */ jsxs23("div", { className: "mb-12 border border-gray-100 bg-white px-4 pt-2 shadow", children: [
        /* @__PURE__ */ jsx36("div", { className: "p-2", children: /* @__PURE__ */ jsx36(FieldLabel3, { size: "lg", label: "Add Field" }) }),
        /* @__PURE__ */ jsx36(
          CreateFieldMappingFieldForm,
          {
            sourceFieldDefinitions,
            targetFieldDefinitions,
            targetFields: targetFieldList,
            sourceFields: sourceFieldList,
            onCreated: onAddAction,
            onCancel: onSetEditing
          }
        )
      ] });
      break;
    }
  }
  return /* @__PURE__ */ jsx36("div", { className: "w-full px-2 py-4", children: currentTab });
};

// src/custom-data/components/__generated__/FieldMappingConfigurationListPaginationQuery.graphql.ts
var node39 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "updatedOn": "DESC"
        }
      ]
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v5 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "processorTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FieldMappingConfigurationListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "FieldMappingConfigurationList_fieldMappingConfigurations"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FieldMappingConfigurationListPaginationQuery",
      "selections": [
        {
          "alias": null,
          "args": v3,
          "concreteType": "IntegrationFieldMappingsConnection",
          "kind": "LinkedField",
          "name": "integrationFieldMappings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationFieldMappingsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationFieldMappingConfiguration",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fieldMappingConfigurationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "targetType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "IntegrationMappableAction",
                      "kind": "LinkedField",
                      "name": "mappings",
                      "plural": true,
                      "selections": [
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "IntegrationMappable",
                          "kind": "LinkedField",
                          "name": "source",
                          "plural": false,
                          "selections": v5,
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "IntegrationMappable",
                          "kind": "LinkedField",
                          "name": "target",
                          "plural": false,
                          "selections": v5,
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "FieldMappingConfigurationList_integrationFieldMappings",
          "kind": "LinkedHandle",
          "name": "integrationFieldMappings"
        }
      ]
    },
    "params": {
      "cacheID": "09928a279cabd99d9203f60425ed1f72",
      "id": null,
      "metadata": {},
      "name": "FieldMappingConfigurationListPaginationQuery",
      "operationKind": "query",
      "text": "query FieldMappingConfigurationListPaginationQuery(\n  $after: String\n  $first: Int = 10\n) {\n  ...FieldMappingConfigurationList_fieldMappingConfigurations_2HEEH6\n}\n\nfragment FieldMappingConfigurationList_fieldMappingConfigurations_2HEEH6 on Query {\n  integrationFieldMappings(first: $first, after: $after, order: [{updatedOn: DESC}]) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        ...FieldMappingConfigurationRow_fieldMappingConfiguration\n        __typename\n      }\n    }\n  }\n}\n\nfragment FieldMappingConfigurationRow_fieldMappingConfiguration on IntegrationFieldMappingConfiguration {\n  id\n  fieldMappingConfigurationId\n  createdOn\n  updatedOn\n  name\n  sourceType\n  targetType\n  mappings {\n    id\n    source {\n      key\n      label\n      dataTypeKey\n      processorTypeKey\n      value\n    }\n    target {\n      key\n      label\n      dataTypeKey\n      processorTypeKey\n      value\n    }\n  }\n}\n"
    }
  };
}();
node39.hash = "6b55969229478dd41c330445b5b4032d";
var FieldMappingConfigurationListPaginationQuery_graphql_default = node39;

// src/custom-data/components/__generated__/FieldMappingConfigurationList_fieldMappingConfigurations.graphql.ts
var node40 = function() {
  var v0 = [
    "integrationFieldMappings"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": FieldMappingConfigurationListPaginationQuery_graphql_default
      }
    },
    "name": "FieldMappingConfigurationList_fieldMappingConfigurations",
    "selections": [
      {
        "alias": "integrationFieldMappings",
        "args": null,
        "concreteType": "IntegrationFieldMappingsConnection",
        "kind": "LinkedField",
        "name": "__FieldMappingConfigurationList_integrationFieldMappings_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationFieldMappingsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationFieldMappingConfiguration",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FieldMappingConfigurationRow_fieldMappingConfiguration"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node40.hash = "6b55969229478dd41c330445b5b4032d";
var FieldMappingConfigurationList_fieldMappingConfigurations_graphql_default = node40;

// src/custom-data/components/FieldMappingConfigurationList.tsx
import { useCallback as useCallback30 } from "react";
import { usePaginationFragment as usePaginationFragment6 } from "react-relay";
import { EdListHeader as EdListHeader6, EdTable as EdTable10 } from "shared-ui";

// src/custom-data/components/__generated__/FieldMappingConfigurationRow_fieldMappingConfiguration.graphql.ts
var node41 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v1 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "processorTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ];
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FieldMappingConfigurationRow_fieldMappingConfiguration",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fieldMappingConfigurationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sourceType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "targetType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IntegrationMappableAction",
        "kind": "LinkedField",
        "name": "mappings",
        "plural": true,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationMappable",
            "kind": "LinkedField",
            "name": "source",
            "plural": false,
            "selections": v1,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationMappable",
            "kind": "LinkedField",
            "name": "target",
            "plural": false,
            "selections": v1,
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "IntegrationFieldMappingConfiguration",
    "abstractKey": null
  };
}();
node41.hash = "01786161b777c377f03e531373cedb98";
var FieldMappingConfigurationRow_fieldMappingConfiguration_graphql_default = node41;

// src/custom-data/components/FieldMappingConfigurationRow.tsx
import { useCallback as useCallback29 } from "react";
import { useFragment as useFragment11 } from "react-relay";
import { timeAgo as timeAgo2 } from "shared-lib";
import { EdActionCell as EdActionCell6, EdColumnCell as EdColumnCell9, EdRow as EdRow9, LinkButton as LinkButton8 } from "shared-ui";
import { jsx as jsx37, jsxs as jsxs24 } from "react/jsx-runtime";
var fieldMappingConfiguration = FieldMappingConfigurationRow_fieldMappingConfiguration_graphql_default;
var FieldMappingConfigurationRow = (props) => {
  const data = useFragment11(
    fieldMappingConfiguration,
    props.fieldMappingConfiguration
  );
  const select = useCallback29(() => {
    props.selected(data);
  }, []);
  return /* @__PURE__ */ jsxs24(EdRow9, { clicked: select, rowKey: data.id, children: [
    /* @__PURE__ */ jsx37(EdColumnCell9, { children: data.name }),
    /* @__PURE__ */ jsx37(EdColumnCell9, { children: data.sourceType }),
    /* @__PURE__ */ jsx37(EdColumnCell9, { children: data.targetType }),
    /* @__PURE__ */ jsx37(EdColumnCell9, { children: timeAgo2(data.createdOn) }),
    /* @__PURE__ */ jsx37(EdColumnCell9, { children: timeAgo2(data.updatedOn) }),
    /* @__PURE__ */ jsx37(EdActionCell6, { children: /* @__PURE__ */ jsx37(LinkButton8, { label: "Select", clicked: select }) })
  ] });
};
var FieldMappingConfigurationRow_default = FieldMappingConfigurationRow;

// src/custom-data/components/FieldMappingConfigurationList.tsx
import { jsx as jsx38, jsxs as jsxs25 } from "react/jsx-runtime";
var columns9 = [
  { id: "name", name: "Name" },
  { id: "sourceType", name: "Source Type" },
  { id: "targetType", name: "Target Type" },
  { id: "createdOn", name: "Created On" },
  { id: "updatedOn", name: "Updated On" }
];
var fragment12 = FieldMappingConfigurationList_fieldMappingConfigurations_graphql_default;
var FieldMappingConfigurationList = ({
  onSelect,
  fieldMappingConfigurationsKey
}) => {
  const select = useCallback30((event) => {
    onSelect(event);
  }, []);
  const paging = usePaginationFragment6(fragment12, fieldMappingConfigurationsKey);
  const { data } = paging;
  const { integrationFieldMappings } = data;
  const rows = integrationFieldMappings?.edges?.map((e) => {
    return /* @__PURE__ */ jsx38(
      FieldMappingConfigurationRow_default,
      {
        fieldMappingConfiguration: e.node,
        selected: select
      },
      e.node.id
    );
  });
  return /* @__PURE__ */ jsxs25("div", { children: [
    /* @__PURE__ */ jsx38(EdListHeader6, { paging }),
    /* @__PURE__ */ jsx38("div", { className: "flex", children: /* @__PURE__ */ jsx38("div", { className: "w-full", children: /* @__PURE__ */ jsx38(EdTable10, { defaultColumns: columns9, rows }) }) })
  ] });
};
var FieldMappingConfigurationList_default = FieldMappingConfigurationList;

// src/custom-data/components/FieldMappingEditor.tsx
import { jsx as jsx39, jsxs as jsxs26 } from "react/jsx-runtime";
var FieldMappingEditor = ({ mappings }) => {
  const mappingItems = mappings.map((mapping) => {
    return /* @__PURE__ */ jsxs26("div", { className: "flex p-4", children: [
      /* @__PURE__ */ jsx39("div", { children: mapping.source?.label }),
      /* @__PURE__ */ jsx39("div", { children: mapping.target?.label })
    ] }, `${mapping.source}-${mapping.target}`);
  });
  return /* @__PURE__ */ jsx39("div", { children: mappingItems });
};

// src/custom-data/components/__generated__/FieldMappingSelectorQuery.graphql.ts
var node42 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v2 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FieldMappingSelectorQuery",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FieldMappingSelectorResults_integrationFieldMappings"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FieldMappingSelectorQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "IntegrationFieldMappingsConnection",
          "kind": "LinkedField",
          "name": "integrationFieldMappings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationFieldMappingsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationFieldMappingConfiguration",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fieldMappingConfigurationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "IntegrationSystemsType",
                      "kind": "LinkedField",
                      "name": "sourceSystem",
                      "plural": false,
                      "selections": v2,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "IntegrationSystemsType",
                      "kind": "LinkedField",
                      "name": "targetSystem",
                      "plural": false,
                      "selections": v2,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "targetType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "FieldMappingSelectorResults_integrationFieldMappings",
          "kind": "LinkedHandle",
          "name": "integrationFieldMappings"
        }
      ]
    },
    "params": {
      "cacheID": "f763af78d4b4efe6b6ea7428914ab493",
      "id": null,
      "metadata": {},
      "name": "FieldMappingSelectorQuery",
      "operationKind": "query",
      "text": "query FieldMappingSelectorQuery(\n  $where: IntegrationFieldMappingConfigurationFilter!\n) {\n  ...FieldMappingSelectorResults_integrationFieldMappings\n}\n\nfragment FieldMappingSelectorResults_integrationFieldMappings on Query {\n  integrationFieldMappings(first: 10, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        fieldMappingConfigurationId\n        name\n        sourceSystem {\n          displayName\n          key\n        }\n        sourceType\n        targetSystem {\n          displayName\n          key\n        }\n        targetType\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node42.hash = "2a9ac38a5be5be3ae03aee93ee6aef27";
var FieldMappingSelectorQuery_graphql_default = node42;

// src/custom-data/components/FieldMappingSelector.tsx
import { useCallback as useCallback32 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery2 } from "react-relay";

// src/custom-data/components/__generated__/FieldMappingSelectorResultsQuery.graphql.ts
var node43 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v4 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "FieldMappingSelectorResultsQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "FieldMappingSelectorResults_integrationFieldMappings"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "FieldMappingSelectorResultsQuery",
      "selections": [
        {
          "alias": null,
          "args": v3,
          "concreteType": "IntegrationFieldMappingsConnection",
          "kind": "LinkedField",
          "name": "integrationFieldMappings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationFieldMappingsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationFieldMappingConfiguration",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fieldMappingConfigurationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "IntegrationSystemsType",
                      "kind": "LinkedField",
                      "name": "sourceSystem",
                      "plural": false,
                      "selections": v4,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "IntegrationSystemsType",
                      "kind": "LinkedField",
                      "name": "targetSystem",
                      "plural": false,
                      "selections": v4,
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "targetType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "FieldMappingSelectorResults_integrationFieldMappings",
          "kind": "LinkedHandle",
          "name": "integrationFieldMappings"
        }
      ]
    },
    "params": {
      "cacheID": "c2a5bdecaf3ae46a0b3501a848c680ea",
      "id": null,
      "metadata": {},
      "name": "FieldMappingSelectorResultsQuery",
      "operationKind": "query",
      "text": "query FieldMappingSelectorResultsQuery(\n  $after: String\n  $first: Int = 10\n  $where: IntegrationFieldMappingConfigurationFilter\n) {\n  ...FieldMappingSelectorResults_integrationFieldMappings_2HEEH6\n}\n\nfragment FieldMappingSelectorResults_integrationFieldMappings_2HEEH6 on Query {\n  integrationFieldMappings(first: $first, after: $after, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        fieldMappingConfigurationId\n        name\n        sourceSystem {\n          displayName\n          key\n        }\n        sourceType\n        targetSystem {\n          displayName\n          key\n        }\n        targetType\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node43.hash = "d54615c8bbdc1cab1defc18240a78a2e";
var FieldMappingSelectorResultsQuery_graphql_default = node43;

// src/custom-data/components/__generated__/FieldMappingSelectorResults_integrationFieldMappings.graphql.ts
var node44 = function() {
  var v0 = [
    "integrationFieldMappings"
  ], v1 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    }
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": FieldMappingSelectorResultsQuery_graphql_default
      }
    },
    "name": "FieldMappingSelectorResults_integrationFieldMappings",
    "selections": [
      {
        "alias": "integrationFieldMappings",
        "args": null,
        "concreteType": "IntegrationFieldMappingsConnection",
        "kind": "LinkedField",
        "name": "__FieldMappingSelectorResults_integrationFieldMappings_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationFieldMappingsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationFieldMappingConfiguration",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fieldMappingConfigurationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IntegrationSystemsType",
                    "kind": "LinkedField",
                    "name": "sourceSystem",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IntegrationSystemsType",
                    "kind": "LinkedField",
                    "name": "targetSystem",
                    "plural": false,
                    "selections": v1,
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "targetType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node44.hash = "d54615c8bbdc1cab1defc18240a78a2e";
var FieldMappingSelectorResults_integrationFieldMappings_graphql_default = node44;

// src/custom-data/components/FieldMappingSelectorResults.tsx
import { useCallback as useCallback31, useState as useState9 } from "react";
import { usePaginationFragment as usePaginationFragment7 } from "react-relay";
import {
  Button as Button16,
  ButtonList as ButtonList6,
  EdListHeader as EdListHeader7,
  SelectMenu as SelectMenu4
} from "shared-ui";
import { jsx as jsx40, jsxs as jsxs27 } from "react/jsx-runtime";
var fragment13 = FieldMappingSelectorResults_integrationFieldMappings_graphql_default;
var FieldMappingSelectorResultsResults = ({
  integrationFieldMappingsKey,
  onSelect
}) => {
  const select = useCallback31((event) => {
    onSelect(event);
  }, []);
  const [current, setCurrent] = useState9(null);
  const onSetCurrent = useCallback31(
    (item) => {
      setCurrent(item);
    },
    [current]
  );
  const paging = usePaginationFragment7(fragment13, integrationFieldMappingsKey);
  const { data } = paging;
  const { integrationFieldMappings } = data;
  const mappings = integrationFieldMappings?.edges;
  let results;
  if (mappings && mappings.length > 0) {
    const items = mappings.map((e) => {
      return {
        id: e.node.fieldMappingConfigurationId,
        name: e.node.name
      };
    });
    let selectedMapping;
    if (current) {
      const mapping = mappings.find(
        (m) => m.node.fieldMappingConfigurationId === current.id
      );
      if (mapping) {
        selectedMapping = /* @__PURE__ */ jsxs27("div", { className: "my-2 border px-4 py-2", children: [
          /* @__PURE__ */ jsx40("div", { className: "text-info-900 mb-2 border-b border-gray-100 py-2 font-medium", children: mapping.node.name }),
          /* @__PURE__ */ jsxs27("div", { className: "flex items-center space-x-2", children: [
            /* @__PURE__ */ jsx40("div", { className: "w-12 font-medium text-gray-500", children: "Source" }),
            /* @__PURE__ */ jsx40("div", { className: "w-16", children: mapping.node.sourceSystem.displayName }),
            /* @__PURE__ */ jsx40("div", { className: "text-info-500 font-medium", children: mapping.node.sourceType })
          ] }),
          /* @__PURE__ */ jsxs27("div", { className: "flex items-center space-x-2", children: [
            /* @__PURE__ */ jsx40("div", { className: "w-12 font-medium text-gray-500", children: "Target" }),
            /* @__PURE__ */ jsx40("div", { className: "w-16", children: mapping.node.targetSystem.displayName }),
            /* @__PURE__ */ jsx40("div", { className: "text-info-500 font-medium", children: mapping.node.targetType })
          ] }),
          /* @__PURE__ */ jsxs27(ButtonList6, { children: [
            /* @__PURE__ */ jsx40(Button16, { color: "gray", clicked: () => setCurrent(null), children: "Cancel" }),
            /* @__PURE__ */ jsx40(Button16, { clicked: () => select(current), children: "Use" })
          ] })
        ] }, mapping.node.id);
      }
    }
    results = /* @__PURE__ */ jsxs27("div", { children: [
      /* @__PURE__ */ jsx40(EdListHeader7, { paging }),
      selectedMapping ? null : /* @__PURE__ */ jsx40(
        SelectMenu4,
        {
          title: "Select Mapping",
          items,
          onChange: onSetCurrent,
          value: current
        }
      ),
      selectedMapping ? /* @__PURE__ */ jsx40("div", { className: "mt-4", children: selectedMapping }) : null
    ] });
  } else {
    results = /* @__PURE__ */ jsx40("div", { children: /* @__PURE__ */ jsx40("div", { className: "text-info-500 text-xl font-medium", children: "No suitable custom field mappings are available" }) });
  }
  return /* @__PURE__ */ jsx40("div", { children: results });
};
var FieldMappingSelectorResults_default = FieldMappingSelectorResultsResults;

// src/custom-data/components/FieldMappingSelector.tsx
import { jsx as jsx41 } from "react/jsx-runtime";
var graphqlQuery2 = FieldMappingSelectorQuery_graphql_default;
var FieldMappingSelector = ({
  onSelect,
  sourceSystem,
  sourceType,
  targetSystem,
  targetType
}) => {
  const select = useCallback32((event) => {
    onSelect(event);
  }, []);
  const where = {};
  if (sourceType) {
    where.sourceSystem = { eq: sourceSystem };
  }
  if (sourceType) {
    where.sourceType = { eq: sourceType };
  }
  if (targetSystem) {
    where.targetSystem = { eq: targetSystem };
  }
  if (targetType) {
    where.targetType = { eq: targetType };
  }
  const query3 = useLazyLoadQuery2(
    graphqlQuery2,
    { where },
    {
      fetchPolicy: "store-and-network"
    }
  );
  return /* @__PURE__ */ jsx41(
    FieldMappingSelectorResults_default,
    {
      integrationFieldMappingsKey: query3,
      onSelect: select
    }
  );
};
var FieldMappingSelector_default = FieldMappingSelector;

// src/custom-data/mutations/field-mapping-config/__generated__/CreateFieldMappingConfigMutation.graphql.ts
var node45 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    }
  ], v5 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfFieldMappingConfiguration",
    "kind": "LinkedField",
    "name": "fieldMappingConfiguration",
    "plural": false,
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IntegrationFieldMappingConfiguration",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fieldMappingConfigurationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationSystemsType",
            "kind": "LinkedField",
            "name": "sourceSystem",
            "plural": false,
            "selections": v4,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationSystemsType",
            "kind": "LinkedField",
            "name": "targetSystem",
            "plural": false,
            "selections": v4,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "targetType",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "CreateFieldMappingConfigMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "FieldMappingPayload",
          "kind": "LinkedField",
          "name": "integrationsCreateFieldMapping",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v6,
                v7
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "CreateFieldMappingConfigMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "FieldMappingPayload",
          "kind": "LinkedField",
          "name": "integrationsCreateFieldMapping",
          "plural": false,
          "selections": [
            v5,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "prependEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "fieldMappingConfiguration",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3,
                v6,
                v7
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "ac5ba97c20c58b3f45a23c921d880762",
      "id": null,
      "metadata": {},
      "name": "CreateFieldMappingConfigMutation",
      "operationKind": "mutation",
      "text": "mutation CreateFieldMappingConfigMutation(\n  $input: CreateFieldMappingInput!\n) {\n  integrationsCreateFieldMapping(input: $input) {\n    fieldMappingConfiguration {\n      __typename\n      cursor\n      node {\n        id\n        fieldMappingConfigurationId\n        createdOn\n        updatedOn\n        name\n        sourceSystem {\n          displayName\n          key\n        }\n        sourceType\n        targetSystem {\n          displayName\n          key\n        }\n        targetType\n      }\n    }\n    userErrors {\n      __typename\n      code\n      message\n    }\n  }\n}\n"
    }
  };
}();
node45.hash = "0f563225dc5e850cafe3303e164dd795";
var CreateFieldMappingConfigMutation_graphql_default = node45;

// src/custom-data/mutations/field-mapping-config/CreateFieldMappingConfigMutation.ts
import { createConnectedCommitMutation as createConnectedCommitMutation8 } from "shared-lib";
var mutation16 = CreateFieldMappingConfigMutation_graphql_default;
var commit16 = createConnectedCommitMutation8(mutation16);
var CreateFieldMappingConfigMutation_default = { commit: commit16 };

// src/custom-data/mutations/field-mapping-config/__generated__/SaveFieldMappingConfigMutation.graphql.ts
var node46 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  }, v6 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    v5
  ], v7 = [
    v5,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "processorTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ], v8 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfFieldMappingConfiguration",
    "kind": "LinkedField",
    "name": "fieldMappingConfiguration",
    "plural": false,
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IntegrationFieldMappingConfiguration",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          v4,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationSystemsType",
            "kind": "LinkedField",
            "name": "sourceSystem",
            "plural": false,
            "selections": v6,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationSystemsType",
            "kind": "LinkedField",
            "name": "targetSystem",
            "plural": false,
            "selections": v6,
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "targetType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationMappableAction",
            "kind": "LinkedField",
            "name": "mappings",
            "plural": true,
            "selections": [
              v4,
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationMappable",
                "kind": "LinkedField",
                "name": "source",
                "plural": false,
                "selections": v7,
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationMappable",
                "kind": "LinkedField",
                "name": "target",
                "plural": false,
                "selections": v7,
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "SaveFieldMappingConfigMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "FieldMappingPayload",
          "kind": "LinkedField",
          "name": "integrationsSaveFieldMapping",
          "plural": false,
          "selections": [
            v8,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v9,
                v10
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "SaveFieldMappingConfigMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "FieldMappingPayload",
          "kind": "LinkedField",
          "name": "integrationsSaveFieldMapping",
          "plural": false,
          "selections": [
            v8,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "prependEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "fieldMappingConfiguration",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3,
                v9,
                v10
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "99783f5ecd4ed38adffe8b1b341f066b",
      "id": null,
      "metadata": {},
      "name": "SaveFieldMappingConfigMutation",
      "operationKind": "mutation",
      "text": "mutation SaveFieldMappingConfigMutation(\n  $input: SaveMappingConfigurationInput!\n) {\n  integrationsSaveFieldMapping(input: $input) {\n    fieldMappingConfiguration {\n      __typename\n      cursor\n      node {\n        id\n        createdOn\n        updatedOn\n        name\n        sourceSystem {\n          displayName\n          key\n        }\n        sourceType\n        targetSystem {\n          displayName\n          key\n        }\n        targetType\n        mappings {\n          id\n          source {\n            key\n            label\n            dataTypeKey\n            processorTypeKey\n            value\n          }\n          target {\n            key\n            label\n            dataTypeKey\n            processorTypeKey\n            value\n          }\n        }\n      }\n    }\n    userErrors {\n      __typename\n      code\n      message\n    }\n  }\n}\n"
    }
  };
}();
node46.hash = "9820810444253db4c3e51fe6c086c567";
var SaveFieldMappingConfigMutation_graphql_default = node46;

// src/custom-data/mutations/field-mapping-config/SaveFieldMappingConfigMutation.ts
import { createConnectedCommitMutation as createConnectedCommitMutation9 } from "shared-lib";
var mutation17 = SaveFieldMappingConfigMutation_graphql_default;
var commit17 = createConnectedCommitMutation9(mutation17);
var SaveFieldMappingConfigMutation_default = { commit: commit17 };

// src/bullhorn/components/config/components/FetchConfigurationEditor.tsx
import { jsx as jsx42, jsxs as jsxs28 } from "react/jsx-runtime";
var graphqlQuery3 = FetchConfigurationEditorQuery_graphql_default;
var FetchConfigurationEditor = ({
  tenantNodeId,
  configType,
  candidateConfig,
  jobOrderConfig,
  onSaved,
  onCancelled
}) => {
  let entity;
  switch (configType) {
    case "Candidate" /* Candidate */: {
      entity = "BULLHORN_CANDIDATE";
      break;
    }
    case "JobOrder" /* JobOrder */: {
      entity = "BULLHORN_JOB_ORDER";
      break;
    }
  }
  const [field, setField] = useState10(null);
  const [fieldValue, setFieldValue] = useState10(null);
  const onSetField = useCallback33(
    (item) => {
      setField(item);
    },
    [field]
  );
  const environment = useRelayEnvironment11();
  const [isBusy, setBusy] = useState10(false);
  const onSaveFetchConfig = useCallback33(() => {
    if (field && fieldValue) {
      setBusy(true);
      logInfo6(JSON.stringify(field));
      const input = {
        id: tenantNodeId,
        candidateFetchFields: [...candidateConfig.fields],
        jobOrderFetchFields: [...jobOrderConfig.fields],
        clientMutationId: "TODO"
      };
      if (configType == "JobOrder" /* JobOrder */) {
        input.jobOrderFetchFields = [
          {
            fieldName: field.id,
            fieldValue
          }
        ];
      }
      if (configType == "Candidate" /* Candidate */) {
        input.candidateFetchFields = [
          {
            fieldName: field.id,
            fieldValue
          }
        ];
      }
      TenantUpdateFetchConfigurationMutation_default.commit(environment, input, () => {
        setBusy(false);
        onSaved();
      });
    }
  }, [field, fieldValue]);
  const onClearFetchConfig = useCallback33(() => {
    setBusy(true);
    const input = {
      id: tenantNodeId,
      candidateFetchFields: [...candidateConfig.fields],
      jobOrderFetchFields: [...jobOrderConfig.fields],
      clientMutationId: "TODO"
    };
    if (configType == "JobOrder" /* JobOrder */) {
      input.jobOrderFetchFields = [];
    }
    if (configType == "Candidate" /* Candidate */) {
      input.candidateFetchFields = [];
    }
    TenantUpdateFetchConfigurationMutation_default.commit(environment, input, () => {
      setBusy(false);
      onSaved();
    });
  }, []);
  const query3 = useLazyLoadQuery3(
    graphqlQuery3,
    { entity },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { customFields } = query3;
  const customFieldItems = integrationFieldMappingsToListItems(customFields);
  return /* @__PURE__ */ jsx42("div", { className: "p-8", children: /* @__PURE__ */ jsxs28("div", { children: [
    /* @__PURE__ */ jsxs28("div", { className: "mb-4", children: [
      /* @__PURE__ */ jsx42("div", { children: /* @__PURE__ */ jsx42(
        SelectMenu5,
        {
          title: "Custom Field",
          items: customFieldItems,
          onChange: onSetField,
          value: field
        }
      ) }),
      /* @__PURE__ */ jsxs28("div", { className: "py-2", children: [
        /* @__PURE__ */ jsx42("div", { className: "py-2", children: "Field Value" }),
        /* @__PURE__ */ jsx42(Input4, { name: "fieldValue", onValueChange: setFieldValue })
      ] })
    ] }),
    /* @__PURE__ */ jsx42("div", { className: "", children: /* @__PURE__ */ jsxs28(ButtonList7, { children: [
      /* @__PURE__ */ jsx42(Button17, { color: "gray", disabled: isBusy, clicked: onCancelled, children: "Cancel" }),
      /* @__PURE__ */ jsx42(
        Button17,
        {
          color: "primary",
          disabled: field === null || isBusy,
          clicked: onSaveFetchConfig,
          children: "Save"
        }
      ),
      /* @__PURE__ */ jsx42(
        Button17,
        {
          color: "warning",
          disabled: isBusy,
          clicked: onClearFetchConfig,
          children: "Clear"
        }
      )
    ] }) })
  ] }) });
};
var FetchConfigurationEditor_default = FetchConfigurationEditor;

// src/bullhorn/components/config/components/FetchConfigurationViewer.tsx
import { jsx as jsx43, jsxs as jsxs29 } from "react/jsx-runtime";
var FetchConfigurationViewer = ({
  tenantNodeId,
  configType,
  candidateConfig,
  jobOrderConfig
}) => {
  const [editing, toggleEditing] = useToggle3();
  const onToggleEdit = useCallback34(() => {
    toggleEditing();
  }, [editing]);
  let current;
  function viewer(config) {
    if (config.fields && config.fields.length === 0) {
      return /* @__PURE__ */ jsx43("div", { className: "px-1 py-3", children: /* @__PURE__ */ jsx43(Button18, { color: "primary", clicked: onToggleEdit, children: "Setup Fetch Configuration" }) });
    } else {
      return /* @__PURE__ */ jsxs29("div", { children: [
        /* @__PURE__ */ jsxs29("table", { className: "min-w-full divide-y divide-gray-200", children: [
          /* @__PURE__ */ jsx43("thead", { className: "bg-gray-50", children: /* @__PURE__ */ jsxs29("tr", { children: [
            /* @__PURE__ */ jsx43(
              "th",
              {
                scope: "col",
                className: "px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500",
                children: "Field Name"
              }
            ),
            /* @__PURE__ */ jsxs29(
              "th",
              {
                scope: "col",
                className: "px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500",
                children: [
                  /* @__PURE__ */ jsx43("div", { children: "Required Value" }),
                  /* @__PURE__ */ jsx43("div", { children: "(Comma Separated List)" })
                ]
              }
            )
          ] }) }),
          /* @__PURE__ */ jsx43("tbody", { children: config.fields.map((field, idx) => {
            return /* @__PURE__ */ jsxs29(
              "tr",
              {
                className: idx % 2 === 0 ? "bg-white" : "bg-gray-50",
                children: [
                  /* @__PURE__ */ jsx43("td", { className: "whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900", children: field.fieldName }),
                  /* @__PURE__ */ jsx43("td", { className: "whitespace-nowrap px-6 py-4 text-sm text-gray-500", children: field.fieldValue })
                ]
              },
              field.fieldName
            );
          }) })
        ] }),
        /* @__PURE__ */ jsx43("div", { className: "flex justify-end px-1 py-3", children: /* @__PURE__ */ jsx43(Button18, { color: "primary", clicked: onToggleEdit, children: "Edit" }) })
      ] });
    }
  }
  switch (editing) {
    case true: {
      current = /* @__PURE__ */ jsx43(
        FetchConfigurationEditor_default,
        {
          tenantNodeId,
          configType,
          jobOrderConfig,
          candidateConfig,
          onCancelled: onToggleEdit,
          onSaved: onToggleEdit
        }
      );
      break;
    }
    case false: {
      switch (configType) {
        case "Candidate" /* Candidate */: {
          current = viewer(candidateConfig);
          break;
        }
        case "JobOrder" /* JobOrder */: {
          current = viewer(jobOrderConfig);
          break;
        }
      }
      break;
    }
  }
  return /* @__PURE__ */ jsx43("div", { children: current });
};
var FetchConfigurationViewer_default = FetchConfigurationViewer;

// src/bullhorn/components/config/components/WorkflowConfigurationViewer.tsx
import { jsx as jsx44, jsxs as jsxs30 } from "react/jsx-runtime";
var WorkflowConfigurationViewer = ({ config }) => {
  return /* @__PURE__ */ jsx44("div", { className: "p-8", children: /* @__PURE__ */ jsxs30("table", { className: "min-w-full divide-y divide-gray-200", children: [
    /* @__PURE__ */ jsx44("thead", { className: "bg-gray-50", children: /* @__PURE__ */ jsxs30("tr", { children: [
      /* @__PURE__ */ jsx44(
        "th",
        {
          scope: "col",
          className: "px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500",
          children: "Configuration"
        }
      ),
      /* @__PURE__ */ jsx44(
        "th",
        {
          scope: "col",
          className: "px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500",
          children: /* @__PURE__ */ jsx44("div", { children: "Required Value" })
        }
      )
    ] }) }),
    /* @__PURE__ */ jsxs30("tbody", { children: [
      /* @__PURE__ */ jsxs30("tr", { className: "bg-white", children: [
        /* @__PURE__ */ jsx44("td", { className: "whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900", children: "JobOrder Workflow" }),
        /* @__PURE__ */ jsx44("td", { className: "whitespace-nowrap px-6 py-4 text-sm text-gray-500", children: config.jobOrderWorkflowId ?? "Custom" })
      ] }),
      /* @__PURE__ */ jsxs30("tr", { className: "bg-gray-50", children: [
        /* @__PURE__ */ jsx44("td", { className: "whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900", children: "Candidate Workflow" }),
        /* @__PURE__ */ jsx44("td", { className: "whitespace-nowrap px-6 py-4 text-sm text-gray-500", children: config.candidateWorkflowId ?? "Custom" })
      ] }),
      /* @__PURE__ */ jsxs30("tr", { className: "bg-white", children: [
        /* @__PURE__ */ jsx44("td", { className: "whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900", children: "Vault JobSubmission Workflow" }),
        /* @__PURE__ */ jsx44("td", { className: "whitespace-nowrap px-6 py-4 text-sm text-gray-500", children: config.vaultJobSubmissionWorkflowId ?? "Custom" })
      ] }),
      /* @__PURE__ */ jsxs30("tr", { className: "bg-gray-50", children: [
        /* @__PURE__ */ jsx44("td", { className: "whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900", children: "Application JobSubmission Workflow" }),
        /* @__PURE__ */ jsx44("td", { className: "whitespace-nowrap px-6 py-4 text-sm text-gray-500", children: config.applicationJobSubmissionWorkflowId ?? "Custom" })
      ] }),
      /* @__PURE__ */ jsxs30("tr", { className: "bg-white", children: [
        /* @__PURE__ */ jsx44("td", { className: "whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900", children: "Recommendation JobSubmission Workflow" }),
        /* @__PURE__ */ jsx44("td", { className: "whitespace-nowrap px-6 py-4 text-sm text-gray-500", children: config.recommendationJobSubmissionWorkflowId ?? "Custom" })
      ] })
    ] })
  ] }) });
};
var WorkflowConfigurationViewer_default = WorkflowConfigurationViewer;

// src/bullhorn/components/config/components/TenantToggleEnabledButton.tsx
import { useCallback as useCallback35 } from "react";
import { ConnectionHandler as ConnectionHandler11, useRelayEnvironment as useRelayEnvironment12 } from "react-relay";
import { useToggle as useToggle4, createClientMutationId as createClientMutationId5 } from "shared-lib";
import { Button as Button19 } from "shared-ui";
import { jsx as jsx45 } from "react/jsx-runtime";
var TenantToggleEnabledButton = (props) => {
  const { title, onStart, onDone, onError, tenantId, ...rest } = props;
  const [isBusy, toggleBusy] = useToggle4(false);
  const onToggleBusy = useCallback35(() => {
    toggleBusy();
  }, []);
  const environment = useRelayEnvironment12();
  const connectionId = ConnectionHandler11.getConnectionID(
    "root",
    // passed as input to the mutation/subscription
    "BullhornTenantList_bullhornTenants"
  );
  const TenantToggleEnabledEvent = useCallback35(() => {
    if (!tenantId) {
      return;
    }
    onStart();
    onToggleBusy();
    const clientMutationId = createClientMutationId5();
    const input = {
      id: tenantId,
      clientMutationId
    };
    TenantToggleEnabledMutation_default.commit(
      environment,
      input,
      connectionId,
      () => {
        onToggleBusy();
        onDone();
      },
      () => {
        onToggleBusy();
        onError();
      }
    );
  }, []);
  return /* @__PURE__ */ jsx45(Button19, { clicked: TenantToggleEnabledEvent, ...rest, disabled: isBusy, children: title });
};

// src/bullhorn/components/tenants/BullhornTenantConfig.tsx
import { jsx as jsx46, jsxs as jsxs31 } from "react/jsx-runtime";
var query = BullhornTenantConfigQuery_graphql_default;
function createLabel(text) {
  return /* @__PURE__ */ jsx46("div", { className: "text-success-500 px-1 py-3 font-medium", children: text });
}
var BullhornTenantConfig = ({ tenantNodeId }) => {
  const [isBusy, toggleBusy] = useToggle5(false);
  const onToggleBusy = useCallback36(() => {
    toggleBusy();
  }, []);
  const { config } = useLazyLoadQuery4(
    query,
    {
      id: tenantNodeId
    },
    {
      fetchPolicy: "store-and-network"
    }
  );
  if (!config) {
    return /* @__PURE__ */ jsx46("div", { children: "No Config" });
  }
  return /* @__PURE__ */ jsxs31(EdGridLayout, { children: [
    /* @__PURE__ */ jsx46(EdCard, { title: "Is Enabled", children: /* @__PURE__ */ jsxs31("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ jsxs31("div", { children: [
        !isBusy ? createLabel(config.isEnabled ? "Enabled" : "Disabled") : null,
        isBusy ? /* @__PURE__ */ jsx46("div", { className: "text-info-500 my-4 p-2 font-bold", children: "Working...." }) : null
      ] }),
      /* @__PURE__ */ jsx46("div", { children: config.isEnabled ? /* @__PURE__ */ jsx46("div", { children: /* @__PURE__ */ jsx46(
        TenantToggleEnabledButton,
        {
          title: "Disable",
          tenantId: tenantNodeId,
          onStart: onToggleBusy,
          onDone: onToggleBusy,
          onError: onToggleBusy
        }
      ) }) : /* @__PURE__ */ jsx46("div", { children: /* @__PURE__ */ jsx46(
        TenantToggleEnabledButton,
        {
          title: "Enable",
          tenantId: tenantNodeId,
          onStart: onToggleBusy,
          onDone: onToggleBusy,
          onError: onToggleBusy
        }
      ) }) })
    ] }) }),
    /* @__PURE__ */ jsx46(EdCard, { title: "Rest Authorize Url", children: createLabel(config.restAuthorizeBaseUrl) }),
    /* @__PURE__ */ jsx46(EdCard, { title: "Rest Login Url", children: createLabel(config.restLoginBaseUrl) }),
    /* @__PURE__ */ jsx46(EdCard, { title: "Rest Token Url", children: createLabel(config.restTokenBaseUrl) }),
    /* @__PURE__ */ jsx46(EdCard, { title: "Job Orders Fetch Config", children: /* @__PURE__ */ jsx46(
      FetchConfigurationViewer_default,
      {
        tenantNodeId,
        configType: "JobOrder" /* JobOrder */,
        candidateConfig: config.candidateFetchConfiguration,
        jobOrderConfig: config.jobOrderFetchConfiguration
      }
    ) }),
    /* @__PURE__ */ jsx46(EdCard, { title: "Candidate Fetch Config", children: /* @__PURE__ */ jsx46(
      FetchConfigurationViewer_default,
      {
        tenantNodeId,
        configType: "Candidate" /* Candidate */,
        candidateConfig: config.candidateFetchConfiguration,
        jobOrderConfig: config.jobOrderFetchConfiguration
      }
    ) })
  ] });
};
var BullhornTenantConfig_default = BullhornTenantConfig;

// src/bullhorn/components/tenants/__generated__/BullhornTenantDetail_bullhornTenant.graphql.ts
var node47 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BullhornTenantDetail_bullhornTenant",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tenantId",
      "storageKey": null
    }
  ],
  "type": "BullhornTenant",
  "abstractKey": null
};
node47.hash = "8f69381ef32412331689d822e2997ee6";
var BullhornTenantDetail_bullhornTenant_graphql_default = node47;

// src/bullhorn/components/tenants/BullhornTenantDetail.tsx
import { Suspense as Suspense2, useCallback as useCallback42 } from "react";
import { useFragment as useFragment13 } from "react-relay";
import { ButtonTabPills, EdCard as EdCard3, EdGridLayout as EdGridLayout2, useTabs } from "shared-ui";

// src/bullhorn/components/tenants/__generated__/BullhornTenantDefaultMappingsEditorPageQuery.graphql.ts
var node48 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "tenantId"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "defaultCandidateMappingConfigurationId",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v5 = [
    v4,
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BullhornTenantDefaultMappingViewer_config"
    }
  ], v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "defaultJobOrderMappingConfigurationId",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "defaultJobSubmissionMappingConfigurationId",
    "storageKey": null
  }, v8 = {
    "kind": "ClientExtension",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__id",
        "storageKey": null
      }
    ]
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  }, v10 = [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    v9
  ], v11 = [
    v9,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "processorTypeKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ], v12 = [
    v4,
    v2,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IntegrationSystemsType",
      "kind": "LinkedField",
      "name": "sourceSystem",
      "plural": false,
      "selections": v10,
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sourceType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IntegrationSystemsType",
      "kind": "LinkedField",
      "name": "targetSystem",
      "plural": false,
      "selections": v10,
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "targetType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IntegrationMappableAction",
      "kind": "LinkedField",
      "name": "mappings",
      "plural": true,
      "selections": [
        v2,
        {
          "alias": null,
          "args": null,
          "concreteType": "IntegrationMappable",
          "kind": "LinkedField",
          "name": "source",
          "plural": false,
          "selections": v11,
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IntegrationMappable",
          "kind": "LinkedField",
          "name": "target",
          "plural": false,
          "selections": v11,
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornTenantDefaultMappingsEditorPageQuery",
      "selections": [
        {
          "alias": "tenant",
          "args": v1,
          "concreteType": "BullhornTenant",
          "kind": "LinkedField",
          "name": "bullhornTenantById",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationFieldMappingConfiguration",
              "kind": "LinkedField",
              "name": "defaultCandidateMappingConfiguration",
              "plural": false,
              "selections": v5,
              "storageKey": null
            },
            v6,
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationFieldMappingConfiguration",
              "kind": "LinkedField",
              "name": "defaultJobOrderMappingConfiguration",
              "plural": false,
              "selections": v5,
              "storageKey": null
            },
            v7,
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationFieldMappingConfiguration",
              "kind": "LinkedField",
              "name": "defaultJobSubmissionMappingConfiguration",
              "plural": false,
              "selections": v5,
              "storageKey": null
            },
            v8
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "BullhornTenantDefaultMappingsEditorPageQuery",
      "selections": [
        {
          "alias": "tenant",
          "args": v1,
          "concreteType": "BullhornTenant",
          "kind": "LinkedField",
          "name": "bullhornTenantById",
          "plural": false,
          "selections": [
            v2,
            v3,
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationFieldMappingConfiguration",
              "kind": "LinkedField",
              "name": "defaultCandidateMappingConfiguration",
              "plural": false,
              "selections": v12,
              "storageKey": null
            },
            v6,
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationFieldMappingConfiguration",
              "kind": "LinkedField",
              "name": "defaultJobOrderMappingConfiguration",
              "plural": false,
              "selections": v12,
              "storageKey": null
            },
            v7,
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationFieldMappingConfiguration",
              "kind": "LinkedField",
              "name": "defaultJobSubmissionMappingConfiguration",
              "plural": false,
              "selections": v12,
              "storageKey": null
            },
            v8
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "9c5d8d6c11a47b1ce4bd16989379b3e0",
      "id": null,
      "metadata": {},
      "name": "BullhornTenantDefaultMappingsEditorPageQuery",
      "operationKind": "query",
      "text": "query BullhornTenantDefaultMappingsEditorPageQuery(\n  $tenantId: UUID!\n) {\n  tenant: bullhornTenantById(id: $tenantId) {\n    id\n    defaultCandidateMappingConfigurationId\n    defaultCandidateMappingConfiguration {\n      name\n      ...BullhornTenantDefaultMappingViewer_config\n      id\n    }\n    defaultJobOrderMappingConfigurationId\n    defaultJobOrderMappingConfiguration {\n      name\n      ...BullhornTenantDefaultMappingViewer_config\n      id\n    }\n    defaultJobSubmissionMappingConfigurationId\n    defaultJobSubmissionMappingConfiguration {\n      name\n      ...BullhornTenantDefaultMappingViewer_config\n      id\n    }\n  }\n}\n\nfragment BullhornTenantDefaultMappingViewer_config on IntegrationFieldMappingConfiguration {\n  ...FieldMappingConfigurationDetail_fieldMappingConfiguration\n}\n\nfragment FieldMappingConfigurationDetail_fieldMappingConfiguration on IntegrationFieldMappingConfiguration {\n  id\n  createdOn\n  updatedOn\n  name\n  sourceSystem {\n    displayName\n    key\n  }\n  sourceType\n  targetSystem {\n    displayName\n    key\n  }\n  targetType\n  mappings {\n    id\n    source {\n      key\n      label\n      dataTypeKey\n      processorTypeKey\n      value\n    }\n    target {\n      key\n      label\n      dataTypeKey\n      processorTypeKey\n      value\n    }\n  }\n}\n"
    }
  };
}();
node48.hash = "2282f8a6d5e09b3a8dcf90d1143e1993";
var BullhornTenantDefaultMappingsEditorPageQuery_graphql_default = node48;

// src/bullhorn/components/tenants/BullhornTenantDefaultMappingsEditor.tsx
import { useCallback as useCallback39, useState as useState11 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery5, useRelayEnvironment as useRelayEnvironment13 } from "react-relay";
import { createClientMutationId as createClientMutationId6 } from "shared-lib";
import { ButtonList as ButtonList8, TabButton as TabButton2 } from "shared-ui";

// src/bullhorn/components/tenants/BullhornTenantDefaultMappingEditor.tsx
import { useCallback as useCallback37 } from "react";
import { classNames } from "shared-ui";
import { jsx as jsx47, jsxs as jsxs32 } from "react/jsx-runtime";
var BullhornTenantDefaultMappingEditor = ({
  title,
  defaultConfig,
  sourceSystem,
  sourceType,
  targetSystem,
  targetType,
  onChanged,
  className
}) => {
  const onChange = useCallback37((config) => {
    onChanged(config);
  }, []);
  return /* @__PURE__ */ jsxs32(
    "div",
    {
      className: classNames("border bg-white p-8", className ? className : ""),
      children: [
        /* @__PURE__ */ jsx47("div", { className: "mb-4 border-b pb-2", children: title }),
        /* @__PURE__ */ jsx47("div", { children: /* @__PURE__ */ jsx47(
          FieldMappingSelector_default,
          {
            sourceSystem,
            sourceType,
            targetSystem,
            targetType,
            onSelect: onChange
          }
        ) })
      ]
    }
  );
};
var BullhornTenantDefaultMappingEditor_default = BullhornTenantDefaultMappingEditor;

// src/bullhorn/components/tenants/__generated__/BullhornTenantDefaultMappingViewer_config.graphql.ts
var node49 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BullhornTenantDefaultMappingViewer_config",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FieldMappingConfigurationDetail_fieldMappingConfiguration"
    }
  ],
  "type": "IntegrationFieldMappingConfiguration",
  "abstractKey": null
};
node49.hash = "8af1432da4155763c4c219304fce2624";
var BullhornTenantDefaultMappingViewer_config_graphql_default = node49;

// src/bullhorn/components/tenants/BullhornTenantDefaultMappingViewer.tsx
import { useCallback as useCallback38 } from "react";
import { useFragment as useFragment12 } from "react-relay";
import { Button as Button20 } from "shared-ui";
import { jsx as jsx48, jsxs as jsxs33 } from "react/jsx-runtime";
var fragment14 = BullhornTenantDefaultMappingViewer_config_graphql_default;
var BullhornTenantDefaultMappingViewer = ({
  title,
  config,
  onEdit,
  className
}) => {
  const data = useFragment12(
    fragment14,
    config
  );
  const edit = useCallback38(() => {
    if (onEdit) {
      onEdit();
    }
  }, []);
  if (!data) {
    return /* @__PURE__ */ jsxs33("div", { className: "border bg-white p-5", children: [
      /* @__PURE__ */ jsx48("div", { className: "text-info-500 text-lg font-medium", children: title }),
      /* @__PURE__ */ jsx48("div", { children: "No custom configuration saved." }),
      /* @__PURE__ */ jsx48("div", { className: "flex justify-center px-4 py-2", children: /* @__PURE__ */ jsx48(Button20, { color: "primary", clicked: edit, children: "Create" }) })
    ] });
  }
  return /* @__PURE__ */ jsx48(
    FieldMappingConfigurationDetail_default,
    {
      className,
      actions: /* @__PURE__ */ jsx48("div", { className: "flex justify-end px-4 py-2", children: /* @__PURE__ */ jsx48(Button20, { color: "primary", clicked: edit, children: "Edit" }) }),
      fieldMappingConfiguration: data
    }
  );
};

// src/bullhorn/components/tenants/BullhornTenantDefaultMappingsEditor.tsx
import { jsx as jsx49, jsxs as jsxs34 } from "react/jsx-runtime";
var graphqlQuery4 = BullhornTenantDefaultMappingsEditorPageQuery_graphql_default;
var BullhornTenantDefaultMappingsEditor = ({
  tenantId,
  onDone
}) => {
  const query3 = useLazyLoadQuery5(
    graphqlQuery4,
    { tenantId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { tenant } = query3;
  const environment = useRelayEnvironment13();
  const [selected, setSelected] = useState11(null);
  const onSetSelected = useCallback39(
    (state) => {
      setSelected(state);
    },
    [selected]
  );
  const onSaveConfig = useCallback39(
    (current2, change) => {
      if (!tenant) {
        return;
      }
      const ids = {
        ...current2,
        ...change
      };
      const input = {
        id: tenant.id,
        jobOrderMappingConfigurationId: ids.defaultJobOrderMappingConfigurationId,
        candidateMappingConfigurationId: ids.defaultCandidateMappingConfigurationId,
        jobSubmissionMappingConfigurationId: ids.defaultJobSubmissionMappingConfigurationId,
        clientMutationId: createClientMutationId6()
      };
      TenantChangeDefaultMappingConfigurationMutation_default.commit(
        environment,
        input,
        () => {
          onDone();
          onSetSelected(null);
        }
      );
    },
    []
  );
  if (!tenant) {
    return /* @__PURE__ */ jsx49("div", { children: "Loading Tenant" });
  }
  let current;
  if (!selected) {
    current = /* @__PURE__ */ jsxs34("div", { children: [
      /* @__PURE__ */ jsx49(
        BullhornTenantDefaultMappingViewer,
        {
          title: "JobOrder Mapping",
          onEdit: () => onSetSelected("JobOrder" /* JobOrder */),
          className: "mb-5 w-full",
          config: tenant.defaultJobOrderMappingConfiguration
        }
      ),
      /* @__PURE__ */ jsx49(
        BullhornTenantDefaultMappingViewer,
        {
          title: "Candidate Mapping",
          onEdit: () => onSetSelected("Candidate" /* Candidate */),
          className: "mb-5 w-full",
          config: tenant.defaultCandidateMappingConfiguration
        }
      ),
      /* @__PURE__ */ jsx49(
        BullhornTenantDefaultMappingViewer,
        {
          title: "JobSubmission Mapping",
          onEdit: () => onSetSelected("JobSubmission" /* JobSubmission */),
          className: "mb-5 w-full",
          config: tenant.defaultJobSubmissionMappingConfiguration
        }
      )
    ] });
  } else {
    switch (selected) {
      case "JobOrder" /* JobOrder */: {
        current = /* @__PURE__ */ jsxs34("div", { className: "sm:w-1/3", children: [
          /* @__PURE__ */ jsx49(
            BullhornTenantDefaultMappingEditor_default,
            {
              className: "w-full",
              title: "Job Order Mapping Editor",
              sourceSystem: BullhornSystem,
              sourceType: BullhornJobOrderEntity,
              targetSystem: ElevateSystem,
              targetType: ElevateVacancyEntity,
              defaultConfig: tenant.defaultJobOrderMappingConfiguration,
              onChanged: (mapping) => {
                onSaveConfig(tenant, {
                  defaultJobOrderMappingConfigurationId: mapping.id
                });
              }
            }
          ),
          /* @__PURE__ */ jsx49("div", { className: "border bg-gray-200 px-4", children: /* @__PURE__ */ jsx49(ButtonList8, { children: /* @__PURE__ */ jsx49(TabButton2, { name: "Cancel", onClick: () => onSetSelected(null) }) }) })
        ] });
        break;
      }
      case "Candidate" /* Candidate */: {
        current = /* @__PURE__ */ jsxs34("div", { className: "sm:w-1/3", children: [
          /* @__PURE__ */ jsx49(
            BullhornTenantDefaultMappingEditor_default,
            {
              className: "w-full",
              title: "Candidate Mapping",
              sourceSystem: BullhornSystem,
              sourceType: BullhornCandidateEntity,
              targetSystem: ElevateSystem,
              targetType: ElevateProfileEntity,
              defaultConfig: tenant.defaultCandidateMappingConfiguration,
              onChanged: (mapping) => {
                onSaveConfig(tenant, {
                  defaultCandidateMappingConfigurationId: mapping.id
                });
              }
            }
          ),
          /* @__PURE__ */ jsx49(ButtonList8, { children: /* @__PURE__ */ jsx49(TabButton2, { name: "Cancel", onClick: () => onSetSelected(null) }) })
        ] });
        break;
      }
      case "JobSubmission" /* JobSubmission */: {
        current = /* @__PURE__ */ jsxs34("div", { className: "sm:w-1/3", children: [
          /* @__PURE__ */ jsx49(
            BullhornTenantDefaultMappingEditor_default,
            {
              className: "w-full",
              title: "Job Submission Mapping",
              sourceSystem: ElevateSystem,
              sourceType: ElevateApplicationEntity,
              targetSystem: BullhornSystem,
              targetType: BullhornJobSubmissionEntity,
              defaultConfig: tenant.defaultJobSubmissionMappingConfiguration,
              onChanged: (mapping) => {
                onSaveConfig(tenant, {
                  defaultJobSubmissionMappingConfigurationId: mapping.id
                });
              }
            }
          ),
          /* @__PURE__ */ jsx49(ButtonList8, { children: /* @__PURE__ */ jsx49(TabButton2, { name: "Cancel", onClick: () => onSetSelected(null) }) })
        ] });
        break;
      }
    }
  }
  return /* @__PURE__ */ jsx49("div", { children: current });
};

// src/bullhorn/components/tenants/__generated__/BullhornTenantWorkflowConfigQuery.graphql.ts
var node50 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = [
    {
      "alias": "config",
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "id"
        }
      ],
      "concreteType": "BullhornTenantConfig",
      "kind": "LinkedField",
      "name": "bullhornTenantConfigByTenantId",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tenantId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TenantWorkflowConfiguration",
          "kind": "LinkedField",
          "name": "workflowConfiguration",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "applicationJobSubmissionWorkflowId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "candidateWorkflowId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jobOrderWorkflowId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "recommendationJobSubmissionWorkflowId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vaultJobSubmissionWorkflowId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornTenantWorkflowConfigQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "BullhornTenantWorkflowConfigQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "8b9817a9d32ce51fadccb96e9db458fc",
      "id": null,
      "metadata": {},
      "name": "BullhornTenantWorkflowConfigQuery",
      "operationKind": "query",
      "text": "query BullhornTenantWorkflowConfigQuery(\n  $id: UUID!\n) {\n  config: bullhornTenantConfigByTenantId(id: $id) {\n    id\n    tenantId\n    workflowConfiguration {\n      applicationJobSubmissionWorkflowId\n      candidateWorkflowId\n      jobOrderWorkflowId\n      recommendationJobSubmissionWorkflowId\n      vaultJobSubmissionWorkflowId\n    }\n  }\n}\n"
    }
  };
}();
node50.hash = "b9100e13c91b8ba9372c7a7eeceef0f6";
var BullhornTenantWorkflowConfigQuery_graphql_default = node50;

// src/bullhorn/components/tenants/BullhornTenantWorkflowConfig.tsx
import { useCallback as useCallback41 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery7 } from "react-relay";
import { Button as Button22, EdCard as EdCard2 } from "shared-ui";
import { useToggle as useToggle6 } from "shared-lib";

// src/bullhorn/components/tenant-config/__generated__/BullhornTenantWorkflowConfigurationEditorQuery.graphql.ts
var node51 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    }
  ], v1 = [
    {
      "alias": "config",
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "tenantId"
        }
      ],
      "concreteType": "BullhornTenantConfig",
      "kind": "LinkedField",
      "name": "bullhornTenantConfigByTenantId",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tenantId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdOn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdByAccountType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdById",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedOn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedByAccountType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedById",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TenantWorkflowConfiguration",
          "kind": "LinkedField",
          "name": "workflowConfiguration",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vaultJobSubmissionWorkflowId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "recommendationJobSubmissionWorkflowId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jobOrderWorkflowId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "candidateWorkflowId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "applicationJobSubmissionWorkflowId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornTenantWorkflowConfigurationEditorQuery",
      "selections": v1,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "BullhornTenantWorkflowConfigurationEditorQuery",
      "selections": v1
    },
    "params": {
      "cacheID": "7850b427628b71b9778832bd07d5682c",
      "id": null,
      "metadata": {},
      "name": "BullhornTenantWorkflowConfigurationEditorQuery",
      "operationKind": "query",
      "text": "query BullhornTenantWorkflowConfigurationEditorQuery(\n  $tenantId: UUID!\n) {\n  config: bullhornTenantConfigByTenantId(id: $tenantId) {\n    id\n    tenantId\n    createdOn\n    createdByAccountType\n    createdById\n    updatedOn\n    updatedByAccountType\n    updatedById\n    workflowConfiguration {\n      vaultJobSubmissionWorkflowId\n      recommendationJobSubmissionWorkflowId\n      jobOrderWorkflowId\n      candidateWorkflowId\n      applicationJobSubmissionWorkflowId\n    }\n  }\n}\n"
    }
  };
}();
node51.hash = "2191981d2fee96d8593ad434dc868db9";
var BullhornTenantWorkflowConfigurationEditorQuery_graphql_default = node51;

// src/bullhorn/components/tenant-config/BullhornTenantWorkflowConfigurationEditor.tsx
import { useCallback as useCallback40 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery6, useRelayEnvironment as useRelayEnvironment14 } from "react-relay";
import { useForm as useForm4 } from "react-hook-form";
import { createClientMutationId as createClientMutationId7 } from "shared-lib";
import { Button as Button21, ButtonList as ButtonList9, FormInput as FormInput2, FormRow as FormRow5 } from "shared-ui";
import { jsx as jsx50, jsxs as jsxs35 } from "react/jsx-runtime";
var DefaultWorkflowId = "Standard";
var graphqlQuery5 = BullhornTenantWorkflowConfigurationEditorQuery_graphql_default;
var resolver2 = async (values) => {
  let errors = {};
  if (!values.jobOrderWorkflowId) {
    errors = {
      ...errors,
      jobOrderWorkflowId: {
        type: "required",
        message: "This is required."
      }
    };
  }
  if (!values.candidateWorkflowId) {
    errors = {
      ...errors,
      candidateWorkflowId: {
        type: "required",
        message: "This is required."
      }
    };
  }
  return {
    values: {
      jobOrderWorkflowId: values.jobOrderWorkflowId || DefaultWorkflowId,
      candidateWorkflowId: values.candidateWorkflowId || DefaultWorkflowId
    },
    errors
  };
};
var BullhornTenantWorkflowConfigurationEditor = ({ tenantId, onDone }) => {
  const query3 = useLazyLoadQuery6(
    graphqlQuery5,
    { tenantId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { config } = query3;
  const environment = useRelayEnvironment14();
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm4({ resolver: resolver2 });
  const onSubmit = handleSubmit((data) => onSaveConfig(data));
  const onSaveConfig = useCallback40((form) => {
    if (!config) {
      return;
    }
    const input = {
      tenantId: config.tenantId,
      jobOrderWorkflowId: form.jobOrderWorkflowId,
      candidateWorkflowId: form.candidateWorkflowId,
      clientMutationId: createClientMutationId7()
    };
    BullhornChangeJobOrderWorkflowConfigurationMutation_default.commit(
      environment,
      input,
      () => {
        onDone();
      }
    );
  }, []);
  if (!config) {
    return /* @__PURE__ */ jsx50("div", { children: "Loading Config" });
  }
  return /* @__PURE__ */ jsx50("form", { onSubmit, children: /* @__PURE__ */ jsxs35("div", { className: "shadow sm:rounded-md", children: [
    /* @__PURE__ */ jsxs35("div", { className: "space-y-6 bg-white px-4 py-5 sm:p-6", children: [
      /* @__PURE__ */ jsxs35(
        FormRow5,
        {
          label: /* @__PURE__ */ jsx50(
            "label",
            {
              htmlFor: "jobOrderWorkflowId",
              className: "block text-sm font-medium text-gray-700",
              children: "Job Order Workflow Id"
            }
          ),
          children: [
            /* @__PURE__ */ jsx50(
              FormInput2,
              {
                type: "text",
                placeholder: " Job Order Workflow Id ",
                defaultValue: config.workflowConfiguration?.jobOrderWorkflowId || "",
                name: "jobOrderWorkflowId",
                required: true,
                register
              }
            ),
            errors.jobOrderWorkflowId && /* @__PURE__ */ jsx50("span", { children: errors.jobOrderWorkflowId.message })
          ]
        }
      ),
      /* @__PURE__ */ jsxs35(
        FormRow5,
        {
          label: /* @__PURE__ */ jsx50(
            "label",
            {
              htmlFor: "candidateWorkflowId",
              className: "block text-sm font-medium text-gray-700",
              children: "Candidate Workflow Id"
            }
          ),
          children: [
            /* @__PURE__ */ jsx50(
              FormInput2,
              {
                type: "text",
                placeholder: " Candidate Workflow Id ",
                defaultValue: config.workflowConfiguration?.candidateWorkflowId || "",
                name: "candidateWorkflowId",
                required: true,
                register
              }
            ),
            errors.candidateWorkflowId && /* @__PURE__ */ jsx50("span", { children: errors.candidateWorkflowId.message })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ jsx50("div", { className: "mx-4", children: /* @__PURE__ */ jsx50(ButtonList9, { children: /* @__PURE__ */ jsx50(Button21, { color: "primary", type: "submit", children: "Save" }) }) })
  ] }) });
};

// src/bullhorn/components/tenants/BullhornTenantWorkflowConfig.tsx
import { jsx as jsx51, jsxs as jsxs36 } from "react/jsx-runtime";
var query2 = BullhornTenantWorkflowConfigQuery_graphql_default;
var BullhornTenantWorkflowConfig = ({
  tenantId
}) => {
  const { config } = useLazyLoadQuery7(
    query2,
    {
      id: tenantId
    },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const [isEditing, toggleIsEditing] = useToggle6();
  const onToggleIsEditing = useCallback41(() => {
    toggleIsEditing();
  }, [isEditing]);
  if (!config) {
    return /* @__PURE__ */ jsx51("div", { children: "No Config" });
  }
  let content;
  if (isEditing) {
    content = /* @__PURE__ */ jsx51("div", { className: "p-4", children: /* @__PURE__ */ jsx51(
      BullhornTenantWorkflowConfigurationEditor,
      {
        tenantId: config.tenantId,
        onDone: onToggleIsEditing
      }
    ) });
  } else {
    content = /* @__PURE__ */ jsx51(WorkflowConfigurationViewer_default, { config: config.workflowConfiguration });
  }
  return /* @__PURE__ */ jsxs36(EdCard2, { title: "Workflow Config", className: "w-1/2", children: [
    /* @__PURE__ */ jsx51("div", { className: "border-b px-6 py-2", children: /* @__PURE__ */ jsx51("div", { className: "flex items-center justify-end", children: /* @__PURE__ */ jsx51(Button22, { color: "primary", title: "Edit", clicked: onToggleIsEditing, children: isEditing ? "Cancel" : "Edit" }) }) }),
    /* @__PURE__ */ jsx51("div", { className: "px-6 py-2", children: content })
  ] });
};
var BullhornTenantWorkflowConfig_default = BullhornTenantWorkflowConfig;

// src/bullhorn/components/tenants/BullhornTenantDetail.tsx
import { jsx as jsx52, jsxs as jsxs37 } from "react/jsx-runtime";
var fragment15 = BullhornTenantDetail_bullhornTenant_graphql_default;
var BullhornTenantDetail = (props) => {
  const data = useFragment13(fragment15, props.tenant);
  const [current, tabLinks] = useTabs([
    { name: "Details" },
    { name: "Api" },
    { name: "Workflow" },
    { name: "Mapping" }
  ]);
  const onMappingsUpdated = useCallback42(() => {
  }, []);
  let currentTab;
  switch (current.name) {
    case "Details": {
      currentTab = /* @__PURE__ */ jsx52(EdGridLayout2, { children: /* @__PURE__ */ jsx52(EdCard3, { title: "Name", children: /* @__PURE__ */ jsx52("p", { className: "text-info-500 pt-1 text-lg font-medium", children: data.name }) }) });
      break;
    }
    case "Api": {
      currentTab = /* @__PURE__ */ jsx52(Suspense2, { fallback: "Loading Config...", children: /* @__PURE__ */ jsx52(BullhornTenantConfig_default, { tenantNodeId: data.id }) });
      break;
    }
    case "Workflow": {
      currentTab = /* @__PURE__ */ jsx52(Suspense2, { fallback: "Loading Config...", children: /* @__PURE__ */ jsx52(BullhornTenantWorkflowConfig_default, { tenantId: data.tenantId }) });
      break;
    }
    case "Mapping": {
      currentTab = /* @__PURE__ */ jsx52(Suspense2, { fallback: "Loading Config...", children: /* @__PURE__ */ jsx52(
        BullhornTenantDefaultMappingsEditor,
        {
          tenantId: data.tenantId,
          onDone: onMappingsUpdated
        }
      ) });
      break;
    }
  }
  return /* @__PURE__ */ jsxs37("div", { children: [
    /* @__PURE__ */ jsx52("div", { className: "mb-2 rounded border border-gray-200 bg-white px-4 py-4", children: /* @__PURE__ */ jsx52(ButtonTabPills, { tabs: tabLinks }) }),
    currentTab
  ] });
};
var BullhornTenantDetail_default = BullhornTenantDetail;

// src/bullhorn/components/tenants/__generated__/BullhornTenantRow_bullhornTenant.graphql.ts
var node52 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BullhornTenantRow_bullhornTenant",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tenantId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BullhornTenantConfig",
      "kind": "LinkedField",
      "name": "config",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BullhornTenant",
  "abstractKey": null
};
node52.hash = "442b92332f38e8b73e240dfa6f410617";
var BullhornTenantRow_bullhornTenant_graphql_default = node52;

// src/bullhorn/components/tenants/BullhornTenantRow.tsx
import { useCallback as useCallback43 } from "react";
import { useFragment as useFragment14 } from "react-relay";
import { parseDate as parseDate2, timeAgo as timeAgo3 } from "shared-lib";
import { EdActionCell as EdActionCell7, EdColumnCell as EdColumnCell10, EdRow as EdRow10, LinkButton as LinkButton9 } from "shared-ui";
import { jsx as jsx53, jsxs as jsxs38 } from "react/jsx-runtime";
var bullhornTenant = BullhornTenantRow_bullhornTenant_graphql_default;
var BullhornTenantRow = (props) => {
  const data = useFragment14(bullhornTenant, props.bullhornTenant);
  const select = useCallback43(() => {
    props.selected(data);
  }, []);
  const status = data.config && data.config.isEnabled ? /* @__PURE__ */ jsx53("div", { className: "text-success-800 font-medium", children: "Enabled" }) : /* @__PURE__ */ jsx53("div", { className: "text-danger-800 font-medium", children: "Disabled" });
  return /* @__PURE__ */ jsxs38(EdRow10, { clicked: select, rowKey: data.id, children: [
    /* @__PURE__ */ jsx53(EdColumnCell10, { children: /* @__PURE__ */ jsx53("div", { className: "text-sm text-gray-900", children: data.name }) }),
    /* @__PURE__ */ jsx53(EdColumnCell10, { children: status }),
    /* @__PURE__ */ jsx53(EdColumnCell10, { children: timeAgo3(parseDate2(data.createdOn)) }),
    /* @__PURE__ */ jsx53(EdColumnCell10, { children: timeAgo3(parseDate2(data.updatedOn)) }),
    /* @__PURE__ */ jsx53(EdActionCell7, { children: /* @__PURE__ */ jsx53(LinkButton9, { label: "Select", clicked: select }) })
  ] });
};
var BullhornTenantRow_default = BullhornTenantRow;

// src/bullhorn/components/tenants/__generated__/BullhornTenantListPaginationQuery.graphql.ts
var node53 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    }
  ], v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "BullhornTenantListPaginationQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "BullhornTenantList_bullhornTenants"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "BullhornTenantListPaginationQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "BullhornTenantsConnection",
          "kind": "LinkedField",
          "name": "bullhornTenants",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BullhornTenantsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BullhornTenant",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tenantId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BullhornTenantConfig",
                      "kind": "LinkedField",
                      "name": "config",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isEnabled",
                          "storageKey": null
                        },
                        v2
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "BullhornTenantList_bullhornTenants",
          "kind": "LinkedHandle",
          "name": "bullhornTenants"
        }
      ]
    },
    "params": {
      "cacheID": "74372351e6e878f1383071d26000e8f7",
      "id": null,
      "metadata": {},
      "name": "BullhornTenantListPaginationQuery",
      "operationKind": "query",
      "text": "query BullhornTenantListPaginationQuery(\n  $after: String\n  $first: Int = 10\n) {\n  ...BullhornTenantList_bullhornTenants_2HEEH6\n}\n\nfragment BullhornTenantDetail_bullhornTenant on BullhornTenant {\n  id\n  name\n  tenantId\n}\n\nfragment BullhornTenantList_bullhornTenants_2HEEH6 on Query {\n  bullhornTenants(first: $first, after: $after) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        tenantId\n        name\n        createdOn\n        updatedOn\n        config {\n          isEnabled\n          id\n        }\n        ...BullhornTenantRow_bullhornTenant\n        ...BullhornTenantDetail_bullhornTenant\n        __typename\n      }\n    }\n  }\n}\n\nfragment BullhornTenantRow_bullhornTenant on BullhornTenant {\n  id\n  tenantId\n  name\n  createdOn\n  updatedOn\n  config {\n    isEnabled\n    id\n  }\n}\n"
    }
  };
}();
node53.hash = "9043165ce49fc3b4d26d8b80359a4f43";
var BullhornTenantListPaginationQuery_graphql_default = node53;

// src/bullhorn/components/tenants/__generated__/BullhornTenantList_bullhornTenants.graphql.ts
var node54 = function() {
  var v0 = [
    "bullhornTenants"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": BullhornTenantListPaginationQuery_graphql_default
      }
    },
    "name": "BullhornTenantList_bullhornTenants",
    "selections": [
      {
        "alias": "bullhornTenants",
        "args": null,
        "concreteType": "BullhornTenantsConnection",
        "kind": "LinkedField",
        "name": "__BullhornTenantList_bullhornTenants_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BullhornTenantsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BullhornTenant",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tenantId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BullhornTenantConfig",
                    "kind": "LinkedField",
                    "name": "config",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isEnabled",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BullhornTenantRow_bullhornTenant"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BullhornTenantDetail_bullhornTenant"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node54.hash = "9043165ce49fc3b4d26d8b80359a4f43";
var BullhornTenantList_bullhornTenants_graphql_default = node54;

// src/bullhorn/components/tenants/BullhornTenantList.tsx
import { useCallback as useCallback44 } from "react";
import { usePaginationFragment as usePaginationFragment8 } from "react-relay";
import { EdListHeader as EdListHeader8, EdTable as EdTable11 } from "shared-ui";
import { jsx as jsx54, jsxs as jsxs39 } from "react/jsx-runtime";
var fragment16 = BullhornTenantList_bullhornTenants_graphql_default;
var columns10 = [
  { id: "name", name: "Name" },
  { id: "enabled", name: "Enabled" },
  { id: "created", name: "Created" },
  { id: "updated", name: "Updated" }
];
var BullhornTenantList = ({
  onSelect,
  bullhornTenantsKey
}) => {
  const select = useCallback44((e) => {
    onSelect({
      id: e.tenantId
    });
  }, []);
  const paging = usePaginationFragment8(fragment16, bullhornTenantsKey);
  const { data } = paging;
  const { bullhornTenants } = data;
  const rows = bullhornTenants?.edges?.map((e) => {
    return /* @__PURE__ */ jsx54(
      BullhornTenantRow_default,
      {
        bullhornTenant: e.node,
        selected: select
      },
      e.node.id
    );
  });
  return /* @__PURE__ */ jsxs39("div", { children: [
    /* @__PURE__ */ jsx54(EdListHeader8, { paging }),
    /* @__PURE__ */ jsx54("div", { className: "flex", children: /* @__PURE__ */ jsx54("div", { className: "w-full", children: /* @__PURE__ */ jsx54(EdTable11, { defaultColumns: columns10, rows }) }) })
  ] });
};
var BullhornTenantList_default = BullhornTenantList;

// src/elevate/components/__generated__/VacancyDetailsData.graphql.ts
var node55 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VacancyDetailsData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdByAccountType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdById",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedByAccountType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedById",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vacancyId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "elevateEmployerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalVacancyId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "integrationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customProperties",
      "storageKey": null
    }
  ],
  "type": "IntegrationsVacancy",
  "abstractKey": null
};
node55.hash = "360e4775d1c5e1b94182b3ceb048c7a0";
var VacancyDetailsData_graphql_default = node55;

// src/elevate/components/VacancyDetails.tsx
import { Fragment as Fragment8 } from "react";
import { useFragment as useFragment15 } from "react-relay";
import { AuditFields as AuditFields5, DescriptionItem as DescriptionItem5, DescriptionList as DescriptionList5 } from "shared-ui";
import { jsx as jsx55, jsxs as jsxs40 } from "react/jsx-runtime";
var fragment17 = VacancyDetailsData_graphql_default;
var VacancyDetails = ({ vacancy }) => {
  const data = useFragment15(fragment17, vacancy);
  return /* @__PURE__ */ jsx55(
    DescriptionList5,
    {
      heading: /* @__PURE__ */ jsx55("div", { className: "flex space-x-2", children: /* @__PURE__ */ jsx55("span", { className: "text-info-600", children: "Integration Vacancy" }) }),
      items: /* @__PURE__ */ jsxs40(Fragment8, { children: [
        /* @__PURE__ */ jsx55("div", { className: "p-4", children: /* @__PURE__ */ jsx55(
          AuditFields5,
          {
            createdOn: data.createdOn,
            updatedOn: data.updatedOn
          }
        ) }),
        /* @__PURE__ */ jsx55(DescriptionItem5, { label: "Status", children: /* @__PURE__ */ jsx55("div", { children: data.status }) }),
        /* @__PURE__ */ jsx55(DescriptionItem5, { label: "External Status", children: /* @__PURE__ */ jsx55("div", { children: data.externalStatus }) })
      ] })
    }
  );
};

// src/elevate/components/__generated__/VacancyContainerQuery.graphql.ts
var node56 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "externalVacancyId"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "externalVacancyId"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "VacancyContainerQuery",
      "selections": [
        {
          "alias": "vacancy",
          "args": v1,
          "concreteType": "IntegrationsVacancy",
          "kind": "LinkedField",
          "name": "integrationVacancyByExternalId",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "VacancyDetailsData"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "VacancyContainerQuery",
      "selections": [
        {
          "alias": "vacancy",
          "args": v1,
          "concreteType": "IntegrationsVacancy",
          "kind": "LinkedField",
          "name": "integrationVacancyByExternalId",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdByAccountType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdById",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedByAccountType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedById",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updatedOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vacancyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "elevateEmployerId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "externalStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "externalVacancyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "integrationType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "customProperties",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "9c60b41b59bd337a40bddd5d47e3f0e6",
      "id": null,
      "metadata": {},
      "name": "VacancyContainerQuery",
      "operationKind": "query",
      "text": "query VacancyContainerQuery(\n  $externalVacancyId: String!\n) {\n  vacancy: integrationVacancyByExternalId(id: $externalVacancyId) {\n    ...VacancyDetailsData\n    id\n  }\n}\n\nfragment VacancyDetailsData on IntegrationsVacancy {\n  id\n  createdByAccountType\n  createdById\n  createdOn\n  updatedByAccountType\n  updatedById\n  updatedOn\n  vacancyId\n  elevateEmployerId\n  externalStatus\n  externalVacancyId\n  integrationType\n  status\n  customProperties\n}\n"
    }
  };
}();
node56.hash = "de321d22c4773f3798f3cc445c3b24d6";
var VacancyContainerQuery_graphql_default = node56;

// src/elevate/components/VacancyContainer.tsx
import { Suspense as Suspense3 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery8 } from "react-relay";
import { EdSkeleton as EdSkeleton2 } from "shared-ui";
import { jsx as jsx56 } from "react/jsx-runtime";
var graphqlQuery6 = VacancyContainerQuery_graphql_default;
var VacancyContainer = ({
  noVacancyContent,
  externalVacancyId
}) => {
  const query3 = useLazyLoadQuery8(
    graphqlQuery6,
    { externalVacancyId },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { vacancy } = query3;
  return /* @__PURE__ */ jsx56(Suspense3, { fallback: /* @__PURE__ */ jsx56(EdSkeleton2, {}), children: vacancy ? /* @__PURE__ */ jsx56(VacancyDetails, { vacancy }) : /* @__PURE__ */ jsx56("div", { children: noVacancyContent }) });
};

// src/employer-mappings/components/__generated__/EmployerMappingListPaginationQuery.graphql.ts
var node57 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Variable",
      "name": "order",
      "variableName": "order"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerMappingListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "EmployerMappingList_employerMappings"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerMappingListPaginationQuery",
      "selections": [
        {
          "alias": null,
          "args": v3,
          "concreteType": "IntegrationEmployerMappingsConnection",
          "kind": "LinkedField",
          "name": "integrationEmployerMappings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationEmployerMappingsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationsEmployerMapping",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "employerMappingId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "integrationType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "elevateId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Employer",
                      "kind": "LinkedField",
                      "name": "employer",
                      "plural": false,
                      "selections": [
                        v4,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "EmployerMappingList_integrationEmployerMappings",
          "kind": "LinkedHandle",
          "name": "integrationEmployerMappings"
        }
      ]
    },
    "params": {
      "cacheID": "4bd0f47ac4fc51d2f7c5ea0045776bd0",
      "id": null,
      "metadata": {},
      "name": "EmployerMappingListPaginationQuery",
      "operationKind": "query",
      "text": "query EmployerMappingListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $order: [IntegrationsEmployerMappingSort!]\n  $where: IntegrationsEmployerMappingFilter\n) {\n  ...EmployerMappingList_employerMappings_2HEEH6\n}\n\nfragment EmployerMappingList_employerMappings_2HEEH6 on Query {\n  integrationEmployerMappings(first: $first, after: $after, order: $order, where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        employerMappingId\n        createdOn\n        updatedOn\n        integrationType\n        elevateId\n        externalId\n        ...EmployerMappingRow_employerMapping\n        __typename\n      }\n    }\n  }\n}\n\nfragment EmployerMappingRow_employerMapping on IntegrationsEmployerMapping {\n  id\n  createdOn\n  updatedOn\n  integrationType\n  employerMappingId\n  elevateId\n  externalId\n  employer {\n    id\n    name\n  }\n}\n"
    }
  };
}();
node57.hash = "9e565564643d2032e0a70440e95704fe";
var EmployerMappingListPaginationQuery_graphql_default = node57;

// src/employer-mappings/components/__generated__/EmployerMappingList_employerMappings.graphql.ts
var node58 = function() {
  var v0 = [
    "integrationEmployerMappings"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "order"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EmployerMappingListPaginationQuery_graphql_default
      }
    },
    "name": "EmployerMappingList_employerMappings",
    "selections": [
      {
        "alias": "integrationEmployerMappings",
        "args": null,
        "concreteType": "IntegrationEmployerMappingsConnection",
        "kind": "LinkedField",
        "name": "__EmployerMappingList_integrationEmployerMappings_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationEmployerMappingsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationsEmployerMapping",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employerMappingId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "integrationType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "elevateId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "externalId",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EmployerMappingRow_employerMapping"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node58.hash = "9e565564643d2032e0a70440e95704fe";
var EmployerMappingList_employerMappings_graphql_default = node58;

// src/employer-mappings/components/EmployerMappingList.tsx
import { useCallback as useCallback46, useEffect as useEffect4 } from "react";
import { usePaginationFragment as usePaginationFragment9 } from "react-relay";
import {
  EdListHeader as EdListHeader9,
  EdTable as EdTable12,
  LinkButton as LinkButton11,
  selectColumn as selectColumn2,
  SortDir as SortDir2
} from "shared-ui";
import { useToggle as useToggle7 } from "shared-lib";

// src/employer-mappings/components/__generated__/EmployerMappingRow_employerMapping.graphql.ts
var node59 = function() {
  var v0 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  };
  return {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmployerMappingRow_employerMapping",
    "selections": [
      v0,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "integrationType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employerMappingId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "elevateId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Employer",
        "kind": "LinkedField",
        "name": "employer",
        "plural": false,
        "selections": [
          v0,
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "IntegrationsEmployerMapping",
    "abstractKey": null
  };
}();
node59.hash = "47572d442d5fb8fbe66676dcf4377a50";
var EmployerMappingRow_employerMapping_graphql_default = node59;

// src/employer-mappings/components/EmployerMappingRow.tsx
import { useCallback as useCallback45 } from "react";
import { useFragment as useFragment16 } from "react-relay";
import { EdActionCell as EdActionCell8, EdColumnCell as EdColumnCell11, EdRow as EdRow11, LinkButton as LinkButton10 } from "shared-ui";
import { formatDateTime as formatDateTime4 } from "shared-lib";
import { jsx as jsx57, jsxs as jsxs41 } from "react/jsx-runtime";
var employerMapping = EmployerMappingRow_employerMapping_graphql_default;
var EmployerMappingRow = (props) => {
  const data = useFragment16(employerMapping, props.employerMapping);
  const select = useCallback45(() => {
    props.selected(data);
  }, []);
  return /* @__PURE__ */ jsxs41(EdRow11, { clicked: select, rowKey: data.id, children: [
    /* @__PURE__ */ jsx57(EdColumnCell11, { children: formatDateTime4(data.createdOn) }),
    /* @__PURE__ */ jsx57(EdColumnCell11, { children: formatDateTime4(data.updatedOn) }),
    /* @__PURE__ */ jsx57(EdColumnCell11, { children: data.integrationType }),
    /* @__PURE__ */ jsx57(EdColumnCell11, { children: data.employer ? data.employer.name : data.elevateId }),
    /* @__PURE__ */ jsx57(EdColumnCell11, { children: data.externalId }),
    /* @__PURE__ */ jsx57(EdActionCell8, { children: /* @__PURE__ */ jsx57(LinkButton10, { label: "Select", clicked: select }) })
  ] });
};
var EmployerMappingRow_default = EmployerMappingRow;

// src/employer-mappings/components/EmployerMappingList.tsx
import { jsx as jsx58, jsxs as jsxs42 } from "react/jsx-runtime";
var defaultColumns2 = [
  {
    id: "createdOn",
    name: "Created",
    sort: true,
    sortValue: SortDir2.Desc
  },
  {
    id: "updatedOn",
    name: "Last Update",
    sort: true,
    sortValue: SortDir2.Desc
  },
  { id: "integrationType", name: "Integration Type" },
  { id: "elevateId", name: "Elevate Id" },
  { id: "externalId", name: "External Id" }
];
var fragment18 = EmployerMappingList_employerMappings_graphql_default;
var EmployerMappingList = ({
  onSelect,
  employerMappingsKey
}) => {
  const [showNotActive, toggleShowNotActive] = useToggle7(false);
  const rowSelected = useCallback46(
    (e) => {
      onSelect({
        id: e.employerMappingId
      });
    },
    []
  );
  const paging = usePaginationFragment9(fragment18, employerMappingsKey);
  function fetch(refetchParameters) {
    refetch(refetchParameters, {
      fetchPolicy: "network-only",
      onComplete: (e) => {
        if (e) {
          console.error(e);
        } else {
          console.log("changed sort on job order list");
        }
      }
    });
  }
  useEffect4(() => {
    let params;
    if (showNotActive) {
      params = {
        first: 10,
        where: {
          or: [{ isActive: { eq: true } }, { isActive: { eq: false } }]
        }
      };
    } else {
      params = {
        first: 10,
        where: {
          or: [{ isActive: { eq: true } }]
        }
      };
    }
    fetch(params);
  }, [showNotActive]);
  const onSortChanged = useCallback46((columns14) => {
    const hasOrderBy = columns14.filter((c) => c.sort && c.sortValue).length > 0;
    if (hasOrderBy === false) {
      return;
    }
    const where = {
      or: [{ isActive: { eq: true } }, { isActive: { eq: false } }]
    };
    const orderBy = [];
    const createdOn = selectColumn2("createdOn", columns14);
    if (createdOn) {
      orderBy.push({ createdOn });
    }
    const updatedOn = selectColumn2("updatedOn", columns14);
    if (updatedOn) {
      orderBy.push({ updatedOn });
    }
    let refetchParameters;
    if (showNotActive) {
      refetchParameters = { first: 10, order: orderBy, where };
    } else {
      refetchParameters = { first: 10, order: orderBy };
    }
    fetch(refetchParameters);
  }, []);
  const { data, refetch } = paging;
  const rows = data.integrationEmployerMappings?.edges?.map((e) => {
    return /* @__PURE__ */ jsx58(
      EmployerMappingRow_default,
      {
        employerMapping: e.node,
        selected: rowSelected
      },
      e.node.id
    );
  });
  return /* @__PURE__ */ jsxs42("div", { children: [
    /* @__PURE__ */ jsx58(
      EdListHeader9,
      {
        total: data.integrationEmployerMappings?.totalCount,
        paging,
        content: /* @__PURE__ */ jsx58("div", { className: "flex items-center justify-end p-2", children: /* @__PURE__ */ jsx58(LinkButton11, { clicked: toggleShowNotActive, children: showNotActive ? "Hide Not Active" : "Include Not Active" }) })
      }
    ),
    /* @__PURE__ */ jsx58("div", { className: "flex", children: /* @__PURE__ */ jsx58("div", { className: "w-full", children: /* @__PURE__ */ jsx58(
      EdTable12,
      {
        defaultColumns: defaultColumns2,
        rows,
        onSortChanged
      }
    ) }) })
  ] });
};

// src/employer-mappings/components/__generated__/EmployerMappingEditFormQuery.graphql.ts
var node60 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v2 = [
    {
      "alias": "mapping",
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "id"
        }
      ],
      "concreteType": "IntegrationsEmployerMapping",
      "kind": "LinkedField",
      "name": "integrationEmployerMappingById",
      "plural": false,
      "selections": [
        v1,
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "integrationType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "elevateId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isActive",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerMappingId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdOn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdByAccountType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdById",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedOn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedByAccountType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedById",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Employer",
          "kind": "LinkedField",
          "name": "employer",
          "plural": false,
          "selections": [
            v1,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "employerId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webSite",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EmployerMappingEditFormQuery",
      "selections": v2,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EmployerMappingEditFormQuery",
      "selections": v2
    },
    "params": {
      "cacheID": "4681a82259533b651d7584dd8d091c65",
      "id": null,
      "metadata": {},
      "name": "EmployerMappingEditFormQuery",
      "operationKind": "query",
      "text": "query EmployerMappingEditFormQuery(\n  $id: UUID!\n) {\n  mapping: integrationEmployerMappingById(id: $id) {\n    id\n    integrationType\n    externalId\n    elevateId\n    isActive\n    employerMappingId\n    createdOn\n    createdByAccountType\n    createdById\n    updatedOn\n    updatedByAccountType\n    updatedById\n    employer {\n      id\n      code\n      entityId\n      employerId\n      name\n      slug\n      webSite\n    }\n  }\n}\n"
    }
  };
}();
node60.hash = "6ee1d9a6dd711e23fb9014ca48731d29";
var EmployerMappingEditFormQuery_graphql_default = node60;

// src/employer-mappings/components/EmployerMappingEditForm.tsx
import { useCallback as useCallback47 } from "react";
import { useLazyLoadQuery as useLazyLoadQuery9, useRelayEnvironment as useRelayEnvironment15 } from "react-relay";
import { useForm as useForm5 } from "react-hook-form";
import * as zod from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { createClientMutationId as createClientMutationId8 } from "shared-lib";
import {
  Button as Button23,
  ButtonList as ButtonList10,
  CheckboxInput,
  FormInput as FormInput3,
  SelectMenuInput
} from "shared-ui";
import { EmployerSearchBoxInput } from "feature-employer-accounts";

// src/employer-mappings/lib/IntegrationTypes.ts
var IntegrationTypes = /* @__PURE__ */ ((IntegrationTypes2) => {
  IntegrationTypes2["MATRIX"] = "MATRIX";
  IntegrationTypes2["BULLHORN"] = "BULLHORN";
  IntegrationTypes2["BOOMI"] = "BOOMI";
  return IntegrationTypes2;
})(IntegrationTypes || {});
var IntegrationTypesList = [
  { id: "BULLHORN" /* BULLHORN */, name: "BULLHORN" /* BULLHORN */ },
  { id: "BOOMI" /* BOOMI */, name: "BOOMI" /* BOOMI */ },
  { id: "MATRIX" /* MATRIX */, name: "MATRIX" /* MATRIX */ }
];
function selectIntegrationTypeListItem(value) {
  if (value === null || value === void 0) {
    return null;
  }
  const item = IntegrationTypesList.find(
    (i) => i.id.toLowerCase() === value.toLowerCase()
  );
  if (item) {
    return item;
  }
  return null;
}
function parseIntegrationTypes(value) {
  switch (value.toUpperCase()) {
    case "BOOMI" /* BOOMI */:
      return "BOOMI" /* BOOMI */;
    case "MATRIX" /* MATRIX */:
      return "MATRIX" /* MATRIX */;
    case "BULLHORN" /* BULLHORN */:
      return "BULLHORN" /* BULLHORN */;
    default:
      throw new Error("Unknown IntegrationTypes");
  }
}

// src/employer-mappings/mutations/__generated__/SetEmployerMappingMutation.graphql.ts
var node61 = function() {
  var v0 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }, v1 = {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }, v2 = [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ], v3 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }, v4 = {
    "alias": null,
    "args": null,
    "concreteType": "EdgeOfEmployerMapping",
    "kind": "LinkedField",
    "name": "employerMapping",
    "plural": false,
    "selections": [
      v3,
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IntegrationsEmployerMapping",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "employerMappingId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "integrationType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "elevateId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }, v5 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  };
  return {
    "fragment": {
      "argumentDefinitions": [
        v0,
        v1
      ],
      "kind": "Fragment",
      "metadata": null,
      "name": "SetEmployerMappingMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "EmployerMappingPayload",
          "kind": "LinkedField",
          "name": "integrationsSetEmployerMapping",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [
        v1,
        v0
      ],
      "kind": "Operation",
      "name": "SetEmployerMappingMutation",
      "selections": [
        {
          "alias": null,
          "args": v2,
          "concreteType": "EmployerMappingPayload",
          "kind": "LinkedField",
          "name": "integrationsSetEmployerMapping",
          "plural": false,
          "selections": [
            v4,
            {
              "alias": null,
              "args": null,
              "filters": null,
              "handle": "prependEdge",
              "key": "",
              "kind": "LinkedHandle",
              "name": "employerMapping",
              "handleArgs": [
                {
                  "kind": "Variable",
                  "name": "connections",
                  "variableName": "connections"
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "userErrors",
              "plural": true,
              "selections": [
                v3,
                v5,
                v6
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    "params": {
      "cacheID": "f2759d8d777c4abda3f3821e0d12ba51",
      "id": null,
      "metadata": {},
      "name": "SetEmployerMappingMutation",
      "operationKind": "mutation",
      "text": "mutation SetEmployerMappingMutation(\n  $input: SetEmployerMappingInput!\n) {\n  integrationsSetEmployerMapping(input: $input) {\n    employerMapping {\n      __typename\n      cursor\n      node {\n        id\n        employerMappingId\n        createdOn\n        updatedOn\n        integrationType\n        elevateId\n        externalId\n      }\n    }\n    userErrors {\n      __typename\n      code\n      message\n    }\n  }\n}\n"
    }
  };
}();
node61.hash = "1143d4565d2f0657d36a046021388cf0";
var SetEmployerMappingMutation_graphql_default = node61;

// src/employer-mappings/mutations/SetEmployerMappingMutation.ts
import { createConnectedCommitMutation as createConnectedCommitMutation10 } from "shared-lib";
var mutation18 = SetEmployerMappingMutation_graphql_default;
var commit18 = createConnectedCommitMutation10(mutation18);
var SetEmployerMappingMutation_default = { commit: commit18 };

// src/employer-mappings/components/EmployerMappingEditForm.tsx
import { jsx as jsx59, jsxs as jsxs43 } from "react/jsx-runtime";
var integrationTypes = Object.values(IntegrationTypes);
var FormSchema = zod.object({
  elevateId: zod.string().nonempty(),
  externalId: zod.string().nonempty(),
  integrationType: zod.enum(integrationTypes),
  isActive: zod.boolean(),
  clientMutationId: zod.string().default(createClientMutationId8())
});
var graphqlQuery7 = EmployerMappingEditFormQuery_graphql_default;
var EmployerMappingEditForm = ({
  id,
  onDone
}) => {
  const query3 = useLazyLoadQuery9(
    graphqlQuery7,
    { id },
    {
      fetchPolicy: "store-and-network"
    }
  );
  const { mapping } = query3;
  const environment = useRelayEnvironment15();
  const defaultValues = {
    elevateId: mapping.elevateId,
    externalId: mapping.externalId,
    integrationType: parseIntegrationTypes(mapping.integrationType),
    isActive: mapping.isActive,
    clientMutationId: createClientMutationId8()
  };
  const { register, handleSubmit, formState, control } = useForm5({
    resolver: zodResolver(FormSchema),
    defaultValues
  });
  const { errors, isValid } = formState;
  const onSubmit = handleSubmit((data) => onSaveConfig(isValid, data));
  const onSaveConfig = useCallback47((isValid2, form) => {
    if (!isValid2 || form.integrationType === void 0 || form.isActive === void 0) {
      return;
    }
    const input = {
      elevateId: form.elevateId,
      externalId: form.externalId,
      integrationType: form.integrationType,
      isActive: form.isActive,
      clientMutationId: createClientMutationId8()
    };
    SetEmployerMappingMutation_default.commit(
      environment,
      input,
      "EmployerMappingList_integrationEmployerMappings",
      () => {
        onDone();
      }
    );
  }, []);
  if (!mapping) {
    return /* @__PURE__ */ jsx59("div", { children: "Loading Mapping" });
  }
  const selectedIntegrationType = selectIntegrationTypeListItem(
    mapping.integrationType
  );
  return /* @__PURE__ */ jsx59("form", { onSubmit, children: /* @__PURE__ */ jsx59("div", { className: "mt-4 shadow sm:rounded-md md:w-3/4 lg:w-1/2", children: /* @__PURE__ */ jsxs43("div", { className: "space-y-6 bg-white px-4 py-5 sm:p-6", children: [
    /* @__PURE__ */ jsxs43("div", { children: [
      /* @__PURE__ */ jsx59(
        EmployerSearchBoxInput,
        {
          control,
          defaultValue: mapping.employer,
          name: "elevateId"
        }
      ),
      errors.elevateId && /* @__PURE__ */ jsx59("p", { children: errors.elevateId.message })
    ] }),
    /* @__PURE__ */ jsxs43("div", { children: [
      /* @__PURE__ */ jsx59("label", { children: "External Id" }),
      /* @__PURE__ */ jsx59(
        FormInput3,
        {
          type: "text",
          placeholder: " Elevate Employer Id ",
          defaultValue: mapping.externalId || "",
          name: "externalId",
          required: true,
          register
        }
      ),
      errors.externalId && /* @__PURE__ */ jsx59("p", { children: errors.externalId.message })
    ] }),
    /* @__PURE__ */ jsxs43("div", { children: [
      /* @__PURE__ */ jsx59(
        CheckboxInput,
        {
          label: /* @__PURE__ */ jsx59("span", { children: "Is Active" }),
          defaultChecked: mapping.isActive ?? false,
          name: "isActive",
          control,
          disabled: false
        }
      ),
      errors.isActive && /* @__PURE__ */ jsx59("p", { children: errors.isActive.message })
    ] }),
    /* @__PURE__ */ jsxs43("div", { children: [
      /* @__PURE__ */ jsx59("label", { children: "Integration Type" }),
      /* @__PURE__ */ jsx59(
        SelectMenuInput,
        {
          name: "integrationType",
          title: "Integration Type",
          control,
          disabled: false,
          items: IntegrationTypesList,
          selectedItem: selectedIntegrationType
        }
      ),
      errors.integrationType && /* @__PURE__ */ jsx59("p", { children: errors.integrationType.message })
    ] }),
    /* @__PURE__ */ jsx59(ButtonList10, { children: /* @__PURE__ */ jsx59(Button23, { disabled: !isValid, color: "primary", type: "submit", children: "Save" }) })
  ] }) }) });
};

// src/employer-mappings/components/EmployerMappingNewForm.tsx
import { useCallback as useCallback48 } from "react";
import { useRelayEnvironment as useRelayEnvironment16 } from "react-relay";
import { useForm as useForm6 } from "react-hook-form";
import * as zod2 from "zod";
import { zodResolver as zodResolver2 } from "@hookform/resolvers/zod";
import { createClientMutationId as createClientMutationId9 } from "shared-lib";
import { Button as Button24, ButtonList as ButtonList11, FormInput as FormInput4, SelectMenu as SelectMenu6 } from "shared-ui";
import { EmployerSearchBoxInput as EmployerSearchBoxInput2 } from "feature-employer-accounts";
import { jsx as jsx60, jsxs as jsxs44 } from "react/jsx-runtime";
var integrationTypes2 = Object.values(IntegrationTypes);
var FormSchema2 = zod2.object({
  elevateId: zod2.string().nonempty(),
  externalId: zod2.string().nonempty(),
  integrationType: zod2.enum(integrationTypes2),
  isActive: zod2.boolean(),
  clientMutationId: zod2.string().default(createClientMutationId9())
});
var EmployerMappingNewForm = ({
  onDone,
  onCancel
}) => {
  const environment = useRelayEnvironment16();
  const { register, handleSubmit, formState, setValue, control } = useForm6({
    resolver: zodResolver2(FormSchema2)
  });
  const { errors, isValid } = formState;
  const onSubmit = handleSubmit((data) => onSaveConfig(isValid, data));
  const onSaveConfig = useCallback48((isValid2, form) => {
    if (!isValid2 || form.integrationType === void 0 || form.isActive === void 0) {
      return;
    }
    const input = {
      elevateId: form.elevateId,
      externalId: form.externalId,
      integrationType: form.integrationType,
      isActive: form.isActive,
      clientMutationId: createClientMutationId9()
    };
    SetEmployerMappingMutation_default.commit(
      environment,
      input,
      "EmployerMappingList_integrationEmployerMappings",
      ({ integrationsSetEmployerMapping }) => {
        if (integrationsSetEmployerMapping.employerMapping && integrationsSetEmployerMapping.employerMapping.node) {
          onDone(
            integrationsSetEmployerMapping.employerMapping.node.employerMappingId
          );
        }
      }
    );
  }, []);
  return /* @__PURE__ */ jsx60("form", { onSubmit, children: /* @__PURE__ */ jsx60("div", { className: "mt-4 shadow sm:rounded-md md:w-3/4 lg:w-1/2", children: /* @__PURE__ */ jsxs44("div", { className: "space-y-6 bg-white px-4 py-5 sm:p-6", children: [
    /* @__PURE__ */ jsxs44("div", { children: [
      /* @__PURE__ */ jsx60(
        EmployerSearchBoxInput2,
        {
          control,
          defaultValue: null,
          name: "elevateId"
        }
      ),
      errors.elevateId && /* @__PURE__ */ jsx60("p", { children: errors.elevateId.message })
    ] }),
    /* @__PURE__ */ jsxs44("div", { children: [
      /* @__PURE__ */ jsx60("label", { children: "External Id" }),
      /* @__PURE__ */ jsx60(
        FormInput4,
        {
          type: "text",
          placeholder: " Elevate Employer Id ",
          defaultValue: "",
          name: "externalId",
          required: true,
          register
        }
      ),
      errors.externalId && /* @__PURE__ */ jsx60("p", { children: errors.externalId.message })
    ] }),
    /* @__PURE__ */ jsxs44("div", { children: [
      /* @__PURE__ */ jsx60("label", { children: "Is Active" }),
      /* @__PURE__ */ jsx60(
        FormInput4,
        {
          type: "checkbox",
          placeholder: " Is Active ",
          defaultValue: true.toString(),
          name: "isActive",
          required: true,
          register
        }
      ),
      errors.isActive && /* @__PURE__ */ jsx60("p", { children: errors.isActive.message })
    ] }),
    /* @__PURE__ */ jsxs44("div", { children: [
      /* @__PURE__ */ jsx60("label", { children: "Integration Type" }),
      /* @__PURE__ */ jsx60(
        SelectMenu6,
        {
          title: "Integration Type",
          items: IntegrationTypesList,
          onChange: (item) => {
            const integrationType = parseIntegrationTypes(
              item.id
            );
            setValue("integrationType", integrationType, {
              shouldValidate: true
            });
          },
          value: null
        }
      )
    ] }),
    /* @__PURE__ */ jsx60("div", { className: "mx-4", children: /* @__PURE__ */ jsx60(ButtonList11, { children: /* @__PURE__ */ jsx60(Button24, { disabled: !isValid, color: "primary", type: "submit", children: "Create" }) }) })
  ] }) }) });
};

// src/logging/components/__generated__/EventLogItem_eventLogItem.graphql.ts
var node62 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventLogItem_eventLogItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventLogSourceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventLogType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventLogTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventLogLevel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventLogMessage",
      "storageKey": null
    }
  ],
  "type": "IntegrationEventLogItem",
  "abstractKey": null
};
node62.hash = "be52ba4b0abfaa59a73ece5c0a1e99af";
var EventLogItem_eventLogItem_graphql_default = node62;

// src/logging/components/EventLogItem.tsx
import { Fragment as Fragment9 } from "react";
import { useFragment as useFragment17 } from "react-relay";
import {
  AuditFields as AuditFields6,
  DescriptionItem as DescriptionItem6,
  DescriptionList as DescriptionList6,
  LinkButton as LinkButton12
} from "shared-ui";
import { jsx as jsx61, jsxs as jsxs45 } from "react/jsx-runtime";
var fragment19 = EventLogItem_eventLogItem_graphql_default;
var EventLogItem = ({
  eventLogItem,
  onBack
}) => {
  const data = useFragment17(fragment19, eventLogItem);
  return /* @__PURE__ */ jsx61("div", { children: /* @__PURE__ */ jsx61("div", { className: "flex", children: /* @__PURE__ */ jsx61(
    DescriptionList6,
    {
      classes: "w-full",
      heading: /* @__PURE__ */ jsxs45("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ jsx61("span", { className: "text-info-600", children: "User Event Log" }),
        /* @__PURE__ */ jsx61(LinkButton12, { label: "Back", clicked: onBack })
      ] }),
      description: /* @__PURE__ */ jsx61("div", { className: "mt-4", children: /* @__PURE__ */ jsx61(AuditFields6, { createdOn: data.createdOn }) }),
      items: /* @__PURE__ */ jsxs45(Fragment9, { children: [
        /* @__PURE__ */ jsx61(DescriptionItem6, { label: "Type", children: data.eventLogType }),
        /* @__PURE__ */ jsx61(DescriptionItem6, { label: "Level", children: data.eventLogLevel }),
        /* @__PURE__ */ jsx61(DescriptionItem6, { label: "Title", children: data.eventLogTitle }),
        /* @__PURE__ */ jsxs45("div", { className: "py-4 sm:px-6 sm:py-5", children: [
          /* @__PURE__ */ jsx61("div", { className: "pb-2 text-sm font-medium text-gray-600", children: "Message" }),
          /* @__PURE__ */ jsx61("div", { className: "prose mt-2 rounded-md border bg-gray-100 p-2 text-gray-900", children: data.eventLogMessage })
        ] })
      ] })
    }
  ) }) });
};

// src/logging/components/__generated__/EventLogListPaginationQuery.graphql.ts
var node63 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ], v1 = {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  }, v2 = {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }, v3 = [
    v1,
    v2,
    {
      "kind": "Literal",
      "name": "order",
      "value": [
        {
          "CreatedOn": "DESC"
        }
      ]
    },
    {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    },
    {
      "kind": "Variable",
      "name": "where",
      "variableName": "where"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "EventLogListPaginationQuery",
      "selections": [
        {
          "args": [
            v1,
            v2
          ],
          "kind": "FragmentSpread",
          "name": "EventLogList_eventLogItems"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "EventLogListPaginationQuery",
      "selections": [
        {
          "alias": null,
          "args": v3,
          "concreteType": "IntegrationEventLogItemsConnection",
          "kind": "LinkedField",
          "name": "integrationEventLogItems",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationEventLogItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationEventLogItem",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdOn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventLogSourceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventLogType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventLogTitle",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventLogLevel",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "eventLogMessage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v3,
          "filters": [],
          "handle": "connection",
          "key": "EventLogList_integrationEventLogItems",
          "kind": "LinkedHandle",
          "name": "integrationEventLogItems"
        }
      ]
    },
    "params": {
      "cacheID": "b0bfa9e64723391b1d9fb514aafda0cb",
      "id": null,
      "metadata": {},
      "name": "EventLogListPaginationQuery",
      "operationKind": "query",
      "text": "query EventLogListPaginationQuery(\n  $after: String\n  $first: Int = 10\n  $tenantId: UUID!\n  $where: IntegrationEventLogItemFilter\n) {\n  ...EventLogList_eventLogItems_2HEEH6\n}\n\nfragment EventLogList_eventLogItems_2HEEH6 on Query {\n  integrationEventLogItems(tenantId: $tenantId, first: $first, after: $after, order: [{CreatedOn: DESC}], where: $where) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        createdOn\n        ...EventLogRow_eventLogItem\n        __typename\n      }\n    }\n  }\n}\n\nfragment EventLogRow_eventLogItem on IntegrationEventLogItem {\n  id\n  createdOn\n  eventLogSourceId\n  eventLogType\n  eventLogTitle\n  eventLogLevel\n  eventLogMessage\n}\n"
    }
  };
}();
node63.hash = "67341e39759cf83e3ee7a22f4f2356ad";
var EventLogListPaginationQuery_graphql_default = node63;

// src/logging/components/__generated__/EventLogList_eventLogItems.graphql.ts
var node64 = function() {
  var v0 = [
    "integrationEventLogItems"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      },
      {
        "kind": "RootArgument",
        "name": "tenantId"
      },
      {
        "kind": "RootArgument",
        "name": "where"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": EventLogListPaginationQuery_graphql_default
      }
    },
    "name": "EventLogList_eventLogItems",
    "selections": [
      {
        "alias": "integrationEventLogItems",
        "args": null,
        "concreteType": "IntegrationEventLogItemsConnection",
        "kind": "LinkedField",
        "name": "__EventLogList_integrationEventLogItems_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationEventLogItemsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationEventLogItem",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdOn",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EventLogRow_eventLogItem"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node64.hash = "67341e39759cf83e3ee7a22f4f2356ad";
var EventLogList_eventLogItems_graphql_default = node64;

// src/logging/components/EventLogList.tsx
import { useCallback as useCallback50 } from "react";
import { usePaginationFragment as usePaginationFragment10 } from "react-relay";
import { EdListHeader as EdListHeader10, EdTable as EdTable13 } from "shared-ui";

// src/logging/components/__generated__/EventLogRow_eventLogItem.graphql.ts
var node65 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventLogRow_eventLogItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventLogSourceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventLogType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventLogTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventLogLevel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventLogMessage",
      "storageKey": null
    }
  ],
  "type": "IntegrationEventLogItem",
  "abstractKey": null
};
node65.hash = "46eed3ad4fbd0f0842b6be38cec5b7a6";
var EventLogRow_eventLogItem_graphql_default = node65;

// src/logging/components/EventLogRow.tsx
import { useCallback as useCallback49 } from "react";
import { useFragment as useFragment18 } from "react-relay";
import { EdActionCell as EdActionCell9, EdColumnCell as EdColumnCell12, EdRow as EdRow12, LinkButton as LinkButton13 } from "shared-ui";
import { parseDate as parseDate3, timeAgo as timeAgo4 } from "shared-lib";
import { jsx as jsx62, jsxs as jsxs46 } from "react/jsx-runtime";
var fragment20 = EventLogRow_eventLogItem_graphql_default;
var EventLogRow = (props) => {
  const data = useFragment18(fragment20, props.eventLogItem);
  const select = useCallback49(() => {
    props.selected(data);
  }, []);
  return /* @__PURE__ */ jsxs46(EdRow12, { clicked: select, rowKey: data.id, children: [
    /* @__PURE__ */ jsx62(EdColumnCell12, { children: timeAgo4(parseDate3(data.createdOn)) }),
    /* @__PURE__ */ jsx62(EdColumnCell12, { children: data.eventLogType }),
    /* @__PURE__ */ jsx62(EdColumnCell12, { children: data.eventLogTitle }),
    /* @__PURE__ */ jsx62(EdColumnCell12, { children: data.eventLogLevel }),
    /* @__PURE__ */ jsx62(EdColumnCell12, { children: data.eventLogMessage }),
    /* @__PURE__ */ jsx62(EdActionCell9, { children: /* @__PURE__ */ jsx62(LinkButton13, { label: "Select", clicked: select }) })
  ] });
};
var EventLogRow_default = EventLogRow;

// src/logging/components/EventLogList.tsx
import { jsx as jsx63, jsxs as jsxs47 } from "react/jsx-runtime";
var columns11 = [
  { id: "created", name: "Created" },
  { id: "type", name: "Type" },
  { id: "title", name: "Title" },
  { id: "level", name: "Level" },
  { id: "message", name: "Message" }
];
var fragment21 = EventLogList_eventLogItems_graphql_default;
var EventLogList = ({
  onSelect,
  eventLogItemsKey
}) => {
  const select = useCallback50((e) => {
    onSelect({
      id: e.id
    });
  }, []);
  const paging = usePaginationFragment10(fragment21, eventLogItemsKey);
  const { data } = paging;
  const { integrationEventLogItems } = data;
  const rows = integrationEventLogItems?.edges?.map((e) => {
    return /* @__PURE__ */ jsx63(EventLogRow_default, { eventLogItem: e.node, selected: select }, e.node.id);
  });
  return /* @__PURE__ */ jsxs47("div", { children: [
    /* @__PURE__ */ jsx63(EdListHeader10, { paging }),
    /* @__PURE__ */ jsx63("div", { className: "flex", children: /* @__PURE__ */ jsx63("div", { className: "w-full", children: /* @__PURE__ */ jsx63(EdTable13, { defaultColumns: columns11, rows }) }) })
  ] });
};

// src/matrix/components/about/MatrixLogo.tsx
import { jsx as jsx64 } from "react/jsx-runtime";
var logo = "https://www.matrix-scm.com/hs-fs/hubfs/MatrixSCM_November2019/Images/matrix-scm-logo-png.png?width=1334&name=matrix-scm-logo-png.png";
var MatrixLogo = ({ width, height }) => /* @__PURE__ */ jsx64(
  "img",
  {
    src: logo,
    alt: "Matrix Scm",
    width: width ? width : "1em ",
    height: height ? height : "1em "
  }
);

// src/workflow/components/workflow-definitions/__generated__/IntegrationWorkflowDefinitionDetail_integrationWorkflowDefinition.graphql.ts
var node66 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IntegrationWorkflowDefinitionDetail_integrationWorkflowDefinition",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "channel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLatest",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPublished",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSingleton",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tag",
      "storageKey": null
    }
  ],
  "type": "IntegrationWorkflowDefinition",
  "abstractKey": null
};
node66.hash = "beb78f3a85fc0ae9d3e95e407ae80fef";
var IntegrationWorkflowDefinitionDetail_integrationWorkflowDefinition_graphql_default = node66;

// src/workflow/components/workflow-definitions/IntegrationWorkflowDefinitionDetail.tsx
import { useFragment as useFragment19 } from "react-relay";
import { useToggle as useToggle8 } from "shared-lib";
import { HtmlDisplay as HtmlDisplay2, LinkButton as LinkButton14, PageHeading } from "shared-ui";
import { jsx as jsx65, jsxs as jsxs48 } from "react/jsx-runtime";
var fragment22 = IntegrationWorkflowDefinitionDetail_integrationWorkflowDefinition_graphql_default;
var IntegrationWorkflowDefinitionDetail = ({
  definition
}) => {
  const data = useFragment19(
    fragment22,
    definition
  );
  const [showDescription, toggleDescription] = useToggle8();
  return /* @__PURE__ */ jsxs48("div", { className: "p-2 sm:rounded-md", children: [
    /* @__PURE__ */ jsxs48("div", { className: "flex items-center justify-between border-b p-2", children: [
      /* @__PURE__ */ jsx65(PageHeading, { children: data.name }),
      /* @__PURE__ */ jsx65("div", { children: /* @__PURE__ */ jsxs48(LinkButton14, { clicked: toggleDescription, children: [
        showDescription && /* @__PURE__ */ jsx65("span", { children: "Hide Description" }),
        !showDescription && /* @__PURE__ */ jsx65("span", { children: "View Description" })
      ] }) })
    ] }),
    showDescription && /* @__PURE__ */ jsx65("div", { className: "prose-xl mt-4 border bg-white p-2", children: /* @__PURE__ */ jsx65(HtmlDisplay2, { html: data.description }) })
  ] });
};
var IntegrationWorkflowDefinitionDetail_default = IntegrationWorkflowDefinitionDetail;

// src/workflow/components/workflow-definitions/__generated__/IntegrationWorkflowDefinitionRow_integrationWorkflowDefinition.graphql.ts
var node67 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IntegrationWorkflowDefinitionRow_integrationWorkflowDefinition",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "channel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLatest",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPublished",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSingleton",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tag",
      "storageKey": null
    }
  ],
  "type": "IntegrationWorkflowDefinition",
  "abstractKey": null
};
node67.hash = "4e5057439c5beabee340204cc5e5a1a9";
var IntegrationWorkflowDefinitionRow_integrationWorkflowDefinition_graphql_default = node67;

// src/workflow/components/workflow-definitions/IntegrationWorkflowDefinitionRow.tsx
import { useCallback as useCallback51 } from "react";
import { useFragment as useFragment20 } from "react-relay";
import { EdActionCell as EdActionCell10, EdColumnCell as EdColumnCell13, EdRow as EdRow13, LinkButton as LinkButton15 } from "shared-ui";
import { jsx as jsx66, jsxs as jsxs49 } from "react/jsx-runtime";
var bullhornJobOrder2 = IntegrationWorkflowDefinitionRow_integrationWorkflowDefinition_graphql_default;
var IntegrationWorkflowDefinitionRow = (props) => {
  const data = useFragment20(bullhornJobOrder2, props.definition);
  const select = useCallback51(() => {
    props.selected(data);
  }, []);
  return /* @__PURE__ */ jsxs49(EdRow13, { clicked: select, rowKey: data.id, children: [
    /* @__PURE__ */ jsx66(EdColumnCell13, { children: data.name }),
    /* @__PURE__ */ jsx66(EdColumnCell13, { children: data.version }),
    /* @__PURE__ */ jsx66(EdColumnCell13, { children: data.displayName }),
    /* @__PURE__ */ jsx66(EdColumnCell13, { children: data.isLatest }),
    /* @__PURE__ */ jsx66(EdColumnCell13, { children: data.isPublished }),
    /* @__PURE__ */ jsx66(EdColumnCell13, { children: data.isSingleton }),
    /* @__PURE__ */ jsx66(EdColumnCell13, { children: data.channel }),
    /* @__PURE__ */ jsx66(EdColumnCell13, { children: data.tag }),
    /* @__PURE__ */ jsx66(EdActionCell10, { children: /* @__PURE__ */ jsx66(LinkButton15, { label: "Select", clicked: select }) })
  ] });
};
var IntegrationWorkflowDefinitionRow_default = IntegrationWorkflowDefinitionRow;

// src/workflow/components/workflow-definitions/__generated__/IntegrationWorkflowDefinitionTableQuery.graphql.ts
var node68 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "IntegrationWorkflowDefinitionTableQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "IntegrationWorkflowDefinitionTable_integrationWorkflowDefinitions"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "IntegrationWorkflowDefinitionTableQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "IntegrationWorkflowDefinitionsConnection",
          "kind": "LinkedField",
          "name": "integrationWorkflowDefinitions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationWorkflowDefinitionsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationWorkflowDefinition",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "displayName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "description",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "channel",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isLatest",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isPublished",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isSingleton",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tag",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "IntegrationWorkflowDefinitionTable_integrationWorkflowDefinitions",
          "kind": "LinkedHandle",
          "name": "integrationWorkflowDefinitions"
        }
      ]
    },
    "params": {
      "cacheID": "77a15dd3f370caf874a2b661bf283af7",
      "id": null,
      "metadata": {},
      "name": "IntegrationWorkflowDefinitionTableQuery",
      "operationKind": "query",
      "text": "query IntegrationWorkflowDefinitionTableQuery(\n  $after: String\n  $first: Int = 10\n) {\n  ...IntegrationWorkflowDefinitionTable_integrationWorkflowDefinitions_2HEEH6\n}\n\nfragment IntegrationWorkflowDefinitionRow_integrationWorkflowDefinition on IntegrationWorkflowDefinition {\n  id\n  name\n  version\n  displayName\n  description\n  channel\n  isLatest\n  isPublished\n  isSingleton\n  tag\n}\n\nfragment IntegrationWorkflowDefinitionTable_integrationWorkflowDefinitions_2HEEH6 on Query {\n  integrationWorkflowDefinitions(first: $first, after: $after) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        name\n        version\n        displayName\n        description\n        channel\n        isLatest\n        isPublished\n        isSingleton\n        tag\n        ...IntegrationWorkflowDefinitionRow_integrationWorkflowDefinition\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node68.hash = "a7e161e80d134501c8f74350ab29c21f";
var IntegrationWorkflowDefinitionTableQuery_graphql_default = node68;

// src/workflow/components/workflow-definitions/__generated__/IntegrationWorkflowDefinitionTable_integrationWorkflowDefinitions.graphql.ts
var node69 = function() {
  var v0 = [
    "integrationWorkflowDefinitions"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": IntegrationWorkflowDefinitionTableQuery_graphql_default
      }
    },
    "name": "IntegrationWorkflowDefinitionTable_integrationWorkflowDefinitions",
    "selections": [
      {
        "alias": "integrationWorkflowDefinitions",
        "args": null,
        "concreteType": "IntegrationWorkflowDefinitionsConnection",
        "kind": "LinkedField",
        "name": "__IntegrationWorkflowDefinitionTable_integrationWorkflowDefinitions_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationWorkflowDefinitionsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationWorkflowDefinition",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "version",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "channel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isLatest",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isPublished",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSingleton",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tag",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "IntegrationWorkflowDefinitionRow_integrationWorkflowDefinition"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node69.hash = "a7e161e80d134501c8f74350ab29c21f";
var IntegrationWorkflowDefinitionTable_integrationWorkflowDefinitions_graphql_default = node69;

// src/workflow/components/workflow-definitions/IntegrationWorkflowDefinitionTable.tsx
import { useCallback as useCallback52 } from "react";
import { usePaginationFragment as usePaginationFragment11 } from "react-relay";
import { EdListHeader as EdListHeader11, EdTable as EdTable14 } from "shared-ui";
import { jsx as jsx67, jsxs as jsxs50 } from "react/jsx-runtime";
var columns12 = [
  { id: "name", name: "Name" },
  { id: "version", name: "Version" },
  { id: "displayName", name: "DisplayName" },
  { id: "latest", name: "Latest" },
  { id: "published", name: "Published" },
  { id: "singleton", name: "Singleton" },
  { id: "channel", name: "Channel" },
  { id: "tag", name: "Tag" }
];
var fragment23 = IntegrationWorkflowDefinitionTable_integrationWorkflowDefinitions_graphql_default;
var IntegrationWorkflowDefinitionTable = ({
  onSelect,
  workflowDefinitionsKey
}) => {
  const select = useCallback52((event) => {
    onSelect(event);
  }, []);
  const paging = usePaginationFragment11(fragment23, workflowDefinitionsKey);
  const { data } = paging;
  const rows = data.integrationWorkflowDefinitions?.edges?.map((e) => {
    return /* @__PURE__ */ jsx67(
      IntegrationWorkflowDefinitionRow_default,
      {
        definition: e.node,
        selected: select
      },
      e.node.id
    );
  });
  return /* @__PURE__ */ jsxs50("div", { children: [
    /* @__PURE__ */ jsx67(
      EdListHeader11,
      {
        total: data.integrationWorkflowDefinitions?.totalCount,
        paging
      }
    ),
    /* @__PURE__ */ jsx67("div", { className: "flex", children: /* @__PURE__ */ jsx67("div", { className: "w-full", children: /* @__PURE__ */ jsx67(EdTable14, { defaultColumns: columns12, rows }) }) })
  ] });
};
var IntegrationWorkflowDefinitionTable_default = IntegrationWorkflowDefinitionTable;

// src/workflow/components/workflow-instances/__generated__/IntegrationWorkflowInstanceDetail_integrationWorkflowInstance.graphql.ts
var node70 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IntegrationWorkflowInstanceDetail_integrationWorkflowInstance",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "definitionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cancelledAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "faultedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "finishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastExecutedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contextId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contextType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "correlationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastExecutedActivityId",
      "storageKey": null
    }
  ],
  "type": "IntegrationWorkflowInstance",
  "abstractKey": null
};
node70.hash = "b45245a08bc6f2dbac42a6048436d76b";
var IntegrationWorkflowInstanceDetail_integrationWorkflowInstance_graphql_default = node70;

// src/workflow/components/workflow-instances/IntegrationWorkflowInstanceDetail.tsx
import { useFragment as useFragment21 } from "react-relay";
import { PageHeading as PageHeading2 } from "shared-ui";
import { jsx as jsx68 } from "react/jsx-runtime";
var fragment24 = IntegrationWorkflowInstanceDetail_integrationWorkflowInstance_graphql_default;
var IntegrationWorkflowInstanceDetail = ({
  instance
}) => {
  const data = useFragment21(
    fragment24,
    instance
  );
  return /* @__PURE__ */ jsx68("div", { className: "p-2 sm:rounded-md", children: /* @__PURE__ */ jsx68("div", { className: "flex items-center justify-between border-b p-2", children: /* @__PURE__ */ jsx68(PageHeading2, { children: data.name }) }) });
};
var IntegrationWorkflowInstanceDetail_default = IntegrationWorkflowInstanceDetail;

// src/workflow/components/workflow-instances/__generated__/IntegrationWorkflowInstanceRow_integrationWorkflowInstance.graphql.ts
var node71 = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IntegrationWorkflowInstanceRow_integrationWorkflowInstance",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "definitionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cancelledAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "faultedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "finishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastExecutedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contextId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contextType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "correlationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastExecutedActivityId",
      "storageKey": null
    }
  ],
  "type": "IntegrationWorkflowInstance",
  "abstractKey": null
};
node71.hash = "e56f52306504a55595c574d3e3f776cd";
var IntegrationWorkflowInstanceRow_integrationWorkflowInstance_graphql_default = node71;

// src/workflow/components/workflow-instances/IntegrationWorkflowInstanceRow.tsx
import { useCallback as useCallback53 } from "react";
import { useFragment as useFragment22 } from "react-relay";
import { EdActionCell as EdActionCell11, EdColumnCell as EdColumnCell14, EdRow as EdRow14, LinkButton as LinkButton16 } from "shared-ui";
import { jsx as jsx69, jsxs as jsxs51 } from "react/jsx-runtime";
var bullhornJobOrder3 = IntegrationWorkflowInstanceRow_integrationWorkflowInstance_graphql_default;
var IntegrationWorkflowInstanceRow = (props) => {
  const data = useFragment22(bullhornJobOrder3, props.instance);
  const select = useCallback53(() => {
    props.selected(data);
  }, []);
  return /* @__PURE__ */ jsxs51(EdRow14, { clicked: select, rowKey: data.id, children: [
    /* @__PURE__ */ jsx69(EdColumnCell14, { children: data.name }),
    /* @__PURE__ */ jsx69(EdColumnCell14, { children: data.version }),
    /* @__PURE__ */ jsx69(EdColumnCell14, { children: data.definitionId }),
    /* @__PURE__ */ jsx69(EdColumnCell14, { children: data.createdAt }),
    /* @__PURE__ */ jsx69(EdColumnCell14, { children: data.cancelledAt }),
    /* @__PURE__ */ jsx69(EdColumnCell14, { children: data.faultedAt }),
    /* @__PURE__ */ jsx69(EdColumnCell14, { children: data.finishedAt }),
    /* @__PURE__ */ jsx69(EdColumnCell14, { children: data.lastExecutedAt }),
    /* @__PURE__ */ jsx69(EdColumnCell14, { children: data.contextId }),
    /* @__PURE__ */ jsx69(EdColumnCell14, { children: data.contextType }),
    /* @__PURE__ */ jsx69(EdColumnCell14, { children: data.correlationId }),
    /* @__PURE__ */ jsx69(EdColumnCell14, { children: data.lastExecutedActivityId }),
    /* @__PURE__ */ jsx69(EdActionCell11, { children: /* @__PURE__ */ jsx69(LinkButton16, { label: "Select", clicked: select }) })
  ] });
};
var IntegrationWorkflowInstanceRow_default = IntegrationWorkflowInstanceRow;

// src/workflow/components/workflow-instances/__generated__/IntegrationWorkflowInstanceTableQuery.graphql.ts
var node72 = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    }
  ], v1 = [
    {
      "kind": "Variable",
      "name": "after",
      "variableName": "after"
    },
    {
      "kind": "Variable",
      "name": "first",
      "variableName": "first"
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "IntegrationWorkflowInstanceTableQuery",
      "selections": [
        {
          "args": v1,
          "kind": "FragmentSpread",
          "name": "IntegrationWorkflowInstanceTable_integrationWorkflowInstances"
        }
      ],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "IntegrationWorkflowInstanceTableQuery",
      "selections": [
        {
          "alias": null,
          "args": v1,
          "concreteType": "IntegrationWorkflowInstancesConnection",
          "kind": "LinkedField",
          "name": "integrationWorkflowInstances",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationWorkflowInstancesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationWorkflowInstance",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "version",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cancelledAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "faultedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "finishedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastExecutedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contextId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contextType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "correlationId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastExecutedActivityId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "definitionId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": v1,
          "filters": [],
          "handle": "connection",
          "key": "IntegrationWorkflowInstanceTable_integrationWorkflowInstances",
          "kind": "LinkedHandle",
          "name": "integrationWorkflowInstances"
        }
      ]
    },
    "params": {
      "cacheID": "fee226c38aface86155d8fb3f3e72de2",
      "id": null,
      "metadata": {},
      "name": "IntegrationWorkflowInstanceTableQuery",
      "operationKind": "query",
      "text": "query IntegrationWorkflowInstanceTableQuery(\n  $after: String\n  $first: Int = 10\n) {\n  ...IntegrationWorkflowInstanceTable_integrationWorkflowInstances_2HEEH6\n}\n\nfragment IntegrationWorkflowInstanceRow_integrationWorkflowInstance on IntegrationWorkflowInstance {\n  id\n  name\n  version\n  definitionId\n  createdAt\n  cancelledAt\n  faultedAt\n  finishedAt\n  lastExecutedAt\n  contextId\n  contextType\n  correlationId\n  lastExecutedActivityId\n}\n\nfragment IntegrationWorkflowInstanceTable_integrationWorkflowInstances_2HEEH6 on Query {\n  integrationWorkflowInstances(first: $first, after: $after) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        name\n        version\n        createdAt\n        cancelledAt\n        faultedAt\n        finishedAt\n        lastExecutedAt\n        contextId\n        contextType\n        correlationId\n        lastExecutedActivityId\n        ...IntegrationWorkflowInstanceRow_integrationWorkflowInstance\n        __typename\n      }\n    }\n  }\n}\n"
    }
  };
}();
node72.hash = "b28f3d735cd76fabe8534771d6d21850";
var IntegrationWorkflowInstanceTableQuery_graphql_default = node72;

// src/workflow/components/workflow-instances/__generated__/IntegrationWorkflowInstanceTable_integrationWorkflowInstances.graphql.ts
var node73 = function() {
  var v0 = [
    "integrationWorkflowInstances"
  ];
  return {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
      },
      {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
      }
    ],
    "kind": "Fragment",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": v0
        }
      ],
      "refetch": {
        "connection": {
          "forward": {
            "count": "first",
            "cursor": "after"
          },
          "backward": null,
          "path": v0
        },
        "fragmentPathInResult": [],
        "operation": IntegrationWorkflowInstanceTableQuery_graphql_default
      }
    },
    "name": "IntegrationWorkflowInstanceTable_integrationWorkflowInstances",
    "selections": [
      {
        "alias": "integrationWorkflowInstances",
        "args": null,
        "concreteType": "IntegrationWorkflowInstancesConnection",
        "kind": "LinkedField",
        "name": "__IntegrationWorkflowInstanceTable_integrationWorkflowInstances_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationWorkflowInstancesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationWorkflowInstance",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "version",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cancelledAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "faultedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "finishedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastExecutedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contextId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contextType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "correlationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastExecutedActivityId",
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "IntegrationWorkflowInstanceRow_integrationWorkflowInstance"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  };
}();
node73.hash = "b28f3d735cd76fabe8534771d6d21850";
var IntegrationWorkflowInstanceTable_integrationWorkflowInstances_graphql_default = node73;

// src/workflow/components/workflow-instances/IntegrationWorkflowInstanceTable.tsx
import { useCallback as useCallback54 } from "react";
import { usePaginationFragment as usePaginationFragment12 } from "react-relay";
import { EdListHeader as EdListHeader12, EdTable as EdTable15 } from "shared-ui";
import { jsx as jsx70, jsxs as jsxs52 } from "react/jsx-runtime";
var columns13 = [
  { id: "name", name: "Name" },
  { id: "version", name: "Version" },
  { id: "displayName", name: "DisplayName" },
  { id: "latest", name: "Latest" },
  { id: "published", name: "Published" },
  { id: "singleton", name: "Singleton" },
  { id: "channel", name: "Channel" },
  { id: "tag", name: "Tag" }
];
var fragment25 = IntegrationWorkflowInstanceTable_integrationWorkflowInstances_graphql_default;
var IntegrationWorkflowInstanceTable = ({
  onSelect,
  workflowInstancesKey
}) => {
  const select = useCallback54((event) => {
    onSelect(event);
  }, []);
  const paging = usePaginationFragment12(fragment25, workflowInstancesKey);
  const { data } = paging;
  const { integrationWorkflowInstances } = data;
  const rows = integrationWorkflowInstances?.edges?.map((e) => {
    return /* @__PURE__ */ jsx70(
      IntegrationWorkflowInstanceRow_default,
      {
        instance: e.node,
        selected: select
      },
      e.node.id
    );
  });
  return /* @__PURE__ */ jsxs52("div", { children: [
    /* @__PURE__ */ jsx70(EdListHeader12, { paging }),
    /* @__PURE__ */ jsx70("div", { className: "flex", children: /* @__PURE__ */ jsx70("div", { className: "w-full", children: /* @__PURE__ */ jsx70(EdTable15, { defaultColumns: columns13, rows }) }) })
  ] });
};
var IntegrationWorkflowInstanceTable_default = IntegrationWorkflowInstanceTable;
export {
  AllEntityEventTypes,
  BullhornCandidateDetail_default as BullhornCandidateDetail,
  BullhornCandidateEntity,
  BullhornCandidateRow_default as BullhornCandidateRow,
  BullhornCandidatesList_default as BullhornCandidatesList,
  BullhornChangeJobOrderWorkflowConfigurationMutation_default as BullhornChangeJobOrderWorkflowConfigurationMutation,
  BullhornEntities,
  BullhornEventRow_default as BullhornEventRow,
  BullhornEventsList_default as BullhornEventsList,
  BullhornJobOrderDetail_default as BullhornJobOrderDetail,
  BullhornJobOrderEntity,
  BullhornJobOrderJobSubmissionsList_default as BullhornJobOrderJobSubmissionsList,
  BullhornJobOrderList_default as BullhornJobOrderList,
  BullhornJobOrderRow_default as BullhornJobOrderRow,
  BullhornJobOrderTabs_default as BullhornJobOrderTabs,
  BullhornJobSubmissionDetail_default as BullhornJobSubmissionDetail,
  BullhornJobSubmissionEntity,
  BullhornJobSubmissionList_default as BullhornJobSubmissionList,
  BullhornJobSubmissionRow_default as BullhornJobSubmissionRow,
  BullhornJobSubmissionsByJobOrderList_default as BullhornJobSubmissionsByJobOrderList,
  BullhornLogo,
  BullhornRefreshVaultCandidateButton,
  BullhornReplaceTalentPoolCandidateButton,
  BullhornSyncCandidateElevateButton,
  BullhornSystem,
  BullhornTenantConfig_default as BullhornTenantConfig,
  BullhornTenantDetail_default as BullhornTenantDetail,
  BullhornTenantList_default as BullhornTenantList,
  BullhornTenantRow_default as BullhornTenantRow,
  BullhornUploadCandidateResumeButton,
  CreateFieldMappingConfigMutation_default as CreateFieldMappingConfigMutation,
  CreateFieldMappingFieldForm,
  CreateJobSubmissionsButton,
  CreateJobSubmissionsMutation_default as CreateJobSubmissionsMutation,
  ElevateApplicationEntity,
  ElevateEntities,
  ElevateProfileEntity,
  ElevateSystem,
  ElevateVacancyEntity,
  EmployerMappingEditForm,
  EmployerMappingList,
  EmployerMappingNewForm,
  EntityEventTypes,
  EventLogItem,
  EventLogItemLevelList,
  EventLogItemTypesList,
  EventLogList,
  EventLogRow,
  FetchJobOrderButton,
  FetchJobOrderMutation_default as FetchJobOrderMutation,
  FieldMappingConfigurationCreateForm,
  FieldMappingConfigurationDetail_default as FieldMappingConfigurationDetail,
  FieldMappingConfigurationEditForm,
  FieldMappingConfigurationFieldsForm,
  FieldMappingConfigurationList_default as FieldMappingConfigurationList,
  FieldMappingConfigurationRow_default as FieldMappingConfigurationRow,
  FieldMappingEditor,
  FieldMappingFieldsList,
  FieldMappingSelector_default as FieldMappingSelector,
  IntegrationEntityMap,
  IntegrationSystems,
  IntegrationWorkflowDefinitionDetail_default as IntegrationWorkflowDefinitionDetail,
  IntegrationWorkflowDefinitionRow_default as IntegrationWorkflowDefinitionRow,
  IntegrationWorkflowDefinitionTable_default as IntegrationWorkflowDefinitionTable,
  IntegrationWorkflowInstanceDetail_default as IntegrationWorkflowInstanceDetail,
  IntegrationWorkflowInstanceRow_default as IntegrationWorkflowInstanceRow,
  IntegrationWorkflowInstanceTable_default as IntegrationWorkflowInstanceTable,
  JobOrderDownloadForm,
  MappableDataType,
  MappableProcessorType,
  MatrixLogo,
  ProcessStandardEventMutation_default as ProcessStandardEventMutation,
  RefreshJobOrderButton,
  RefreshJobOrderMutation_default as RefreshJobOrderMutation,
  RefreshVaultCandidateMutation_default as RefreshVaultCandidateMutation,
  ReplaceTalentPoolCandidateMutation_default as ReplaceTalentPoolCandidateMutation,
  SaveFieldMappingConfigMutation_default as SaveFieldMappingConfigMutation,
  SubmitPendingJobSubmissionsButton,
  SubmitPendingJobSubmissionsMutation_default as SubmitPendingJobSubmissionsMutation,
  SyncCandidateMutation_default as SyncCandidateMutation,
  SyncJobOrderButton,
  SyncJobOrderMutation_default as SyncJobOrderMutation,
  SyncJobSubmissionMutation_default as SyncJobSubmissionMutation,
  TenantChangeDefaultMappingConfigurationMutation_default as TenantChangeDefaultMappingConfigurationMutation,
  TenantToggleEnabledMutation_default as TenantToggleEnabledMutation,
  TenantUpdateFetchConfigurationMutation_default as TenantUpdateFetchConfigurationMutation,
  UploadCandidateResumeMutation_default as UploadCandidateResumeMutation,
  VacancyContainer,
  VacancyDetails,
  dataTypes,
  fieldDefinitionToListItem,
  fieldDefinitionsToListItems,
  getDataType,
  hasFieldDefinition,
  hasValueField,
  integrationFieldMappingToListItem,
  integrationFieldMappingsToListItems,
  processTypes
};
//# sourceMappingURL=index.mjs.map